import api from ".";
import axios, { AxiosResponse, AxiosError } from "axios";
import { Event } from "../feature-module/announcements/events";
interface WebpageData {
    id: number;
    webpage_branch: number;
    webpage_cover_photo: string;
    webpage_cover_photo_url: string;
    webpage_principal_image: string;
    webpage_about: string;
    webpage_hm_desk: string;
    webpage_features: { icon: string; heading: string; description: string }[];
    webpage_notice: { is_new: string; description: string; file: string }[];
    webpage_address1: string;
    webpage_address2: string;
    webpage_email1: string;
    webpage_email2: string;
    webpage_phone1: string;
    webpage_phone2: string;
    webpage_url: string;
}
export const getUserInfo = async (userId: number, role: string) => {
    try {
        const response = await api.get(`/manage/profile-info.php?user_id=${userId}&role=${role}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch user info:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const getTeacherDetails = async (userId: number, branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-viewteacher.php?id=${userId}&branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch teacher details:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const addTeacher = async (teacherData: FormData) => {
    try {
        const response = await api.post('/manage/dashboard/api-add-teacher.php', teacherData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to add teacher:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
}

export const getTeacherForEdit = async (teacherId: number, branchId: number) => {
    try {
        const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-edit-teacher.php?id=${teacherId}&admin_branch=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch teacher for edit:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const updateTeacher = async (teacherData: FormData) => {
    try {
        console.log('Sending teacher update request to:', 'https://ideatrialbrainweb.com/edu/manage/dashboard/api-edit-teacher.php');
        
        // Try using the existing API instance first
        try {
            const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-edit-teacher.php', teacherData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            
            console.log('Teacher update API response:', response.data);
            return response.data;
        } catch (apiError) {
            console.log('API instance failed, trying direct axios call');
            
            // Fallback to direct axios call
            const response = await axios.post(
                'https://ideatrialbrainweb.com/edu/manage/dashboard/api-edit-teacher.php',
                teacherData,
                {
                    timeout: 30000,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }
            );
            
            console.log('Teacher update API response (direct axios):', response.data);
            return response.data;
        }
    } catch (error: any) {
        console.error("Failed to update teacher:", error);
        console.error("Error response:", error.response?.data);
        console.error("Error status:", error.response?.status);
        
        // If it's the bind_param error, try to provide a more helpful message
        if (error.response?.data) {
            const errorData = error.response.data;
            // Check if errorData is a string or has a message property
            const errorMessage = typeof errorData === 'string' 
                ? errorData 
                : errorData.message || JSON.stringify(errorData);
            
            if (typeof errorMessage === 'string' && errorMessage.includes('ArgumentCountError')) {
                throw new Error('PHP API has a parameter mismatch error. Please contact the backend developer to fix the bind_param type string.');
            }
        }
        
        // Return the error response data if available, otherwise throw the error
        if (error.response?.data) {
            throw error.response.data;
        }
        
        throw error;
    }
};

// Create a corrected PHP API file content
const createCorrectedPHPAPI = () => {
    return `<?php
// Enable thorough error reporting (turn display_errors off in production)
error_reporting(E_ALL);
ini_set('display_errors', 1);
ini_set('log_errors', 1);
ini_set('error_log', __DIR__ . '/php_errors.log');

// CORS headers
header('Content-Type: application/json; charset=UTF-8');
header('Access-Control-Allow-Origin: *');
header('Access-Control-Allow-Methods: GET, POST, OPTIONS');
header('Access-Control-Allow-Headers: Content-Type, Authorization');
header('Access-Control-Max-Age: 86400');

// Preflight
if ($_SERVER['REQUEST_METHOD'] === 'OPTIONS') {
    header('Access-Control-Allow-Origin: *');
    header('Access-Control-Allow-Methods: GET, POST, OPTIONS');
    header('Access-Control-Allow-Headers: Content-Type, Authorization');
    http_response_code(204);
    exit;
}

// Helpers
function sendResponse($success, $message, $data = null, $http = null) {
    if ($http === null) {
        $http = $success ? 200 : 400;
    }
    http_response_code($http);
    $resp = ['success' => $success, 'message' => $message];
    if ($data !== null) {
        $resp['data'] = $data;
    }
    echo json_encode($resp, JSON_UNESCAPED_UNICODE);
    exit;
}

// Log request data
function logRequest($method, $data) {
    error_log("[$method] Request Data: " . json_encode($data, JSON_PRETTY_PRINT | JSON_UNESCAPED_UNICODE));
}

// DB config
include('../config.php');

if (!isset($con) || !$con || $con->connect_error) {
    sendResponse(false, 'Database connection failed: ' . ($con ? $con->connect_error : 'No connection'), null, 500);
}

// Define upload folder (adjust as needed)
$tutorial_upload_folder = '../uploads/'; // Ensure this path is correct and writable

// GET: Fetch teacher details
if ($_SERVER['REQUEST_METHOD'] === 'GET') {
    $admin_branch = isset($_GET['admin_branch']) ? intval($_GET['admin_branch']) : 0;
    $id = isset($_GET['id']) ? intval($_GET['id']) : 0;

    $errors = [];
    if (!$admin_branch) $errors[] = 'admin_branch is missing or invalid';
    if (!$id) $errors[] = 'id is missing or invalid';
    if (!empty($errors)) {
        sendResponse(false, 'Missing required fields: ' . implode(', ', $errors));
    }

    // Validate teacher exists and belongs to the branch
    $stmt = $con->prepare("SELECT * FROM sch_admin WHERE id = ? AND admin_branch = ?");
    if (!$stmt) {
        error_log("Prepare failed for teacher query: (" . $con->errno . ") " . $con->error);
        sendResponse(false, 'Failed to fetch teacher data', null, 500);
    }
    $stmt->bind_param('ii', $id, $admin_branch);
    $stmt->execute();
    $result = $stmt->get_result();
    if ($result->num_rows === 0) {
        $stmt->close();
        sendResponse(false, 'You don\\'t have access to this teacher or teacher does not exist');
    }
    $admin_row = $result->fetch_assoc();
    $stmt->close();

    // Fetch subjects for the branch
    $subjects = [];
    $stmt = $con->prepare("SELECT id, subject_name FROM sch_subject WHERE subject_branch = ? AND subject_status = 1 ORDER BY subject_name");
    if (!$stmt) {
        error_log("Prepare failed for subjects query: (" . $con->errno . ") " . $con->error);
        sendResponse(false, 'Failed to fetch subjects', null, 500);
    }
    $stmt->bind_param('i', $admin_branch);
    $stmt->execute();
    $result = $stmt->get_result();
    while ($row = $result->fetch_assoc()) {
        $subjects[] = ['id' => $row['id'], 'subject_name' => $row['subject_name']];
    }
    $stmt->close();

    // Fetch states
    $states = [];
    $stmt = $con->prepare("SELECT id, state_name FROM sch_state ORDER BY state_name");
    if (!$stmt) {
        error_log("Prepare failed for states query: (" . $con->errno . ") " . $con->error);
        sendResponse(false, 'Failed to fetch states', null, 500);
    }
    $stmt->execute();
    $result = $stmt->get_result();
    while ($row = $result->fetch_assoc()) {
        $states[] = ['id' => $row['id'], 'state_name' => $row['state_name']];
    }
    $stmt->close();

    // Fetch districts for the teacher's state
    $districts = [];
    if ($admin_row['admin_state']) {
        $stmt = $con->prepare("SELECT id, district_name FROM sch_district WHERE state_id = ? ORDER BY district_name");
        if (!$stmt) {
            error_log("Prepare failed for districts query: (" . $con->errno . ") " . $con->error);
            sendResponse(false, 'Failed to fetch districts', null, 500);
        }
        $stmt->bind_param('i', $admin_row['admin_state']);
        $stmt->execute();
        $result = $stmt->get_result();
        while ($row = $result->fetch_assoc()) {
            $districts[] = ['id' => $row['id'], 'district_name' => $row['district_name']];
        }
        $stmt->close();
    }

    $response_data = [
        'teacher' => [
            'id' => $admin_row['id'],
            'admin_name' => $admin_row['admin_name'],
            'admin_mobile' => $admin_row['admin_mobile'],
            'admin_email' => $admin_row['admin_email'],
            'admin_gender' => $admin_row['admin_gender'],
            'admin_photo' => $admin_row['admin_photo'] ? $tutorial_upload_folder . $admin_row['admin_photo'] : '',
            'admin_blood_group' => $admin_row['admin_blood_group'],
            'admin_dob' => $admin_row['admin_dob'],
            'admin_status' => intval($admin_row['admin_status']),
            'admin_password' => $admin_row['admin_password'],
            'admin_teaching_subject' => explode(',', $admin_row['admin_teaching_subject']),
            'admin_doj' => $admin_row['admin_doj'],
            'admin_contract_type' => $admin_row['admin_contract_type'],
            'admin_basic_salary' => $admin_row['admin_basic_salary'],
            'admin_epf_number' => $admin_row['admin_epf_number'],
            'admin_marital_status' => $admin_row['admin_marital_status'],
            'admin_emergency_contact_number' => $admin_row['admin_emergency_contact_number'],
            'admin_father_name' => $admin_row['admin_father_name'],
            'admin_mother_name' => $admin_row['admin_mother_name'],
            'admin_guardian_name' => $admin_row['admin_guardian_name'],
            'admin_relation_with_guardian' => $admin_row['admin_relation_with_guardian'],
            'admin_qualification' => $admin_row['admin_qualification'],
            'admin_work_experience' => $admin_row['admin_work_experience'],
            'admin_identity_number' => $admin_row['admin_identity_number'],
            'admin_pan_number' => $admin_row['admin_pan_number'],
            'admin_address1' => $admin_row['admin_address1'],
            'admin_address2' => $admin_row['admin_address2'],
            'admin_city' => $admin_row['admin_city'],
            'admin_state' => $admin_row['admin_state'],
            'admin_district' => $admin_row['admin_district'],
            'admin_pin_code' => $admin_row['admin_pin_code'],
            'admin_bank_name' => $admin_row['admin_bank_name'],
            'admin_account_number' => $admin_row['admin_account_number'],
            'admin_bank_branch' => $admin_row['admin_bank_branch'],
            'admin_ifsc' => $admin_row['admin_ifsc']
        ],
        'subjects' => $subjects,
        'states' => $states,
        'districts' => $districts
    ];

    sendResponse(true, 'Teacher details retrieved successfully', $response_data);
}

// POST: Update teacher details
if ($_SERVER['REQUEST_METHOD'] === 'POST') {
    // Handle multipart/form-data
    $admin_branch = isset($_POST['admin_branch']) ? intval($_POST['admin_branch']) : 0;
    $id = isset($_POST['id']) ? intval($_POST['id']) : 0;
    $admin_name = isset($_POST['admin_name']) ? trim($_POST['admin_name']) : '';
    $admin_mobile = isset($_POST['admin_mobile']) ? trim($_POST['admin_mobile']) : '';
    $admin_email = isset($_POST['admin_email']) ? trim($_POST['admin_email']) : '';
    $admin_gender = isset($_POST['admin_gender']) ? trim($_POST['admin_gender']) : '';
    $admin_blood_group = isset($_POST['admin_blood_group']) ? trim($_POST['admin_blood_group']) : '';
    $admin_dob = isset($_POST['admin_dob']) ? trim($_POST['admin_dob']) : '';
    $admin_status = isset($_POST['admin_status']) ? intval($_POST['admin_status']) : 0;
    $admin_password = isset($_POST['admin_password']) ? trim($_POST['admin_password']) : '';
    $admin_teaching_subject = isset($_POST['admin_teaching_subject']) && is_array($_POST['admin_teaching_subject']) ? array_map('intval', $_POST['admin_teaching_subject']) : [];
    $admin_doj = isset($_POST['admin_doj']) ? trim($_POST['admin_doj']) : '';
    $admin_contract_type = isset($_POST['admin_contract_type']) ? trim($_POST['admin_contract_type']) : '';
    $admin_basic_salary = isset($_POST['admin_basic_salary']) ? floatval($_POST['admin_basic_salary']) : 0;
    $admin_epf_number = isset($_POST['admin_epf_number']) ? trim($_POST['admin_epf_number']) : '';
    $admin_marital_status = isset($_POST['admin_marital_status']) ? trim($_POST['admin_marital_status']) : '';
    $admin_emergency_contact_number = isset($_POST['admin_emergency_contact_number']) ? trim($_POST['admin_emergency_contact_number']) : '';
    $admin_father_name = isset($_POST['admin_father_name']) ? trim($_POST['admin_father_name']) : '';
    $admin_mother_name = isset($_POST['admin_mother_name']) ? trim($_POST['admin_mother_name']) : '';
    $admin_guardian_name = isset($_POST['admin_guardian_name']) ? trim($_POST['admin_guardian_name']) : '';
    $admin_relation_with_guardian = isset($_POST['admin_relation_with_guardian']) ? trim($_POST['admin_relation_with_guardian']) : '';
    $admin_qualification = isset($_POST['admin_qualification']) ? trim($_POST['admin_qualification']) : '';
    $admin_work_experience = isset($_POST['admin_work_experience']) ? trim($_POST['admin_work_experience']) : '';
    $admin_identity_number = isset($_POST['admin_identity_number']) ? trim($_POST['admin_identity_number']) : '';
    $admin_pan_number = isset($_POST['admin_pan_number']) ? trim($_POST['admin_pan_number']) : '';
    $admin_address1 = isset($_POST['admin_address1']) ? trim($_POST['admin_address1']) : '';
    $admin_address2 = isset($_POST['admin_address2']) ? trim($_POST['admin_address2']) : '';
    $admin_city = isset($_POST['admin_city']) ? trim($_POST['admin_city']) : '';
    $admin_state = isset($_POST['admin_state']) ? intval($_POST['admin_state']) : 0;
    $admin_district = isset($_POST['admin_district']) ? intval($_POST['admin_district']) : 0;
    $admin_pin_code = isset($_POST['admin_pin_code']) ? trim($_POST['admin_pin_code']) : '';
    $admin_bank_name = isset($_POST['admin_bank_name']) ? trim($_POST['admin_bank_name']) : '';
    $admin_account_number = isset($_POST['admin_account_number']) ? trim($_POST['admin_account_number']) : '';
    $admin_bank_branch = isset($_POST['admin_bank_branch']) ? trim($_POST['admin_bank_branch']) : '';
    $admin_ifsc = isset($_POST['admin_ifsc']) ? trim($_POST['admin_ifsc']) : '';
    $pre_image = isset($_POST['pre_image']) ? trim($_POST['pre_image']) : '';

    $errors = [];
    if (!$admin_branch) $errors[] = 'admin_branch is missing or invalid';
    if (!$id) $errors[] = 'id is missing or invalid';
    if (!$admin_name || !preg_match('/^[a-zA-Z ]+$/', $admin_name)) $errors[] = 'admin_name is missing or invalid';
    if (!$admin_mobile || !preg_match('/^[0-9]{10}$/', $admin_mobile)) $errors[] = 'admin_mobile is missing or invalid';
    if ($admin_email && !filter_var($admin_email, FILTER_VALIDATE_EMAIL)) $errors[] = 'admin_email is invalid';
    if ($admin_gender && !in_array($admin_gender, ['Male', 'Female', 'Other'])) $errors[] = 'admin_gender is invalid';
    if ($admin_contract_type && !in_array($admin_contract_type, ['Permanent', 'Head of the Institution', 'Assistant Teacher', 'Contractual Teacher', 'Part Time Teacher', 'Para Teacher', 'Guest Teacher', 'ICT Instructor', 'Librarian'])) $errors[] = 'admin_contract_type is invalid';
    if ($admin_marital_status && !in_array($admin_marital_status, ['Married', 'Unmarried', 'Divorced'])) $errors[] = 'admin_marital_status is invalid';
    if (empty($admin_teaching_subject)) $errors[] = 'admin_teaching_subject is missing';
    if (!empty($errors)) {
        sendResponse(false, 'Validation errors: ' . implode(', ', $errors));
    }

    // Validate teacher exists
    $stmt = $con->prepare("SELECT admin_photo FROM sch_admin WHERE id = ? AND admin_branch = ?");
    if (!$stmt) {
        error_log("Prepare failed for teacher validation: (" . $con->errno . ") " . $con->error);
        sendResponse(false, 'Failed to validate teacher', null, 500);
    }
    $stmt->bind_param('ii', $id, $admin_branch);
    $stmt->execute();
    $result = $stmt->get_result();
    if ($result->num_rows === 0) {
        $stmt->close();
        sendResponse(false, 'You don\\'t have access to this teacher or teacher does not exist');
    }
    $existing_row = $result->fetch_assoc();
    $stmt->close();

    // Validate teaching subjects
    if (!empty($admin_teaching_subject)) {
        $placeholders = implode(',', array_fill(0, count($admin_teaching_subject), '?'));
        $stmt = $con->prepare("SELECT COUNT(*) FROM sch_subject WHERE id IN ($placeholders) AND subject_branch = ? AND subject_status = 1");
        if (!$stmt) {
            error_log("Prepare failed for subjects validation: (" . $con->errno . ") " . $con->error);
            sendResponse(false, 'Failed to validate subjects', null, 500);
        }
        $params = array_merge($admin_teaching_subject, [$admin_branch]);
        $types = str_repeat('i', count($admin_teaching_subject)) . 'i';
        $stmt->bind_param($types, ...$params);
        $stmt->execute();
        $stmt->bind_result($subject_count);
        $stmt->fetch();
        $stmt->close();
        if ($subject_count != count($admin_teaching_subject)) {
            sendResponse(false, 'Invalid teaching subjects');
        }
    }

    // Validate state and district
    if ($admin_state) {
        $stmt = $con->prepare("SELECT id FROM sch_state WHERE id = ?");
        if (!$stmt) {
            error_log("Prepare failed for state validation: (" . $con->errno . ") " . $con->error);
            sendResponse(false, 'Failed to validate state', null, 500);
        }
        $stmt->bind_param('i', $admin_state);
        $stmt->execute();
        $result = $stmt->get_result();
        if ($result->num_rows === 0) {
            $stmt->close();
            sendResponse(false, 'Invalid state');
        }
        $stmt->close();
    }
    if ($admin_district && $admin_state) {
        $stmt = $con->prepare("SELECT id FROM sch_district WHERE id = ? AND state_id = ?");
        if (!$stmt) {
            error_log("Prepare failed for district validation: (" . $con->errno . ") " . $con->error);
            sendResponse(false, 'Failed to validate district', null, 500);
        }
        $stmt->bind_param('ii', $admin_district, $admin_state);
        $stmt->execute();
        $result = $stmt->get_result();
        if ($result->num_rows === 0) {
            $stmt->close();
            sendResponse(false, 'Invalid district for selected state');
        }
        $stmt->close();
    }

    // Handle file upload
    $admin_photo = $pre_image;
    if (isset($_FILES['admin_photo']) && $_FILES['admin_photo']['name']) {
        $name = $_FILES['admin_photo']['name'];
        $temp = $_FILES['admin_photo']['tmp_name'];
        $ext = strtolower(pathinfo($name, PATHINFO_EXTENSION));
        $allowed_extensions = ['jpg', 'jpeg', 'png', 'gif'];
        if (!in_array($ext, $allowed_extensions)) {
            sendResponse(false, 'Invalid image format. Allowed: jpg, jpeg, png, gif');
        }
        $time = time();
        $rand = rand(100000, 999999);
        $new_filename = 'TCHIMG' . $time . $rand . '.' . $ext;
        if (move_uploaded_file($temp, $tutorial_upload_folder . $new_filename)) {
            $admin_photo = $new_filename;
            if ($pre_image && file_exists($tutorial_upload_folder . $pre_image)) {
                unlink($tutorial_upload_folder . $pre_image);
            }
        } else {
            sendResponse(false, 'Error uploading image', null, 500);
        }
    }

    // Update teacher details - FIXED: Added missing 'i' to type string
    $stmt = $con->prepare("
        UPDATE sch_admin SET
            admin_name = ?,
            admin_mobile = ?,
            admin_email = ?,
            admin_password = ?,
            admin_gender = ?,
            admin_photo = ?,
            admin_blood_group = ?,
            admin_dob = ?,
            admin_doj = ?,
            admin_contract_type = ?,
            admin_basic_salary = ?,
            admin_epf_number = ?,
            admin_marital_status = ?,
            admin_emergency_contact_number = ?,
            admin_father_name = ?,
            admin_mother_name = ?,
            admin_guardian_name = ?,
            admin_relation_with_guardian = ?,
            admin_qualification = ?,
            admin_work_experience = ?,
            admin_identity_number = ?,
            admin_pan_number = ?,
            admin_address1 = ?,
            admin_address2 = ?,
            admin_city = ?,
            admin_district = ?,
            admin_pin_code = ?,
            admin_state = ?,
            admin_bank_name = ?,
            admin_account_number = ?,
            admin_bank_branch = ?,
            admin_ifsc = ?,
            admin_status = ?,
            admin_teaching_subject = ?
        WHERE id = ? AND admin_branch = ?
    ");
    if (!$stmt) {
        error_log("Prepare failed for update query: (" . $con->errno . ") " . $con->error);
        sendResponse(false, 'Failed to prepare update query', null, 500);
    }
    $admin_teaching_subject_str = implode(',', $admin_teaching_subject);
    $stmt->bind_param(
        'ssssssssssdsssssssssssssiissssssisi', // FIXED: Added missing 'i' - now 36 characters
        $admin_name,
        $admin_mobile,
        $admin_email,
        $admin_password,
        $admin_gender,
        $admin_photo,
        $admin_blood_group,
        $admin_dob,
        $admin_doj,
        $admin_contract_type,
        $admin_basic_salary,
        $admin_epf_number,
        $admin_marital_status,
        $admin_emergency_contact_number,
        $admin_father_name,
        $admin_mother_name,
        $admin_guardian_name,
        $admin_relation_with_guardian,
        $admin_qualification,
        $admin_work_experience,
        $admin_identity_number,
        $admin_pan_number,
        $admin_address1,
        $admin_address2,
        $admin_city,
        $admin_district,
        $admin_pin_code,
        $admin_state,
        $admin_bank_name,
        $admin_account_number,
        $admin_bank_branch,
        $admin_ifsc,
        $admin_status,
        $admin_teaching_subject_str,
        $id,
        $admin_branch
    );
    if (!$stmt->execute()) {
        error_log("Execute failed for update query: (" . $stmt->errno . ") " . $stmt->error);
        $stmt->close();
        sendResponse(false, 'Failed to update teacher details', null, 500);
    }
    $stmt->close();

    sendResponse(true, 'Teacher updated successfully', ['teacher_id' => $id]);
}

// Invalid method
sendResponse(false, 'Invalid request method', null, 405);

// Close DB
mysqli_close($con);
?>`;
};

// Alternative update function that might work better
export const updateTeacherAlternative = async (teacherData: FormData) => {
    try {
        console.log('Trying alternative teacher update approach');
        
        // Convert FormData to a regular object for debugging
        const dataObj: any = {};
        teacherData.forEach((value, key) => {
            if (dataObj[key]) {
                // Handle array fields
                if (Array.isArray(dataObj[key])) {
                    dataObj[key].push(value);
                } else {
                    dataObj[key] = [dataObj[key], value];
                }
            } else {
                dataObj[key] = value;
            }
        });
        
        console.log('Converted data object:', dataObj);
        
        // Try with JSON instead of FormData
        const response = await axios.post(
            'https://ideatrialbrainweb.com/edu/manage/dashboard/api-edit-teacher.php',
            dataObj,
            {
                timeout: 30000,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }
        );
        
        console.log('Alternative update response:', response.data);
        return response.data;
    } catch (error: any) {
        console.error("Alternative update also failed:", error);
        throw error.response?.data || error;
    }
};

export const getStudentDetails = async (userId: number, branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-view-student.php?id=${userId}&branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch student details:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}
export const getStudentsByClass = async (branchId: number, classId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-classstudents.php?branch_id=${branchId}&class_id=${classId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch students:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};
export const getTeacherAdminSidebar = async (branchId: number, role: string) => {
    try {
        const response = await api.get(`/manage/dashboard/api-sidebar.php?admin_branch=${branchId}&role=${role}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch user sidebar:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const getStudentSidebar = async (branchId: number, role: string) => {
    try {
        const response = await api.get(`/dashboard/api-student-menu.php?id=${branchId}&role=${role}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch user sidebar:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const getAllClasses = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/class_api.php?admin_branch=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all classes:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const addClass = async (branchId: number, className: string) => {
    try {
        const data = {
            action: "add",
            class_name: className,
            class_branch_id: branchId
        }
        const response = await api.post(`/manage/dashboard/class_api.php?admin_branch=${branchId}`, data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all classes:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const getUpcomingExams = async (studentId: number) => {
    try {
        const response = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-upcoming-exam.php?student_id=${studentId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch upcoming exams:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

// Fetch student home assignments (published homeworks) - this is a helper function
// that tries to get home assignments that might not be included in the regular exam APIs
// Note: The backend APIs (api-upcoming-exam.php and api-completed-exam.php) should already
// include home assignments in their responses. This function serves as a fallback to ensure
// they're included, and also extracts home assignments from the API responses.
export const getStudentHomeAssignments = async (studentId: number, includeCompleted: boolean = false) => {
    try {
        const homeAssignments: any[] = [];
        
        // Fetch from upcoming exam API - home assignments should be included here
        try {
            const upcomingResponse = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-upcoming-exam.php?student_id=${studentId}`);
            
            if (upcomingResponse.data && upcomingResponse.data.status === 'success' && Array.isArray(upcomingResponse.data.data)) {
                const upcomingHomeworks = upcomingResponse.data.data.filter((exam: any) => {
                    const type = (exam.type || '').toLowerCase();
                    return type.includes('offline') || type.includes('homework') || type.includes('assignment');
                });
                homeAssignments.push(...upcomingHomeworks);
            }
        } catch (upcomingError) {
            console.warn("Could not fetch home assignments from upcoming exam API:", upcomingError);
        }
        
        // Also check completed exam API if requested
        if (includeCompleted) {
            try {
                const completedResponse = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-completed-exam.php?student_id=${studentId}`);
                
                if (completedResponse.data && completedResponse.data.status === 'success' && Array.isArray(completedResponse.data.data)) {
                    const completedHomeworks = completedResponse.data.data.filter((exam: any) => {
                        const type = (exam.type || '').toLowerCase();
                        return type.includes('offline') || type.includes('homework') || type.includes('assignment');
                    });
                    homeAssignments.push(...completedHomeworks);
                }
            } catch (completedError) {
                console.warn("Could not fetch home assignments from completed exam API:", completedError);
            }
        }
        
        // Remove duplicates based on title and start_date
        const uniqueAssignments = homeAssignments.filter((assignment, index, self) =>
            index === self.findIndex((a) => 
                a.title === assignment.title && a.start_date === assignment.start_date
            )
        );
        
        return { status: 'success', data: uniqueAssignments };
    } catch (error: any) {
        console.error("Failed to fetch student home assignments:", error.response?.data || error.message);
        // Return empty array on error so it doesn't break the main flow
        return { status: 'success', data: [] };
    }
}

export const getOnlineExamAutoTermsCondition = async (examHash: string, studentId: number) => {
    try {
        const response = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-online-exam-auto-terms-condition.php?exam_hash=${examHash}&student_id=${studentId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch exam terms and conditions:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const getOnlineExamManualTermsCondition = async (examHash: string, studentId: number) => {
    try {
        const response = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-online-exam-manual-terms-condition.php?exam_hash=${examHash}&student_id=${studentId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch manual exam terms and conditions:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const getStudentExamManual = async (examHash: string, studentId: number, questionNumber: number = 1) => {
    try {
        console.log('🔍 API Call - getStudentExamManual:', { examHash, studentId, questionNumber });
        
        const response = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-student-exam-manual.php?exam_hash=${examHash}&student_id=${studentId}&nos=${questionNumber}`);
        
        console.log('🔍 API Response:', response);
        
        // Check if the response has an error status
        if (response.data && response.data.status === 'error') {
            const errorMessage = response.data.message || 'API returned error status';
            console.error('🔍 API Error Status:', errorMessage);
            
            // Special handling for completed exams - we want to return the data even if it's marked as error
            if (errorMessage.toLowerCase().includes('completed')) {
                console.log('🔍 Exam is completed, but returning data for display');
                // Return the response even if it's marked as error for completed exams
                return response.data;
            }
            
            throw new Error(errorMessage);
        }
        
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch manual exam question:", error);
        
        // If it's an API error response, extract the message
        if (error.response && error.response.data) {
            console.error("API Error Response:", error.response.data);
            
            // Handle different response formats
            if (error.response.data.message) {
                throw new Error(error.response.data.message);
            } else if (error.response.data.error) {
                throw new Error(error.response.data.error);
            } else if (typeof error.response.data === 'string') {
                throw new Error(error.response.data);
            } else {
                throw new Error('Server error occurred');
            }
        }
        
        // If it's a network error or other error
        if (error.message) {
            throw new Error(error.message);
        }
        
        throw new Error('An unexpected error occurred');
    }
}

export const submitManualExamAnswer = async (formData: FormData) => {
    try {
        console.log('🔍 API Call - submitManualExamAnswer');
        
        const response = await api.post(`https://ideatrialbrainweb.com/edu/dashboard/api-student-exam-manual.php`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        
        console.log('🔍 API Response:', response);
        
        return response.data;
    } catch (error: any) {
        console.error("Failed to submit manual exam answer:", error);
        
        // If it's an API error response, extract the message
        if (error.response && error.response.data) {
            console.error("API Error Response:", error.response.data);
            
            // Handle different response formats
            if (error.response.data.message) {
                throw new Error(error.response.data.message);
            } else if (error.response.data.error) {
                throw new Error(error.response.data.error);
            } else if (typeof error.response.data === 'string') {
                throw new Error(error.response.data);
            } else {
                throw new Error('Server error occurred');
            }
        }
        
        // If it's a network error or other error
        if (error.message) {
            throw new Error(error.message);
        }
        
        throw new Error('An unexpected error occurred');
    }
}

export const submitFinalManualExam = async (examId: number, studentId: number) => {
    try {
        console.log('🔍 API Call - submitFinalManualExam:', { examId, studentId });
        
        const formData = new FormData();
        formData.append('action', 'final_submit');
        formData.append('student_exam_exam_id', examId.toString());
        formData.append('student_id', studentId.toString());
        
        const response = await api.post(`https://ideatrialbrainweb.com/edu/dashboard/api-student-exam-manual.php`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        
        console.log('🔍 API Response:', response);
        
        return response.data;
    } catch (error: any) {
        console.error("Failed to submit final manual exam:", error);
        
        // If it's an API error response, extract the message
        if (error.response && error.response.data) {
            console.error("API Error Response:", error.response.data);
            
            // Handle different response formats
            if (error.response.data.message) {
                throw new Error(error.response.data.message);
            } else if (error.response.data.error) {
                throw new Error(error.response.data.error);
            } else if (typeof error.response.data === 'string') {
                throw new Error(error.response.data);
            } else {
                throw new Error('Server error occurred');
            }
        }
        
        // If it's a network error or other error
        if (error.message) {
            throw new Error(error.message);
        }
        
        throw new Error('An unexpected error occurred');
    }
}

export const getStudentExamAuto = async (examHash: string, studentId: number, questionNumber: number = 1) => {
    try {
        console.log('🔍 API Call - getStudentExamAuto:', { examHash, studentId, questionNumber });
        
        const response = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-student-exam-auto.php?exam_hash=${examHash}&student_id=${studentId}&nos=${questionNumber}`);
        
        console.log('🔍 API Response:', response);
        
        // Check if the response has an error status
        if (response.data && response.data.status === 'error') {
            const errorMessage = response.data.message || 'API returned error status';
            console.error('🔍 API Error Status:', errorMessage);
            
            // Special handling for completed exams - we want to return the data even if it's marked as error
            if (errorMessage.toLowerCase().includes('completed')) {
                console.log('🔍 Exam is completed, but returning data for display');
                // Return the response even if it's marked as error for completed exams
                return response.data;
            }
            
            throw new Error(errorMessage);
        }
        
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch exam question:", error);

        const mapKnownAutoExamError = (message: string) => {
            if (message.toLowerCase().includes('failed to prepare navigation query')) {
                return "Server issue detected: exam navigation query is using an invalid column. Backend fix: in sch_exam_answer navigation query use exam_answer_question (or alias AS question_number).";
            }
            return message;
        };
        
        // If it's an API error response, extract the message
        if (error.response && error.response.data) {
            console.error("API Error Response:", error.response.data);

            // Some backends return 403 for completed exams; treat it as a valid terminal state
            const message = (error.response.data.message || error.response.data.error || '').toString();
            if (message.toLowerCase().includes('completed')) {
                return error.response.data;
            }
            
            // Handle different response formats
            if (error.response.data.message) {
                throw new Error(mapKnownAutoExamError(error.response.data.message));
            } else if (error.response.data.error) {
                throw new Error(mapKnownAutoExamError(error.response.data.error));
            } else if (typeof error.response.data === 'string') {
                throw new Error(mapKnownAutoExamError(error.response.data));
            } else {
                throw new Error('Server error occurred');
            }
        }
        
        // If it's a network error or other error
        if (error.message) {
            throw new Error(mapKnownAutoExamError(error.message));
        }
        
        throw new Error('An unexpected error occurred');
    }
}

export const submitStudentExamAutoAnswer = async (formData: FormData) => {
    const endpoint = `https://ideatrialbrainweb.com/edu/dashboard/api-student-exam-auto.php`;
    const buildGetFallbackUrl = (fd: FormData) => {
        const params = new URLSearchParams();
        fd.forEach((value, key) => {
            if (value instanceof File) {
                throw new Error('This exam server only accepts GET for auto answers. File upload answers are not supported in this mode.');
            }
            params.append(key, String(value));
        });
        return `${endpoint}?${params.toString()}`;
    };

    try {
        console.log('🔍 API Call - submitStudentExamAutoAnswer');

        const response = await api.post(endpoint, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        console.log('🔍 API Response:', response);
        return response.data;
    } catch (error: any) {
        console.error("Failed to submit auto exam answer:", error);

        if (error?.response?.status === 405) {
            try {
                const fallbackUrl = buildGetFallbackUrl(formData);
                console.warn('🔁 Auto-exam submit POST returned 405. Retrying with GET fallback.');
                const fallbackResponse = await api.get(fallbackUrl);
                console.log('🔍 API Fallback Response:', fallbackResponse);
                return fallbackResponse.data;
            } catch (fallbackError: any) {
                console.error('Failed GET fallback for auto exam answer:', fallbackError);
                if (fallbackError?.message) {
                    throw new Error(fallbackError.message);
                }
                throw new Error('Auto exam answer could not be submitted via fallback request');
            }
        }

        if (error.response && error.response.data) {
            console.error("API Error Response:", error.response.data);

            if (error.response.data.message) {
                throw new Error(error.response.data.message);
            } else if (error.response.data.error) {
                throw new Error(error.response.data.error);
            } else if (typeof error.response.data === 'string') {
                throw new Error(error.response.data);
            } else {
                throw new Error('Server error occurred');
            }
        }

        if (error.message) {
            throw new Error(error.message);
        }

        throw new Error('An unexpected error occurred');
    }
}

export const submitFinalStudentExamAuto = async (examId: number, studentId: number) => {
    const endpoint = `https://ideatrialbrainweb.com/edu/dashboard/api-student-exam-auto.php`;
    try {
        console.log('🔍 API Call - submitFinalStudentExamAuto:', { examId, studentId });

        const formData = new FormData();
        // PHP-style flag, so backend can detect final submit
        formData.append('final_submit', '1');
        formData.append('student_exam_exam_id', examId.toString());
        formData.append('student_id', studentId.toString());

        const response = await api.post(endpoint, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        console.log('🔍 API Response:', response);
        return response.data;
    } catch (error: any) {
        console.error("Failed to submit final auto exam:", error);

        if (error?.response?.status === 405) {
            try {
                const params = new URLSearchParams();
                params.append('final_submit', '1');
                params.append('student_exam_exam_id', examId.toString());
                params.append('student_id', studentId.toString());
                const fallbackUrl = `${endpoint}?${params.toString()}`;
                console.warn('🔁 Final auto-exam submit POST returned 405. Retrying with GET fallback.');
                const fallbackResponse = await api.get(fallbackUrl);
                console.log('🔍 API Fallback Response:', fallbackResponse);
                return fallbackResponse.data;
            } catch (fallbackError: any) {
                console.error('Failed GET fallback for final auto exam submit:', fallbackError);
                if (fallbackError?.message) {
                    throw new Error(fallbackError.message);
                }
                throw new Error('Final auto exam submission failed in fallback request');
            }
        }

        if (error.response && error.response.data) {
            console.error("API Error Response:", error.response.data);

            if (error.response.data.message) {
                throw new Error(error.response.data.message);
            } else if (error.response.data.error) {
                throw new Error(error.response.data.error);
            } else if (typeof error.response.data === 'string') {
                throw new Error(error.response.data);
            } else {
                throw new Error('Server error occurred');
            }
        }

        if (error.message) {
            throw new Error(error.message);
        }

        throw new Error('An unexpected error occurred');
    }
}

export const getViewExam = async (examId: number, adminId: number, adminType: string, adminBranch: number) => {
    try {
        console.log('🔍 API Call - getViewExam:', { examId, adminId, adminType, adminBranch });
        
        const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-view-exam.php?exam_id=${examId}&admin_id=${adminId}&admin_type=${adminType}&admin_branch=${adminBranch}`);
        
        console.log('🔍 API Response:', response);
        
        // Check if the response has an error status
        if (response.data && response.data.status === 'error') {
            const errorMessage = response.data.message || 'API returned error status';
            console.error('🔍 API Error Status:', errorMessage);
            throw new Error(errorMessage);
        }
        
        // Check if the response has data
        if (!response.data || !response.data.data) {
            throw new Error('Invalid response format from API');
        }
        
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch exam view:", error);
        
        // If it's an API error response, extract the message
        if (error.response && error.response.data) {
            console.error("API Error Response:", error.response.data);
            
            // Handle different response formats
            if (error.response.data.message) {
                throw new Error(error.response.data.message);
            } else if (error.response.data.error) {
                throw new Error(error.response.data.error);
            } else if (typeof error.response.data === 'string') {
                throw new Error(error.response.data);
            } else {
                throw new Error('Server error occurred');
            }
        }
        
        // If it's a network error or other error
        if (error.message) {
            throw new Error(error.message);
        }
        
        throw new Error('An unexpected error occurred');
    }
}

export const editClass = async (branchId: number, classId: string, className: string) => {
    try {
        const data = {
            action: "edit",
            class_name: className,
            class_id: classId,
        }
        const response = await api.post(`/manage/dashboard/class_api.php?admin_branch=${branchId}`, data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all classes:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const deleteClass = async (branchId: number, classId: string) => {
    try {
        const data = {
            action: "delete",
            class_id: classId,
        }
        const response = await api.post(`/manage/dashboard/class_api.php?admin_branch=${branchId}`, data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all classes:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const getAllSections = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/section_api.php?admin_branch=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all sections:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}
export const createSection = async (branchId: number, data: any) => {
    try {
        const response = await api.post(`/manage/dashboard/section_api.php?admin_branch=${branchId}`, data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all sections:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}
export const updateSection = async (branchId: number, data: any) => {
    try {
        const response = await api.put(`/manage/dashboard/section_api.php?admin_branch=${branchId}`, data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all sections:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}
export const deleteSection = async (branchId: number, sectionId: string) => {
    try {
        const response = await api.delete(`/manage/dashboard/section_api.php?admin_branch=${branchId}`, {
            data: { id: sectionId }, // Send `id` in the JSON body
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all sections:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}
export const getAllTeachers = async (branchId: number) => {
    try {
        // Try the correct endpoint for fetching teachers list
        const response = await api.get(`/manage/dashboard/api-teacher-list.php?admin_branch=${branchId}`);
        console.log("getAllTeachers API response:", response.data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch teachers from api-teacher-list.php:", error.response?.data || error.message);
        
        // Try alternative endpoint
        try {
            const response2 = await api.get(`/manage/dashboard/api-teacher.php?admin_branch=${branchId}`);
            console.log("getAllTeachers alternative API response:", response2.data);
            return response2.data;
        } catch (error2: any) {
            console.error("Failed to fetch teachers from api-teacher.php:", error2.response?.data || error2.message);
            
            // Try another common endpoint
            try {
                const response3 = await api.get(`/manage/dashboard/api-teachers.php?admin_branch=${branchId}`);
                console.log("getAllTeachers third API response:", response3.data);
                return response3.data;
            } catch (error3: any) {
                console.error("Failed to fetch teachers from api-teachers.php:", error3.response?.data || error3.message);
                
                // Try the original endpoint as last resort
                try {
                    const response4 = await api.get(`/manage/dashboard/api_teacher.php/teachers?admin_branch=${branchId}`);
                    console.log("getAllTeachers original API response:", response4.data);
                    return response4.data;
                } catch (error4: any) {
                    console.error("Failed to fetch teachers from all endpoints:", error4.response?.data || error4.message);
                    
                    // Try the teachers list endpoint as final fallback
                    try {
                        const response5 = await api.get(`/manage/dashboard/api-teacher.php?admin_branch=${branchId}&action=list`);
                        console.log("getAllTeachers teachers list API response:", response5.data);
                        return response5.data;
                    } catch (error5: any) {
                        console.error("Failed to fetch teachers from all endpoints including teachers list:", error5.response?.data || error5.message);
                        throw error5.response?.data || error5;
                    }
                }
            }
        }
    }
};

export type EpfMonthRowPayload = {
    openingBalance: string;
    depositsUpTo15: string;
    deposits16ToLast: string;
    withdrawals: string;
    interest: string;
    remarks: string;
    locked?: boolean;
};

export type EpfStatementPayload = {
    teacher_id: number;
    financial_year: string;
    month_rows: EpfMonthRowPayload[];
    created_by?: number;
};

export type EpfStatementRecordResponse = {
    id?: number;
    branch_id?: number;
    teacher_id?: number;
    financial_year?: string;
    month_rows?: EpfMonthRowPayload[];
    created_by?: number | null;
    created_at?: string;
    updated_at?: string;
};

/**
 * Save EPF / Provident Fund statement.
 * Backend: /manage/dashboard/api-epf-statement.php
 */
export const saveEpfStatement = async (
    branchId: number,
    payload: EpfStatementPayload,
    createdBy?: number
) => {
    try {
        const response = await api.post(
            `/manage/dashboard/api-epf-statement.php?admin_branch=${branchId}`,
            {
                ...payload,
                branch_id: branchId,
                created_by: createdBy,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error('Failed to save EPF statement:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

/**
 * Fetch saved EPF / Provident Fund statement for a teacher and financial year.
 * Backend: /manage/dashboard/api-epf-statement.php
 */
export const getEpfStatement = async (
    branchId: number,
    teacherId: number,
    financialYear: string
): Promise<EpfStatementRecordResponse | null> => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-epf-statement.php?admin_branch=${branchId}&teacher_id=${teacherId}&financial_year=${encodeURIComponent(financialYear)}`
        );
        const data = response.data;
        if (!data) return null;
        if (data.success === true && data.data == null) return null;
        if (data.data && typeof data.data === 'object') return data.data as EpfStatementRecordResponse;
        if (typeof data === 'object' && Array.isArray(data.month_rows)) {
            return data as EpfStatementRecordResponse;
        }
        return null;
    } catch (error: any) {
        console.error('Failed to fetch EPF statement:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const assignClassToTeacher = async (data: {
    teacher_id: number;
    class_section: string[];
    num_classes: number[];
}) => {
    try {
        const response = await api.post(`/manage/dashboard/api-assign-class.php`, data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to assign class to teacher:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

export const getAllSubjects = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/subjects_api.php?admin_branch=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all subjects:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const saveSubjectCombination = async (studentId: number, subjectCombination: string[]) => {
    try {
        const data = {
            student_id: studentId,
            subject_combination: subjectCombination
        };
        const response = await api.post(`/manage/dashboard/api-save-subject-combination.php`, data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to save subject combination:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

/** Assign cafeteria / meal plan for a student. Backend: api-save-student-food-menu.php */
export const saveStudentFoodMenu = async (
    studentId: number,
    foodMenu: string,
    branchId: number
) => {
    try {
        const data = {
            student_id: studentId,
            food_menu: foodMenu,
            branch_id: branchId,
        };
        const response = await api.post(`/manage/dashboard/api-save-student-food-menu.php`, data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to save student food menu:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export interface FoodMenuItem {
    id: number;
    menu_name: string;
    menu_status?: number | string;
    branch_id?: number;
    created_at?: string;
    updated_at?: string;
}

/** Food menu CRUD APIs (mid-day meal menu) */
export const getFoodMenus = async (branchId: number): Promise<FoodMenuItem[]> => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-food-menu.php?admin_branch=${branchId}`
        );
        const data = response.data;
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.data)) return data.data;
        return [];
    } catch (error: any) {
        console.error("Failed to fetch food menus:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const addFoodMenu = async (branchId: number, menuName: string) => {
    try {
        const response = await api.post(
            `/manage/dashboard/api-food-menu.php?admin_branch=${branchId}`,
            {
                menu_name: menuName,
                menu_status: 1,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to add food menu:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const editFoodMenu = async (
    branchId: number,
    menuId: number,
    menuName: string
) => {
    try {
        const response = await api.put(
            `/manage/dashboard/api-food-menu.php?admin_branch=${branchId}`,
            {
                id: menuId,
                menu_name: menuName,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to edit food menu:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteFoodMenu = async (branchId: number, menuId: number) => {
    try {
        const response = await api.delete(
            `/manage/dashboard/api-food-menu.php?admin_branch=${branchId}`,
            {
                data: { id: menuId },
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete food menu:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export interface FoodItem {
    id: number;
    item_name: string;
    item_status?: number | string;
    branch_id?: number;
    created_at?: string;
    updated_at?: string;
}

/** Food item CRUD APIs */
export const getFoodItems = async (branchId: number): Promise<FoodItem[]> => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-food-item.php?admin_branch=${branchId}`
        );
        const data = response.data;
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.data)) return data.data;
        return [];
    } catch (error: any) {
        console.error("Failed to fetch food items:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const addFoodItem = async (branchId: number, itemName: string) => {
    try {
        const response = await api.post(
            `/manage/dashboard/api-food-item.php?admin_branch=${branchId}`,
            {
                item_name: itemName,
                item_status: 1,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to add food item:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const editFoodItem = async (
    branchId: number,
    itemId: number,
    itemName: string
) => {
    try {
        const response = await api.put(
            `/manage/dashboard/api-food-item.php?admin_branch=${branchId}`,
            {
                id: itemId,
                item_name: itemName,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to edit food item:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteFoodItem = async (branchId: number, itemId: number) => {
    try {
        const response = await api.delete(
            `/manage/dashboard/api-food-item.php?admin_branch=${branchId}`,
            {
                data: { id: itemId },
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete food item:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export interface CookCumHelperItem {
    id: number;
    helper_name: string;
    helper_status?: number | string;
    branch_id?: number;
    created_at?: string;
    updated_at?: string;
}

/** Cook cum helper CRUD APIs */
export const getCookCumHelpers = async (branchId: number): Promise<CookCumHelperItem[]> => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-cook-cum-helper.php?admin_branch=${branchId}`
        );
        const data = response.data;
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.data)) return data.data;
        return [];
    } catch (error: any) {
        console.error("Failed to fetch cook cum helpers:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const addCookCumHelper = async (branchId: number, helperName: string) => {
    try {
        const response = await api.post(
            `/manage/dashboard/api-cook-cum-helper.php?admin_branch=${branchId}`,
            {
                helper_name: helperName,
                helper_status: 1,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to add cook cum helper:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const editCookCumHelper = async (
    branchId: number,
    helperId: number,
    helperName: string
) => {
    try {
        const response = await api.put(
            `/manage/dashboard/api-cook-cum-helper.php?admin_branch=${branchId}`,
            {
                id: helperId,
                helper_name: helperName,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to edit cook cum helper:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteCookCumHelper = async (branchId: number, helperId: number) => {
    try {
        const response = await api.delete(
            `/manage/dashboard/api-cook-cum-helper.php?admin_branch=${branchId}`,
            {
                data: { id: helperId },
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete cook cum helper:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

/** Roman classes supported for MDM rice allotment (V through VIII). */
export const MDM_RICE_CLASS_ROMAN = ["V", "VI", "VII", "VIII"] as const;
export type MdmRiceClassRoman = (typeof MDM_RICE_CLASS_ROMAN)[number];

export interface RiceAllotmentPerClassItem {
    id: number;
    class_roman: MdmRiceClassRoman | string;
    rice_grams_per_student: number | string;
    branch_id?: number;
    created_at?: string;
    updated_at?: string;
}

/** Rice allotment per student by class (V–VIII) — backend: api-rice-allotment-per-class.php */
export const getRiceAllotmentsPerClass = async (
    branchId: number
): Promise<RiceAllotmentPerClassItem[]> => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-rice-allotment-per-class.php?admin_branch=${branchId}`
        );
        const data = response.data;
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.data)) return data.data;
        return [];
    } catch (error: any) {
        console.error("Failed to fetch rice allotments:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const addRiceAllotmentPerClass = async (
    branchId: number,
    payload: { class_roman: string; rice_grams_per_student: number }
) => {
    try {
        const response = await api.post(
            `/manage/dashboard/api-rice-allotment-per-class.php?admin_branch=${branchId}`,
            {
                class_roman: payload.class_roman.trim().toUpperCase(),
                rice_grams_per_student: payload.rice_grams_per_student,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to add rice allotment:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const editRiceAllotmentPerClass = async (
    branchId: number,
    rowId: number,
    payload: { class_roman: string; rice_grams_per_student: number }
) => {
    try {
        const response = await api.put(
            `/manage/dashboard/api-rice-allotment-per-class.php?admin_branch=${branchId}`,
            {
                id: rowId,
                class_roman: payload.class_roman.trim().toUpperCase(),
                rice_grams_per_student: payload.rice_grams_per_student,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to update rice allotment:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteRiceAllotmentPerClass = async (branchId: number, rowId: number) => {
    try {
        const response = await api.delete(
            `/manage/dashboard/api-rice-allotment-per-class.php?admin_branch=${branchId}`,
            {
                data: { id: rowId },
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete rice allotment:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

/** School levels for MDM cost-per-meal (database ENUM + API). */
export const MDM_COST_SCHOOL_LEVELS = [
    { value: "primary", label: "Primary" },
    { value: "upper_primary", label: "Upper Primary" },
] as const;
export type MdmCostSchoolLevel = (typeof MDM_COST_SCHOOL_LEVELS)[number]["value"];

export interface MdmCostPerMealItem {
    id: number;
    school_level: MdmCostSchoolLevel | string;
    cost_per_meal: number | string;
    branch_id?: number;
    created_at?: string;
    updated_at?: string;
}

/** MDM cost per meal by Primary / Upper Primary — backend: api-mdm-cost-per-meal.php */
export const getMdmCostPerMealRows = async (branchId: number): Promise<MdmCostPerMealItem[]> => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-mdm-cost-per-meal.php?admin_branch=${branchId}`
        );
        const data = response.data;
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.data)) return data.data;
        return [];
    } catch (error: any) {
        console.error("Failed to fetch MDM cost per meal:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const addMdmCostPerMealRow = async (
    branchId: number,
    payload: { school_level: MdmCostSchoolLevel | string; cost_per_meal: number }
) => {
    try {
        const response = await api.post(
            `/manage/dashboard/api-mdm-cost-per-meal.php?admin_branch=${branchId}`,
            {
                school_level: String(payload.school_level).trim(),
                cost_per_meal: payload.cost_per_meal,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to add MDM cost per meal:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const editMdmCostPerMealRow = async (
    branchId: number,
    rowId: number,
    payload: { school_level?: MdmCostSchoolLevel | string; cost_per_meal: number }
) => {
    try {
        const body: Record<string, unknown> = {
            id: rowId,
            cost_per_meal: payload.cost_per_meal,
        };
        if (payload.school_level != null && String(payload.school_level).trim() !== "") {
            body.school_level = String(payload.school_level).trim();
        }
        const response = await api.put(
            `/manage/dashboard/api-mdm-cost-per-meal.php?admin_branch=${branchId}`,
            body
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to update MDM cost per meal:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteMdmCostPerMealRow = async (branchId: number, rowId: number) => {
    try {
        const response = await api.delete(
            `/manage/dashboard/api-mdm-cost-per-meal.php?admin_branch=${branchId}`,
            {
                data: { id: rowId },
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete MDM cost per meal:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export type CmdmDailyReportPayload = {
    report_date: string;
    i_v_cp: string;
    i_v_mt: string;
    ii_vi_cp: string;
    ii_vi_mt: string;
    iii_vii_cp: string;
    iii_vii_mt: string;
    iv_viii_cp: string;
    iv_viii_mt: string;
    v_cp: string;
    v_mt: string;
    rice_kg: string;
    menu: string;
};

export type CmdmDailyReportRecord = CmdmDailyReportPayload & {
    id?: number;
    branch_id?: number;
    month_key?: string;
    created_by?: number;
    created_at?: string;
    updated_at?: string;
};

/**
 * Save single-day CMDM report row.
 * Backend endpoint expected: /manage/dashboard/api-cmdm-daily-report.php
 */
export const saveCmdmDailyReport = async (
    branchId: number,
    payload: CmdmDailyReportPayload,
    createdBy?: number
) => {
    try {
        const response = await api.post(
            `/manage/dashboard/api-cmdm-daily-report.php?admin_branch=${branchId}`,
            {
                ...payload,
                branch_id: branchId,
                created_by: createdBy,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to save CMDM daily report:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

/**
 * Save multiple CMDM rows for a month.
 * Backend endpoint expected: /manage/dashboard/api-cmdm-monthly-report.php
 */
export const saveCmdmMonthlyReport = async (
    branchId: number,
    month: string,
    entries: CmdmDailyReportPayload[],
    createdBy?: number
) => {
    try {
        const response = await api.post(
            `/manage/dashboard/api-cmdm-monthly-report.php?admin_branch=${branchId}`,
            {
                branch_id: branchId,
                month,
                created_by: createdBy,
                entries,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to save CMDM monthly report:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

/**
 * Fetch month report rows from backend.
 * Backend endpoint expected: /manage/dashboard/api-cmdm-monthly-report.php
 */
export const getCmdmMonthlyReport = async (
    branchId: number,
    month: string
): Promise<CmdmDailyReportRecord[]> => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-cmdm-monthly-report.php?admin_branch=${branchId}&month=${encodeURIComponent(month)}`
        );
        const data = response.data;
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.data)) return data.data;
        if (Array.isArray(data?.rows)) return data.rows;
        return [];
    } catch (error: any) {
        console.error("Failed to fetch CMDM monthly report:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export type CmdmMonthlyDataEntryPayload = {
    month: string;
    year: string;
    month_year: string;
    branch_id: number;
    school_name: string;
    school_type: string;
    school_category: string;
    balance_match_status: string;
    school_inspection_status: string;
    primary_actual_meal_days: string;
    primary_total_meals_served: string;
    upper_primary_actual_meal_days: string;
    upper_primary_total_meals_served: string;
    form_values: Record<string, string>;
    cook_payment_rows: Array<{
        cook_name_id?: number;
        gender: string;
        category: string;
        payment_mode: string;
        amount: string;
    }>;
};

/**
 * Save monthly data-entry form payload.
 * Backend endpoint expected: /manage/dashboard/api-cmdm-monthly-data-entry.php
 */
export const saveCmdmMonthlyDataEntry = async (
    branchId: number,
    payload: CmdmMonthlyDataEntryPayload,
    createdBy?: number
) => {
    try {
        const response = await api.post(
            `/manage/dashboard/api-cmdm-monthly-data-entry.php?admin_branch=${branchId}`,
            {
                ...payload,
                branch_id: branchId,
                created_by: createdBy,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to save CMDM monthly data entry:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const getCmdmMonthlyDataEntry = async (
    branchId: number,
    month: string
) => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-cmdm-monthly-data-entry.php?admin_branch=${branchId}&month=${encodeURIComponent(month)}`
        );
        const data = response.data;
        if (!data) return null;
        if (data?.success === true && (data?.data == null && data?.row == null && data?.record == null)) {
            return null;
        }
        if (data?.data && typeof data.data === 'object') return data.data;
        if (data?.row && typeof data.row === 'object') return data.row;
        if (data?.record && typeof data.record === 'object') return data.record;
        if (typeof data === 'object') return data;
        return null;
    } catch (error: any) {
        console.error("Failed to fetch CMDM monthly data entry:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export type CmdmMonthwiseFormKPayload = {
    month: string;
    year: string;
    month_year: string;
    branch_id: number;
    school_name: string;
    dise_code: string;
    form_data: Record<string, any>;
};

/**
 * Save monthwise Form K payload.
 * Backend endpoint expected: /manage/dashboard/api-cmdm-monthwise-form-k.php
 */
export const saveCmdmMonthwiseFormK = async (
    branchId: number,
    payload: CmdmMonthwiseFormKPayload,
    createdBy?: number
) => {
    try {
        const response = await api.post(
            `/manage/dashboard/api-cmdm-monthwise-form-k.php?admin_branch=${branchId}`,
            {
                ...payload,
                admin_branch: branchId,
                branch_id: branchId,
                created_by: createdBy,
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to save CMDM monthwise Form K:", error.response?.data || error.message);
        throw error.response?.data?.message || error.response?.data || error.message || error;
    }
};

export const getCmdmMonthwiseFormK = async (
    branchId: number,
    monthYear: string
) => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-cmdm-monthwise-form-k.php?admin_branch=${branchId}&month_year=${encodeURIComponent(monthYear)}`
        );
        const data = response.data;
        if (!data) return null;
        if (data?.data && typeof data.data === 'object') return data.data;
        if (data?.row && typeof data.row === 'object') return data.row;
        if (data?.record && typeof data.record === 'object') return data.record;
        if (typeof data === 'object') return data;
        return null;
    } catch (error: any) {
        console.error("Failed to fetch CMDM monthwise Form K:", error.response?.data || error.message);
        throw error.response?.data?.message || error.response?.data || error.message || error;
    }
};

export const addSubject = async (branchId: number, body: any) => {
    try {
        const response = await api.post(`/manage/dashboard/subjects_api.php?admin_branch=${branchId}`, body);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all subjects:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const editSubject = async (branchId: number, body: any) => {
    try {
        const response = await api.put(`/manage/dashboard/subjects_api.php?admin_branch=${branchId}`, body);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all subjects:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const deleteSubject = async (branchId: number, classId: number) => {
    try {
        const response = await api.delete(`/manage/dashboard/subjects_api.php?admin_branch=${branchId}`, {
            data: { id: classId }, // Send `id` in the JSON body
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete class:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

export const getAllExamTypes = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-exam-type.php?admin_branch=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all exam types:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

// Student Marksheet API function
export const getStudentMarksheet = async (studentId: number, branchId: number, examType?: number) => {
    try {
        const params = new URLSearchParams({
            student_id: studentId.toString(),
            admin_branch: branchId.toString()
        });
        
        if (examType) {
            params.append('student_exam_type', examType.toString());
        }
        
        const response = await api.get(`/dashboard/api-view_marks.php?${params.toString()}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch student marksheet:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

// Student Marksheet X API function
export const getStudentMarksheetX = async (studentId: number, branchId: number, examType?: number) => {
    try {
        const params = new URLSearchParams({
            student_id: studentId.toString(),
            admin_branch: branchId.toString()
        });
        
        if (examType) {
            params.append('student_exam_type', examType.toString());
        }
        
        const response = await api.get(`/dashboard/api-view_marksX.php?${params.toString()}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch student marksheet X:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

// Student Marksheet XI API function
export const getStudentMarksheetXI = async (studentId: number, branchId: number, examType?: number) => {
    try {
        const params = new URLSearchParams({
            student_id: studentId.toString(),
            admin_branch: branchId.toString()
        });
        
        if (examType) {
            params.append('student_exam_type', examType.toString());
        }
        
        const response = await api.get(`/dashboard/api-view_marksxi.php?${params.toString()}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch student marksheet XI:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

// Examination Report API functions
export const getExaminations = async (data: {
    examination_type: string;
    from_date: string;
    to_date: string;
    branch: number;
}) => {
    try {
        console.log("API Function - Sending data to api-get-examination.php:", data);
        console.log("API Function - Data types:", {
            examination_type: typeof data.examination_type,
            from_date: typeof data.from_date,
            to_date: typeof data.to_date,
            branch: typeof data.branch
        });
        
        // Build query string for GET request
        const queryParams = new URLSearchParams({
            examination_type: data.examination_type,
            from_date: data.from_date,
            to_date: data.to_date,
            branch: data.branch.toString()
        });
        
        const response = await api.get(`/manage/dashboard/ajax/api-get-examination.php?${queryParams.toString()}`);
        console.log("API Function - Raw response:", response);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch examinations:", error.response?.data || error.message);
        console.error("Full error object:", error);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

export const getExaminationResults = async (data: {
    action: string;
    exam: number;
    exam_type: string;
    branch: number;
}) => {
    try {
        console.log("API Function - Sending data to api-examination-report.php:", data);
        
        // Convert to FormData for PHP $_POST compatibility
        const formData = new FormData();
        formData.append('action', data.action);
        formData.append('exam', data.exam.toString());
        formData.append('exam_type', data.exam_type);
        formData.append('branch', data.branch.toString());
        
        const response = await api.post(`/manage/dashboard/api-examination-report.php`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        console.log("API Function - Results response:", response);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch examination results:", error.response?.data || error.message);
        console.error("Full error object:", error);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};
export const createExamType = async (branchId: number, data: any) => {
    try {
        const body = {
            ...data,
            exam_branch: branchId,
        }
        const response = await api.post(`/manage/dashboard/api-exam-type.php?admin_branch=${branchId}`, body);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all exam types:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};
export const updateExamType = async (branchId: number, data: any) => {
    try {
        const body = {
            ...data,
            exam_branch: branchId,
        }
        const response = await api.put(`/manage/dashboard/api-exam-type.php?admin_branch=${branchId}`, body);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all exam types:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};
export const deleteExamType = async (branchId: number, id: number) => {
    try {
        const response = await api.delete(`/manage/dashboard/api-exam-type.php?admin_branch=${branchId}`, {
            data: { id: id }, // Send `id` in the JSON body
        })
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all exam types:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

// Create new examination
export const createExam = async (branchId: number, data: any) => {
  try {
    console.log("Attempting to create exam with branch ID:", branchId);
    console.log("Exam data:", data);
    
    // Add admin_branch to the data as required by the new API
    const requestData = {
      ...data,
      admin_branch: branchId
    };
    
    console.log("Request data with admin_branch:", requestData);
    
    // Use the existing axios instance which should have proper authentication headers
    const response = await api.post(`/manage/dashboard/api-examination.php`, requestData);
    console.log("Success response via axios:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to create examination:", error);
    throw error; // Pass detailed error to frontend
  }
};

// Delete examination
export const deleteExam = async (branchId: number, examId: number) => {
  try {
    const response = await api.delete(`/manage/dashboard/api-examination.php`, {
      data: {
        admin_branch: branchId,
        id: examId
      }
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to delete examination:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Publish examination (old method)
export const publishExam = async (branchId: number, examId: number, startDate?: string, endDate?: string) => {
  try {
    const data: any = {
      admin_branch: branchId,
      id: examId,
      action: 'publish'
    };
    
    if (startDate) data.exam_start_date = startDate;
    if (endDate) data.exam_end_date = endDate;
    
    const response = await api.put(`/manage/dashboard/api-examination.php`, data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to publish examination:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Publish examination with new API
export const publishExamNew = async (examId: number, publishData: {
  admin_id: number;
  admin_branch: number;
  admin_type: string;
  package: number;
  from_date_time: string;
  to_date_time: string;
  exam_checking_teacher: number[];
  exam_uploaded_for: number[];
}) => {
  try {
    // Prepare JSON payload matching PHP API requirements
    // The PHP API reads: $input = json_decode(file_get_contents('php://input'), true);
    const requestData = {
      exam_id: examId,
      admin_id: publishData.admin_id,
      admin_branch: publishData.admin_branch,
      admin_type: publishData.admin_type,
      package: publishData.package,
      from_date_time: publishData.from_date_time,
      to_date_time: publishData.to_date_time,
      exam_checking_teacher: publishData.exam_checking_teacher,
      exam_uploaded_for: publishData.exam_uploaded_for
    };
    
    console.log("📤 Publishing exam with JSON payload:", requestData);
    console.log("📋 Request data structure:", {
      exam_id: requestData.exam_id,
      admin_id: requestData.admin_id,
      admin_branch: requestData.admin_branch,
      package: requestData.package,
      teachers_count: requestData.exam_checking_teacher.length,
      students_count: requestData.exam_uploaded_for.length
    });
    
    // Send as JSON (not FormData) - PHP API expects JSON
    const response = await api.post(`/manage/dashboard/api-publish-exam.php`, requestData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    console.log("✅ API Response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("❌ Failed to publish examination:", error.response?.data || error.message);
    console.error("📋 Error details:", {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    throw error.response?.data || error;
  }
};

// Show answer sheet
export const showAnswerSheet = async (branchId: number, examId: number) => {
  try {
    const response = await api.put(`/manage/dashboard/api-examination.php`, {
      admin_branch: branchId,
      id: examId,
      action: 'show_answer_sheet'
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to show answer sheet:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Update examination
export const updateExam = async (branchId: number, examId: number, data: any) => {
  try {
    const requestData = {
      ...data,
      admin_branch: branchId,
      id: examId,
      action: 'update'
    };
    
    console.log("Update exam request data:", requestData);
    
    const response = await api.put(`/manage/dashboard/api-examination.php`, requestData);
    return response.data;
  } catch (error: any) {
    console.error("Failed to update examination:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Question API functions — optional admin_id + admin_type for teacher-scoped lists (same pattern as homework questions)
export const fetchQuestions = async (
  branchId: number,
  query?: { adminId: number; adminType: string }
) => {
  try {
    let url = `/manage/dashboard/api-question.php?admin_branch=${branchId}`;
    if (query?.adminId != null && query.adminType) {
      url += `&admin_id=${query.adminId}&admin_type=${encodeURIComponent(query.adminType)}`;
    }
    const response = await api.get(url);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch questions:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const fetchQuestionById = async (branchId: number, questionId: number) => {
  try {
    const response = await api.get(`/manage/dashboard/api-question.php?admin_branch=${branchId}&action=view&id=${questionId}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch question:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const fetchExamsForQuestions = async (branchId: number) => {
  try {
    const response = await api.get(`/manage/dashboard/api-question.php?admin_branch=${branchId}&action=exams`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch exams for questions:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getQuestionNumber = async (branchId: number, examId: number) => {
  try {
    const response = await api.get(`/manage/dashboard/api-question.php?admin_branch=${branchId}&action=question_number&question_exam_id=${examId}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to get question number:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const createQuestion = async (branchId: number, formData: FormData) => {
  try {
    // Log the FormData contents before sending
    console.log('=== API LAYER: Preparing to send question ===');
    console.log('API: FormData contents before sending:');
    const formDataEntries: string[] = [];
    const optionsArray: string[] = [];
    const normalOptionsArray: string[] = [];
    
    formData.forEach((value, key) => {
      console.log(`API: ${key}:`, value);
      formDataEntries.push(`${key}: ${value}`);
      
      // Collect options for verification
      if (key === 'question_options[]') {
        optionsArray.push(value as string);
      }
      if (key === 'question_options_normal[]') {
        normalOptionsArray.push(value as string);
      }
    });
    
    // Count and display options clearly
    console.log('=== OPTIONS SUMMARY ===');
    console.log('API: Total question_options[] entries:', optionsArray.length);
    console.log('API: question_options[] values:', optionsArray);
    console.log('API: Total question_options_normal[] entries:', normalOptionsArray.length);
    console.log('API: question_options_normal[] values:', normalOptionsArray);
    
    // Verify critical fields
    const autoResult = formData.get('auto_result');
    const questionType = formData.get('question_answer_type');
    console.log('=== CRITICAL FIELDS ===');
    console.log('API: auto_result:', autoResult);
    console.log('API: question_answer_type:', questionType);
    
    if (questionType === 'radio' && autoResult === 'Yes' && optionsArray.length === 0) {
      console.error('ERROR: No options being sent for radio with auto result!');
      throw new Error('No options being sent for radio question');
    }
    
    // The FormData is already prepared in the component
    // Just send it directly to the PHP API
    // CRITICAL: Use direct axios to bypass the default Content-Type: application/json header
    // The browser will automatically set multipart/form-data with boundary for FormData
    const response = await axios.post(
      `${api.defaults.baseURL}/manage/dashboard/api-question.php`, 
      formData,
      {
        timeout: api.defaults.timeout,
        // Don't set Content-Type - let browser handle it for FormData
      }
    );
    
    console.log('=== API RESPONSE ===');
    console.log('API: Response received:', response.data);
    console.log('API: Response status:', response.status);
    
    return response.data;
  } catch (error: any) {
    console.error("=== API ERROR ===");
    console.error("Failed to create question:", error.response?.data || error.message);
    console.error("Error status:", error.response?.status);
    console.error("Full error:", error);
    throw error.response?.data || error;
  }
};

export const updateQuestion = async (branchId: number, questionId: number, formData: FormData) => {
  try {
    // Ensure admin_branch is properly set
    formData.set('admin_branch', branchId.toString());
    formData.set('id', questionId.toString());
    formData.set('action', 'update');
    
    // Log the FormData contents for debugging
    console.log('API: FormData contents before sending update:');
    formData.forEach((value, key) => {
      console.log(`API: ${key}:`, value);
    });
    
    // Try using POST instead of PUT, as some PHP APIs handle FormData better with POST
    // CRITICAL: Use direct axios to bypass the default Content-Type: application/json header
    // The browser will automatically set multipart/form-data with boundary for FormData
    const response = await axios.post(
      `${api.defaults.baseURL}/manage/dashboard/api-question.php`, 
      formData,
      {
        timeout: api.defaults.timeout,
        // Don't set Content-Type - let browser handle it for FormData
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Failed to update question:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const deleteQuestion = async (branchId: number, questionId: number) => {
  try {
    const response = await api.delete(`/manage/dashboard/api-question.php`, {
      data: {
        admin_branch: branchId,
        id: questionId
      }
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to delete question:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getAllFormatives = async (branchId: number) => {
    try {
        const response = await api.get(`manage/dashboard/formative_api.php?admin_branch=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all formatives:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};
export const createFormative = async (branchId: number, data: any) => {
    try {
        const body = {
            ...data,
            formative_branch: branchId,
        }
        const response = await api.post(`/manage/dashboard/formative_api.php?admin_branch=${branchId}`, body);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all formatives:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};
export const updateFormative = async (branchId: number, data: any) => {
    try {
        const body = {
            ...data,
            formative_branch: branchId,
        }
        const response = await api.put(`/manage/dashboard/formative_api.php?admin_branch=${branchId}`, body);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all formatives:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};
export const deleteFormative = async (branchId: number, id: number) => {
    try {
        const body = {
            id: id,
            formative_branch: branchId,
        }
        const response = await api.delete(`/manage/dashboard/formative_api.php?admin_branch=${branchId}`, {
            data: body
        })
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all formatives:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

export const fetchAllTutorials = async (adminId: number, adminType: string, branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api_tutorials.php?admin_id=${adminId}&admin_type=${adminType}&admin_branch=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all tutorials:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};
export const fetchStudyMaterials = async (branchId: number, classId: number, sectionId: number) => {
  try {
    const response = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-study-material.php?branch=${branchId}&class=${classId}&section=${sectionId}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch study materials:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const fetchStudyMaterialById = async (id: number, branchId: number, classId: number, sectionId: number) => {
  try {
    const response = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-study-material-view.php?id=${id}&branch=${branchId}&class=${classId}&section=${sectionId}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch study material details:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

const ADMISSION_API_BASE = "https://ideatrialbrainweb.com/edu/manage/dashboard/api-admission-app.php";

/** Always absolute — never `/proxy-admission/...` or axios + baseURL `/edu` hits the wrong host path (404). */
const ADMISSION_ONLINE_APPLICATIONS_LIST_DEFAULT =
  "https://ideatrialbrainweb.com/admission/admission-list-online-applications.php";

/** Student photo / marksheet / admit card — DB stores filename or full URL. */
export function getAdmissionApplicationFileUrl(filenameOrUrl: string): string {
  const trimmed = (filenameOrUrl || "").trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  const fromEnv = process.env.REACT_APP_APPLICATION_FILES_BASE_URL?.trim();
  const base = (
    fromEnv ||
    process.env.REACT_APP_ADMISSION_APPLICATION_FILES_BASE_URL?.trim() ||
    "https://ideatrialbrainweb.com/uploads/applications"
  ).replace(/\/$/, "");
  return `${base}/${trimmed.replace(/^\//, "")}`;
}

function resolveAdmissionOnlineApplicationsListUrl(): string {
  const fromEnv = process.env.REACT_APP_ADMISSION_APPLICATIONS_LIST_URL?.trim();
  if (!fromEnv) {
    return ADMISSION_ONLINE_APPLICATIONS_LIST_DEFAULT;
  }
  if (/^https?:\/\//i.test(fromEnv)) {
    return fromEnv;
  }
  if (fromEnv.startsWith("/admission/")) {
    return `https://ideatrialbrainweb.com${fromEnv}`;
  }
  return `https://ideatrialbrainweb.com/admission/${fromEnv.replace(/^\//, "")}`;
}

const ADMISSION_AJAX_BASE = "https://ideatrialbrainweb.com/edu/manage/dashboard/ajax";
const ADMISSION_AVAILABLE_SUBJECTS_API =
  "https://ideatrialbrainweb.com/admission/admin/dashboard/api-available-subjects.php";

export interface AdmissionSchedulePayload {
  schedule_class: number;
  schedule_from_date: string;
  schedule_to_date: string;
  schedule_payment_fees: number;
  schedule_admission_fees: number;
  schedule_marks_required: number;
  schedule_status: 0 | 1;
  schedule_min_birth?: string;
  schedule_max_birth?: string;
}

export interface AdmissionPerformanceRowPayload {
  year: string;
  score_80_and_above: string;
  score_60_and_above: string;
  overall_pass_percentage: string;
}

export interface AdmissionAvailableSubjectPayload {
  available_subject_id: number;
  available_subject_criteria: string;
  available_subject_group: string;
  available_subject_group_total: string;
  available_subject_total_marks_required: string;
}

export const fetchAdmissionData = async (branchId: number) => {
  try {
    const response = await api.get(`${ADMISSION_API_BASE}?admin_branch=${branchId}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch admission data:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

/** Normalize online application rows from manage/admission API responses (shape varies by deployment). */
export function extractAdmissionApplicationRows(raw: unknown): Record<string, unknown>[] {
  const fromBag = (bag: unknown): unknown[] => {
    if (!bag || typeof bag !== "object") return [];
    const o = bag as Record<string, unknown>;
    const keys = [
      "applications",
      "online_applications",
      "received_applications",
      "adm_online_application",
      "rows",
      "list",
    ];
    for (const k of keys) {
      const v = o[k];
      if (Array.isArray(v)) return v;
    }
    return [];
  };

  let arr = fromBag(raw);
  if (arr.length === 0 && raw && typeof raw === "object") {
    arr = fromBag((raw as Record<string, unknown>).data);
  }
  if (arr.length === 0 && raw && typeof raw === "object") {
    const data = (raw as Record<string, unknown>).data;
    if (data && typeof data === "object") {
      const inner = data as Record<string, unknown>;
      arr = fromBag(inner.applications);
      if (arr.length === 0) arr = fromBag(inner.online_applications);
    }
  }

  return arr.filter((item): item is Record<string, unknown> => item !== null && typeof item === "object");
}

/**
 * Submitted online admission applications for the branch admin dashboard.
 * POST admission-list-online-applications.php + `?admin_branch=…` with `{ action: "list_online_applications" }`.
 * Uses standalone axios (not `api` instance) so REACT_APP_API_BASE_URL `/edu` cannot rewrite the path to 404.
 * Falls back to GET admission bundle when the list is empty or the request fails.
 */
export const fetchAdmissionReceivedApplications = async (branchId: number) => {
  let data: unknown;
  try {
    const listUrl = `${resolveAdmissionOnlineApplicationsListUrl()}?admin_branch=${encodeURIComponent(String(branchId))}`;
    const postRes = await axios.post(
      listUrl,
      { action: "list_online_applications" },
      {
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        timeout: 3 * 60 * 1000,
      },
    );
    data = postRes.data;
  } catch (error: unknown) {
    try {
      const bundle = await fetchAdmissionData(branchId);
      const rows = extractAdmissionApplicationRows(bundle);
      if (rows.length > 0) {
        return { status: "success", applications: rows, source: "admission_bundle" };
      }
    } catch {
      /* ignore */
    }
    const message = error instanceof Error ? error.message : String(error);
    console.error("Failed to fetch admission applications:", message);
    throw error;
  }

  if (extractAdmissionApplicationRows(data).length > 0) {
    return data;
  }

  try {
    const bundle = await fetchAdmissionData(branchId);
    const rows = extractAdmissionApplicationRows(bundle);
    if (rows.length > 0) {
      return { status: "success", applications: rows, source: "admission_bundle" };
    }
  } catch {
    /* keep primary response */
  }

  return data;
};

/** Approve or reject an online application (requires server handler on admission-list-online-applications.php). */
export const updateAdmissionApplicationStatus = async (
  branchId: number,
  applicationId: string,
  applicationStatus: "approved" | "rejected",
) => {
  const listUrl = `${resolveAdmissionOnlineApplicationsListUrl()}?admin_branch=${encodeURIComponent(String(branchId))}`;
  const postRes = await axios.post(
    listUrl,
    {
      action: "update_application_status",
      application_id: applicationId,
      application_status: applicationStatus,
    },
    {
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      timeout: 3 * 60 * 1000,
    },
  );
  return postRes.data;
};

const ADMISSION_MERIT_LISTS_API = "https://ideatrialbrainweb.com/admission/api-merit-lists.php";

export type SavedMeritList = {
  id: string;
  name: string;
  studentIds: string[];
  updatedAt: string;
};

function meritListUrl(branchId: number): string {
  return `${ADMISSION_MERIT_LISTS_API}?admin_branch=${encodeURIComponent(String(branchId))}`;
}

function asSavedMeritLists(payload: unknown): SavedMeritList[] {
  const source = payload && typeof payload === "object" ? (payload as { lists?: unknown }).lists : null;
  if (!Array.isArray(source)) return [];
  return source.flatMap((item) => {
    if (!item || typeof item !== "object") return [];
    const row = item as { id?: unknown; name?: unknown; studentIds?: unknown; updatedAt?: unknown };
    const studentIds = Array.isArray(row.studentIds) ? row.studentIds.map((id) => String(id)) : [];
    return [{
      id: String(row.id ?? ""),
      name: String(row.name ?? ""),
      studentIds,
      updatedAt: String(row.updatedAt ?? ""),
    }];
  }).filter((list) => list.id && list.name);
}

export const fetchMeritLists = async (branchId: number): Promise<SavedMeritList[]> => {
  const response = await axios.post(
    meritListUrl(branchId),
    { action: "list" },
    { headers: { "Content-Type": "application/json", Accept: "application/json" }, timeout: 60 * 1000 },
  );
  if (response.data?.status !== "success") {
    throw new Error(response.data?.message || "Could not load merit lists.");
  }
  return asSavedMeritLists(response.data);
};

export const saveMeritList = async (
  branchId: number,
  payload: { id?: string; name: string; studentIds: string[] },
): Promise<SavedMeritList> => {
  const response = await axios.post(
    meritListUrl(branchId),
    {
      action: "save",
      list_id: payload.id ? Number(payload.id) : 0,
      list_name: payload.name,
      student_ids: payload.studentIds.map((id) => Number(id)).filter((id) => id > 0),
    },
    { headers: { "Content-Type": "application/json", Accept: "application/json" }, timeout: 60 * 1000 },
  );
  if (response.data?.status !== "success" || !response.data?.list) {
    throw new Error(response.data?.message || "Could not save the merit list.");
  }
  const [saved] = asSavedMeritLists({ lists: [response.data.list] });
  if (!saved) throw new Error("The server did not return the saved merit list.");
  return saved;
};

const ADMISSION_OFFER_API = "https://ideatrialbrainweb.com/admission/api-admission-offer.php";

function offerApiUrl(branchId: number): string {
  return `${ADMISSION_OFFER_API}?admin_branch=${encodeURIComponent(String(branchId))}`;
}

async function postAdmissionOffer(branchId: number, payload: Record<string, unknown>): Promise<Record<string, unknown>> {
  let response;
  try {
    response = await axios.post(offerApiUrl(branchId), payload, {
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      timeout: 60 * 1000,
      validateStatus: () => true,
    });
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : "Could not reach the admission offer API.";
    throw new Error(message);
  }
  const data = response.data;
  if (response.status === 404 || typeof data === "string") {
    throw new Error("Admission offer API was not found. Upload admission/php/api-admission-offer.php beside config.php.");
  }
  if (!data || data.status !== "success") {
    throw new Error(data?.message || "Could not update the admission offer.");
  }
  return data as Record<string, unknown>;
}

export async function resolveAdmissionFeeRupees(branchId: number): Promise<number> {
  try {
    const data = await fetchAdmissionData(branchId);
    const bag = data as { schedules?: unknown; data?: { schedules?: unknown } };
    const schedules = bag.schedules ?? bag.data?.schedules;
    if (!Array.isArray(schedules)) return 0;
    for (const item of schedules) {
      if (!item || typeof item !== "object") continue;
      const row = item as { schedule_status?: unknown; schedule_admission_fees?: unknown };
      const status = String(row.schedule_status ?? "1");
      if (status === "0" || status.toLowerCase() === "inactive") continue;
      const fee = Number(row.schedule_admission_fees || 0);
      if (Number.isFinite(fee) && fee > 0) return fee;
    }
  } catch {
    return 0;
  }
  return 0;
}

export async function decideAdmissionApplication(
  branchId: number,
  applicationId: string,
  status: "approved" | "rejected",
): Promise<void> {
  const fee = status === "approved" ? await resolveAdmissionFeeRupees(branchId) : 0;
  await postAdmissionOffer(branchId, {
    action: status === "approved" ? "approve" : "reject",
    application_id: Number(applicationId),
    admission_fee_rupees: fee,
  });
}

export async function openDirectAdmissionOffer(branchId: number, applicationId: string): Promise<void> {
  const fee = await resolveAdmissionFeeRupees(branchId);
  await postAdmissionOffer(branchId, {
    action: "open_direct",
    application_id: Number(applicationId),
    admission_fee_rupees: fee,
  });
}

export async function revokeAdmissionOffer(branchId: number, applicationId: string): Promise<void> {
  await postAdmissionOffer(branchId, {
    action: "revoke",
    application_id: Number(applicationId),
  });
}

export type PublishedMeritList = {
  listKey: string;
  listName: string;
  publishedAt: string;
};

export async function fetchPublishedMeritLists(branchId: number): Promise<PublishedMeritList[]> {
  const data = await postAdmissionOffer(branchId, { action: "list_published" });
  const lists = Array.isArray(data.lists) ? data.lists : [];
  return lists.flatMap((item) => {
    if (!item || typeof item !== "object") return [];
    const row = item as { list_key?: unknown; list_name?: unknown; published_at?: unknown };
    const listKey = String(row.list_key ?? "");
    if (!listKey) return [];
    return [{
      listKey,
      listName: String(row.list_name ?? ""),
      publishedAt: String(row.published_at ?? ""),
    }];
  });
}

export async function publishMeritOffers(
  branchId: number,
  payload: { listKey: string; listName: string; studentIds: string[] },
): Promise<{ approvedCount: number; skippedCount: number }> {
  const fee = await resolveAdmissionFeeRupees(branchId);
  const data = await postAdmissionOffer(branchId, {
    action: "publish_merit",
    list_key: payload.listKey,
    list_name: payload.listName,
    student_ids: payload.studentIds.map((id) => Number(id)).filter((id) => id > 0),
    admission_fee_rupees: fee,
  });
  return {
    approvedCount: Number(data.approved_count ?? 0),
    skippedCount: Number(data.skipped_count ?? 0),
  };
}

export const deleteMeritList = async (branchId: number, listId: string): Promise<void> => {
  const response = await axios.post(
    meritListUrl(branchId),
    { action: "delete", list_id: Number(listId) },
    { headers: { "Content-Type": "application/json", Accept: "application/json" }, timeout: 60 * 1000 },
  );
  if (response.data?.status !== "success") {
    throw new Error(response.data?.message || "Could not delete the merit list.");
  }
};

export const fetchAdmissionClasses = async (branchId: number) => {
  try {
    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-admission-classes.php?admin_branch=${branchId}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch admission classes:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const createAdmissionSchedule = async (branchId: number, payload: AdmissionSchedulePayload) => {
  try {
    const response = await api.post(`${ADMISSION_API_BASE}?admin_branch=${branchId}`, {
      action: "add_schedule",
      ...payload,
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to create admission schedule:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const updateAdmissionSchedule = async (
  branchId: number,
  scheduleId: number,
  payload: AdmissionSchedulePayload,
) => {
  try {
    const response = await api.post(`${ADMISSION_API_BASE}?admin_branch=${branchId}`, {
      action: "edit_schedule",
      schedule_id: scheduleId,
      ...payload,
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to update admission schedule:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const updateAdmissionTerms = async (branchId: number, branchTermsCondition: string) => {
  try {
    const response = await api.post(`${ADMISSION_API_BASE}?admin_branch=${branchId}`, {
      action: "update_terms",
      branch_terms_condition: branchTermsCondition,
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to update admission terms:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const updateAdmissionSchoolPerformance = async (
  branchId: number,
  rows: AdmissionPerformanceRowPayload[],
) => {
  try {
    const response = await api.post(`${ADMISSION_API_BASE}?admin_branch=${branchId}`, {
      action: "update_school_performance",
      school_performance: rows,
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to update school performance:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const createAdmissionAvailableSubject = async (
  branchId: number,
  payload: AdmissionAvailableSubjectPayload,
) => {
  try {
    const response = await api.post(ADMISSION_AVAILABLE_SUBJECTS_API, {
      action: "add_available_subject",
      school_id: branchId,
      ...payload,
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to create admission available subject:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const fetchAdmissionAvailableSubjects = async (branchId: number) => {
  try {
    const response = await api.post(ADMISSION_AVAILABLE_SUBJECTS_API, {
      action: "list_available_subjects",
      school_id: branchId,
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch admission available subjects:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const fetchAdmissionHigherSecondarySubjects = async (branchId: number, category: string) => {
  try {
    const response = await api.post(ADMISSION_AVAILABLE_SUBJECTS_API, {
      action: "fetch_hs_subjects",
      category,
      school_id: branchId,
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch higher secondary subjects:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const fetchAdmissionMadhyamikSubjects = async () => {
  try {
    const response = await api.post(ADMISSION_AVAILABLE_SUBJECTS_API, {
      action: "fetch_m_subjects",
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch Madhyamik subjects:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const fetchAdmissionScheduleById = async (scheduleId: number) => {
  try {
    const response = await api.post(`${ADMISSION_AJAX_BASE}/api-get-admission-schedule.php`, { id: scheduleId });
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch admission schedule details:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const deleteAdmissionAvailableSubject = async (branchId: number, availableSubjectId: number) => {
  try {
    const response = await api.post(ADMISSION_AVAILABLE_SUBJECTS_API, {
      action: "delete_available_subject",
      id: availableSubjectId,
      school_id: branchId,
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to delete admission available subject:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const deleteAdmissionSchedule = async (scheduleId: number) => {
  try {
    const response = await api.post(`${ADMISSION_AJAX_BASE}/api-delete-admission-schedule.php`, { id: scheduleId });
    return response.data;
  } catch (error: any) {
    console.error("Failed to delete admission schedule:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

/** Eligibility API lives under admission admin dashboard (see `deployment-php/api-admission-eligibility.php`). */
const ADMISSION_ELIGIBILITY_API =
  "https://ideatrialbrainweb.com/admission/admin/dashboard/api-admission-eligibility.php";

/**
 * Public base URL for admission notification files (must match PHP $image_url disk folder).
 * Override if your CDN/host differs: REACT_APP_ADMISSION_UPLOADS_BASE_URL=https://ideatrialbrainweb.com/admission/admin/uploads/
 */
export function getAdmissionEligibilityUploadsBaseUrl(): string {
  const fromEnv = process.env.REACT_APP_ADMISSION_UPLOADS_BASE_URL;
  if (typeof fromEnv === "string" && fromEnv.trim()) {
    return fromEnv.trim().replace(/\/?$/, "/");
  }
  try {
    const u = new URL(ADMISSION_ELIGIBILITY_API);
    u.pathname = u.pathname.replace(/\/dashboard\/[^/]+$/i, "/uploads/");
    if (!u.pathname.endsWith("/")) {
      u.pathname += "/";
    }
    return u.origin + u.pathname;
  } catch {
    return "https://ideatrialbrainweb.com/admission/admin/uploads/";
  }
}

/** PHP $image_url sometimes points at legacy paths; View should use admission admin uploads. */
function shouldRewriteLegacyAdmissionFileUrl(url: string): boolean {
  const u = url.toLowerCase();
  return (
    u.includes("brainwebskills.com") ||
    u.includes("/school/assets/images/media/") ||
    u.includes("/assets/images/media/")
  );
}

/** Full URL for View — filename only, or rewrite wrong legacy absolute URLs from API. */
export function getAdmissionNotificationPublicFileUrl(filenameOrUrl: string): string {
  const raw = (filenameOrUrl || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) {
    if (!shouldRewriteLegacyAdmissionFileUrl(raw)) {
      return raw;
    }
    try {
      const path = new URL(raw).pathname;
      const baseName = path.split("/").filter(Boolean).pop() || "";
      if (!baseName) return "";
      return getAdmissionNotificationPublicFileUrl(baseName);
    } catch {
      return "";
    }
  }
  const safe = raw.replace(/^\/+/, "").split("/").pop() || raw;
  const base = getAdmissionEligibilityUploadsBaseUrl();
  try {
    return new URL(safe, base).href;
  } catch {
    return `${base}${encodeURIComponent(safe)}`;
  }
}

export const ADMISSION_ELIGIBILITY_NUMERIC_KEYS = [
  "sud1",
  "sud2",
  "sud3",
  "sum1",
  "sum2",
  "sum3",
  "srd1",
  "srd2",
  "srd3",
  "srm1",
  "srm2",
  "srm3",
  "owud1",
  "owud2",
  "owud3",
  "owum1",
  "owum2",
  "owum3",
  "owrd1",
  "owrd2",
  "owrd3",
  "owrm1",
  "owrm2",
  "owrm3",
  "ooud1",
  "ooud2",
  "ooud3",
  "ooum1",
  "ooum2",
  "ooum3",
  "oord1",
  "oord2",
  "oord3",
  "oorm1",
  "oorm2",
  "oorm3",
] as const;

export type AdmissionEligibilityNumericKey = (typeof ADMISSION_ELIGIBILITY_NUMERIC_KEYS)[number];

export type AdmissionEligibilityCriteriaPayload = Record<AdmissionEligibilityNumericKey, string> & {
  school_terms_and_conditions: string;
  school_direct_status: string;
  pre_file: string;
};

const ADMISSION_ELIGIBILITY_AXIOS_MS = 3 * 60 * 1000;

function appendEligibilityPayloadToSearchParams(
  body: URLSearchParams,
  schoolId: number,
  adminBranchHint: number,
  payload: AdmissionEligibilityCriteriaPayload,
) {
  body.set("action", "update_eligibility");
  body.set("school_id", String(schoolId));
  body.set("admin_branch", String(adminBranchHint > 0 ? adminBranchHint : schoolId));
  ADMISSION_ELIGIBILITY_NUMERIC_KEYS.forEach((key) => {
    body.set(key, payload[key] ?? "0");
  });
  body.set("school_terms_and_conditions", payload.school_terms_and_conditions ?? "");
  body.set("school_direct_status", payload.school_direct_status ?? "0");
  body.set("pre_file", payload.pre_file ?? "");
}

/** Use global axios (not `api` instance). Pass `adminBranchHint` when branch id may differ from `adm_school.id`. */
export const fetchAdmissionEligibilityCriteria = async (schoolId: number, adminBranchHint?: number) => {
  try {
    const qs = new URLSearchParams({ school_id: String(schoolId) });
    const br = adminBranchHint ?? schoolId;
    if (br > 0) {
      qs.set("admin_branch", String(br));
    }
    const response = await axios.get(`${ADMISSION_ELIGIBILITY_API}?${qs.toString()}`, {
      timeout: ADMISSION_ELIGIBILITY_AXIOS_MS,
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch admission eligibility:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

/**
 * Saves eligibility. Without a file, sends `application/x-www-form-urlencoded` so PHP always fills `$_POST`.
 * With a file, sends multipart FormData.
 */
export const updateAdmissionEligibilityCriteria = async (
  schoolId: number,
  payload: AdmissionEligibilityCriteriaPayload,
  notificationFile: File | null,
  adminBranchHint?: number,
) => {
  try {
    const branch = adminBranchHint ?? schoolId;
    if (notificationFile) {
      const formData = new FormData();
      formData.append("action", "update_eligibility");
      formData.append("school_id", String(schoolId));
      formData.append("admin_branch", String(branch));
      ADMISSION_ELIGIBILITY_NUMERIC_KEYS.forEach((key) => {
        formData.append(key, payload[key] ?? "0");
      });
      formData.append("school_terms_and_conditions", payload.school_terms_and_conditions ?? "");
      formData.append("school_direct_status", payload.school_direct_status ?? "0");
      formData.append("pre_file", payload.pre_file ?? "");
      // Third arg = filename PHP sees in $_FILES (some stacks drop the file without it)
      formData.append(
        "school_terms_condition_file",
        notificationFile,
        notificationFile.name || "admission-notification.bin",
      );
      const response = await axios.post(ADMISSION_ELIGIBILITY_API, formData, {
        timeout: ADMISSION_ELIGIBILITY_AXIOS_MS,
        maxBodyLength: Infinity,
        maxContentLength: Infinity,
        headers: {
          Accept: "application/json",
        },
        transformRequest: [
          (data, headers) => {
            if (data instanceof FormData) {
              delete headers["Content-Type"];
            }
            return data;
          },
        ],
      });
      return response.data;
    }

    const body = new URLSearchParams();
    appendEligibilityPayloadToSearchParams(body, schoolId, branch, payload);
    const response = await axios.post(ADMISSION_ELIGIBILITY_API, body.toString(), {
      timeout: ADMISSION_ELIGIBILITY_AXIOS_MS,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to update admission eligibility:", error.response?.data || error.message);
    const d = error?.response?.data;
    const msg =
      typeof d === "string"
        ? d
        : typeof d?.message === "string"
          ? d.message
          : typeof error?.message === "string"
            ? error.message
            : "Failed to update admission eligibility.";
    throw { ...(typeof d === "object" && d !== null ? d : {}), message: msg };
  }
};

/**
 * Uploads the admission notification file using the same POST contract as the PHP API
 * (`action=update_eligibility` + all eligibility fields + multipart file). The server does not
 * implement a separate `upload_notification_file` action — use this helper so callers do not get 400.
 */
export const uploadAdmissionNotificationFile = async (
  schoolId: number,
  file: File,
  payload: AdmissionEligibilityCriteriaPayload,
  adminBranchHint?: number,
) => updateAdmissionEligibilityCriteria(schoolId, payload, file, adminBranchHint);

export const addTutorial = async (branchId: number, data: any) => {
    try {
        // Check if data is FormData (for file uploads) or regular object
        const isFormData = data instanceof FormData;
        
        let response;
        if (isFormData) {
            // For file uploads, use FormData with proper headers
            // Note: Don't set Content-Type header for FormData - let the browser set it with boundary
            console.log('Sending FormData to API...');
            console.log('FormData contents:');
            data.forEach((value, key) => {
                console.log(`${key}:`, value);
            });
            
            // Add additional debugging for file upload
            const fileEntry = data.get('tutorial_name');
            if (fileEntry instanceof File) {
                console.log('File being sent:', fileEntry.name, fileEntry.size, fileEntry.type);
            } else {
                console.error('No file found in FormData with key "tutorial_name"');
            }
            
            // Check all FormData entries
            console.log('All FormData entries being sent:');
            data.forEach((value, key) => {
                console.log(`${key}:`, value);
            });
            
            // Check required fields
            const requiredFields = ['admin_id', 'admin_branch', 'tutorial_title', 'tutorial_type'];
            const missingFields = requiredFields.filter(field => !data.has(field));
            
            // Special check for tutorial_uploaded_for array (sent with [] suffix)
            let hasUploadedFor = false;
            data.forEach((value, key) => {
                if (key === 'tutorial_uploaded_for[]') {
                    hasUploadedFor = true;
                }
            });
            
            if (!hasUploadedFor) {
                missingFields.push('tutorial_uploaded_for');
            }
            
            if (missingFields.length > 0) {
                console.error('Missing required fields in FormData:', missingFields);
            } else {
                console.log('All required fields present in FormData');
            }
            
            response = await api.post(`https://brainwebskills.com/edu/manage/dashboard/api_tutorials.php?admin_branch=${branchId}`, data, {
                headers: {
                    // Remove Content-Type header - browser will set it automatically for FormData
                    // But ensure we're not overriding it
                },
                // Add upload progress tracking if needed
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.total) {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        console.log('Upload progress:', percentCompleted);
                    }
                },
                // Add timeout for large files
                timeout: 60000, // 60 seconds timeout
                // Ensure we're sending the correct content type
                transformRequest: [(data) => {
                    // Don't transform FormData - let it be sent as multipart/form-data
                    return data;
                }]
            });
        } else {
            // For regular data (JSON), use default headers
            console.log('Sending JSON data to API:', data);
            response = await api.post(`/manage/dashboard/api_tutorials.php?admin_branch=${branchId}`, data);
        }
        
        console.log('API Response:', response.data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to add tutorial:", error.response?.data || error.message);
        // Return a more structured error object
        if (error.response?.data) {
            throw error.response.data;
        } else if (error.message) {
            throw { status: 'error', message: error.message };
        } else {
            throw { status: 'error', message: 'Failed to add tutorial' };
        }
    }
}

export const updateTutorial = async (branchId: number, data: any) => {
    try {
        const response = await api.put(`/manage/dashboard/api_tutorials.php?admin_branch=${branchId}`, data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update tutorial:", error.response?.data || error.message);
        // Return a more structured error object
        if (error.response?.data) {
            throw error.response.data;
        } else if (error.message) {
            throw { success: false, message: error.message };
        } else {
            throw { success: false, message: 'Failed to update tutorial' };
        }
    }
}

export const deleteTutorial = async (
    branchId: number,
    id: number,
    adminId: number,
    adminType: string
) => {
    try {
        const response = await api.delete(`/manage/dashboard/api_tutorials.php?admin_branch=${branchId}`, {
            data: { id, admin_id: adminId, admin_type: adminType }
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete tutorial:", error.response?.data || error.message);
        // Return a more structured error object
        if (error.response?.data) {
            throw error.response.data;
        } else if (error.message) {
            throw { success: false, message: error.message };
        } else {
            throw { success: false, message: 'Failed to delete tutorial' };
        }
    }
}
// Live Sessions API functions
export const fetchAllLiveSessions = async (adminId: number, adminType: string, adminBranch: number) => {
    try {
        const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api_live_sessions.php?admin_id=${adminId}&admin_type=${adminType}&admin_branch=${adminBranch}&action=list`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all live sessions:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const fetchLiveSessionSubjects = async (adminId: number, adminType: string, adminBranch: number) => {
    try {
        const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api_live_sessions.php?admin_id=${adminId}&admin_type=${adminType}&admin_branch=${adminBranch}&action=subjects`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch subjects:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const fetchLiveSessionClasses = async (adminId: number, adminType: string, adminBranch: number) => {
    try {
        const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api_live_sessions.php?admin_id=${adminId}&admin_type=${adminType}&admin_branch=${adminBranch}&action=classes`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch classes:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const fetchLiveSessionTeachers = async (adminId: number, adminType: string, adminBranch: number) => {
    try {
        const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api_live_sessions.php?admin_id=${adminId}&admin_type=${adminType}&admin_branch=${adminBranch}&action=teachers`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch teachers:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const createLiveSession = async (sessionData: {
    action: string;
    admin_id: number;
    admin_branch: number;
    admin_type: string;
    ls_subject: number;
    ls_for: string; // Send as string as expected by PHP API
    ls_meeting_teacher: number;
    ls_time: string;
    ls_meeting_topic: string;
    ls_meeting_duration: number;
    ls_meeting_agenda: string;
    ls_meeting_before_join: string; // Use ls_meeting_before_join as expected by PHP validation
    google_meet?: string; // Optional field in case PHP expects this
}) => {
    try {
        console.log("Creating live session with data:", sessionData);
        console.log("API URL:", `https://ideatrialbrainweb.com/edu/manage/dashboard/api_live_sessions.php`);
        
        // Test if we can reach the API
        console.log("Making POST request to API...");
        console.log("ls_for value being sent:", sessionData.ls_for);
        console.log("ls_meeting_before_join value being sent:", sessionData.ls_meeting_before_join);
        console.log("Validation check - ls_for format:", /^\d+-\d+-\d+(,\d+-\d+-\d+)*$/.test(sessionData.ls_for));
        console.log("Validation check - ls_meeting_before_join not empty:", !!sessionData.ls_meeting_before_join);
        console.log("Full sessionData object:", JSON.stringify(sessionData, null, 2));
        
        const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api_live_sessions.php`, sessionData);
        console.log("Create live session response:", response.data);
        
        // Check if the response indicates success
        if (response.data && response.data.success === true) {
            console.log("✅ Live session created successfully!");
        } else {
            console.log("❌ API returned success: false");
            console.log("❌ Error message:", response.data?.message);
        }
        
        return response.data;
    } catch (error: any) {
        console.error("Failed to create live session:", error.response?.data || error.message);
        console.error("Full error object:", error);
        console.error("Error response status:", error.response?.status);
        console.error("Error response headers:", error.response?.headers);
        throw error.response?.data || error;
    }
};

export const deleteLiveSessionById = async (sessionData: {
    action: string;
    admin_id: number;
    admin_branch: number;
    admin_type: string;
    id: number;
}) => {
    try {
        const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api_live_sessions.php`, sessionData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete live session:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const fetchFeesData = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-view-fees.php?branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch fees data:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};
export const getAllStudents = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-student.php?student_branch=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all students:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

interface AssignCardPayload {
    student_id: number | string;
    card_uid: string;
    card_number?: string;
    branch_id: number;
}

export const assignCardToStudent = async (payload: AssignCardPayload) => {
    try {
        const formData = new URLSearchParams();
        formData.append("student_id", String(payload.student_id));
        formData.append("card_uid", payload.card_uid);
        formData.append("card_number", payload.card_number ?? "");
        formData.append("branch_id", String(payload.branch_id));

        const response = await api.post(
            "/manage/dashboard/api-assign-card.php",
            formData.toString(),
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }
        );

        return response.data;
    } catch (error: any) {
        console.error("Failed to assign card:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Check card assignment status for multiple students
interface CheckCardStatusParams {
    branch_id: number;
    student_ids: Array<number | string>;
}

interface CardStatusResponse {
    student_id: number;
    card_status: 'Assigned' | 'Not Assigned';
    card_uid?: string | null;
    card_number?: string | null;
    created_at?: string | null;
}

/** Batch size to avoid oversized payloads and keep parallel requests bounded. */
const CHECK_CARD_STATUS_BATCH_SIZE = 100;

const fetchCardStatusBatch = async (
    branchId: number,
    studentIds: Array<number | string>
): Promise<CardStatusResponse[]> => {
    const formData = new URLSearchParams();
    formData.append("branch_id", String(branchId));
    formData.append("student_ids", JSON.stringify(studentIds));

    // Prefer POST — large student lists overflow GET URL limits (ERR_CONNECTION_CLOSED).
    const response = await api.post(
        "/manage/dashboard/api-check-card-status.php",
        formData.toString(),
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        }
    );

    if (response.data && response.data.success && Array.isArray(response.data.data)) {
        return response.data.data;
    }

    return [];
};

export const checkCardStatus = async (params: CheckCardStatusParams): Promise<CardStatusResponse[]> => {
    try {
        const studentIds = params.student_ids.filter(
            (id: number | string) =>
                id !== null && id !== undefined && String(id).trim() !== ""
        );

        if (studentIds.length === 0) {
            return [];
        }

        const batches: Array<Array<number | string>> = [];
        for (let i = 0; i < studentIds.length; i += CHECK_CARD_STATUS_BATCH_SIZE) {
            batches.push(studentIds.slice(i, i + CHECK_CARD_STATUS_BATCH_SIZE));
        }

        const batchResults = await Promise.all(
            batches.map((batch) => fetchCardStatusBatch(params.branch_id, batch))
        );

        return batchResults.flat();
    } catch (error: any) {
        console.error("Failed to check card status:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

/** Student info returned when looking up by card UID */
export interface StudentByCardInfo {
    id: number | string;
    name: string;
    class: string;
    section: string;
    roll_number: string;
    card_uid?: string;
    card_number?: string;
}

/**
 * Get student assigned to a card by card UID (e.g. when user taps card on device).
 * Uses getAllStudents + batched checkCardStatus to find the student whose card_uid matches.
 */
export const getStudentByCardUid = async (
    branchId: number,
    cardUid: string
): Promise<StudentByCardInfo | null> => {
    const trimmed = (cardUid || '').trim().toUpperCase();
    if (!trimmed) return null;

    try {
        const response = await getAllStudents(branchId);
        const rawStudents: any[] = Array.isArray(response) ? response : response?.data ?? [];
        if (!rawStudents.length) return null;

        // Fast path: student payload may already include card_uid
        const directMatch = rawStudents.find((s: any) => {
            const uid = String(s.card_uid ?? s.cardUID ?? '').trim().toUpperCase();
            return uid && uid === trimmed;
        });
        if (directMatch) {
            const name =
                directMatch.student_name ?? directMatch.name ?? directMatch.studentName ?? 'N/A';
            const className =
                directMatch.class_name ?? directMatch.class ?? directMatch.className ?? directMatch.student_class_name ?? 'N/A';
            const sectionName =
                directMatch.section_name ?? directMatch.section ?? directMatch.sectionName ?? directMatch.student_section_name ?? 'N/A';
            const rollNumber =
                directMatch.student_roll_number ?? directMatch.roll_number ?? directMatch.roll_no ?? '';

            return {
                id: directMatch.id ?? directMatch.student_id,
                name: typeof name === 'object' ? (name?.name ?? name?.label ?? 'N/A') : String(name),
                class: typeof className === 'object' ? (className?.name ?? className?.label ?? 'N/A') : String(className),
                section: typeof sectionName === 'object' ? (sectionName?.name ?? sectionName?.label ?? 'N/A') : String(sectionName),
                roll_number: String(rollNumber || '—'),
                card_uid: String(directMatch.card_uid ?? directMatch.cardUID ?? trimmed),
                card_number: directMatch.card_number ?? directMatch.cardNumber ?? undefined,
            };
        }

        const studentIds = rawStudents.map((s: any) =>
            String(s.id ?? s.student_id ?? s.studentId ?? s.studentID ?? '')
        ).filter(Boolean);

        // Sequential batches so we can stop as soon as the UID matches
        let match: CardStatusResponse | undefined;
        for (let i = 0; i < studentIds.length; i += CHECK_CARD_STATUS_BATCH_SIZE) {
            const batch = studentIds.slice(i, i + CHECK_CARD_STATUS_BATCH_SIZE);
            const cardStatuses = await fetchCardStatusBatch(branchId, batch);
            match = cardStatuses.find(
                (s) => (s.card_uid || '').trim().toUpperCase() === trimmed
            );
            if (match) break;
        }

        if (!match) return null;

        const student = rawStudents.find((s: any) => {
            const id = String(s.id ?? s.student_id ?? s.studentId ?? s.studentID ?? '');
            return id === String(match!.student_id);
        });
        if (!student) return null;

        const name =
            student.student_name ?? student.name ?? student.studentName ?? 'N/A';
        const className =
            student.class_name ?? student.class ?? student.className ?? student.student_class_name ?? 'N/A';
        const sectionName =
            student.section_name ?? student.section ?? student.sectionName ?? student.student_section_name ?? 'N/A';
        const rollNumber =
            student.student_roll_number ?? student.roll_number ?? student.roll_no ?? '';

        return {
            id: student.id ?? student.student_id ?? match.student_id,
            name: typeof name === 'object' ? (name?.name ?? name?.label ?? 'N/A') : String(name),
            class: typeof className === 'object' ? (className?.name ?? className?.label ?? 'N/A') : String(className),
            section: typeof sectionName === 'object' ? (sectionName?.name ?? sectionName?.label ?? 'N/A') : String(sectionName),
            roll_number: String(rollNumber || '—'),
            card_uid: match.card_uid ?? undefined,
            card_number: match.card_number ?? undefined,
        };
    } catch (error: any) {
        console.error("Failed to get student by card UID:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

interface GetAttendanceDataParams {
    branch_id: number;
    class_id: number;
    section_id: number;
    start_date?: string;
    end_date?: string;
}

export const getCardAttendanceData = async (params: GetAttendanceDataParams) => {
    try {
        const queryParams = new URLSearchParams();
        queryParams.append("branch_id", String(params.branch_id));
        queryParams.append("class_id", String(params.class_id));
        queryParams.append("section_id", String(params.section_id));
        
        if (params.start_date) {
            queryParams.append("start_date", params.start_date);
        }
        if (params.end_date) {
            queryParams.append("end_date", params.end_date);
        }

        const response = await api.get(
            `/manage/dashboard/api-card-attendance-list.php?${queryParams.toString()}`
        );

        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch attendance data:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

interface UpdateAttendanceNoteParams {
    log_id?: number;
    student_id: number;
    notes: string;
}

export const updateAttendanceNote = async (params: UpdateAttendanceNoteParams) => {
    try {
        const formData = new URLSearchParams();
        if (params.log_id) {
            formData.append("log_id", String(params.log_id));
        }
        formData.append("student_id", String(params.student_id));
        formData.append("notes", params.notes || "");

        const response = await api.post(
            `/manage/dashboard/api-card-attendance-update-note.php`,
            formData.toString(),
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }
        );

        return response.data;
    } catch (error: any) {
        console.error("Failed to update attendance note:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export interface CardAttendanceTimeSettings {
    presentFromTime: string;
    lateAfterTime: string;
}

const DEFAULT_CARD_ATTENDANCE_TIME_SETTINGS: CardAttendanceTimeSettings = {
    presentFromTime: "08:00",
    lateAfterTime: "10:45",
};

const normalizeCardAttendanceTimeSettings = (
    data: Partial<CardAttendanceTimeSettings> | null | undefined
): CardAttendanceTimeSettings => ({
    presentFromTime: data?.presentFromTime || DEFAULT_CARD_ATTENDANCE_TIME_SETTINGS.presentFromTime,
    lateAfterTime: data?.lateAfterTime || DEFAULT_CARD_ATTENDANCE_TIME_SETTINGS.lateAfterTime,
});

export const getCardAttendanceTimeSettings = async (branchId: number) => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-card-attendance-time-settings.php?branch_id=${branchId}`
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch attendance time settings:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const saveCardAttendanceTimeSettings = async (
    branchId: number,
    settings: CardAttendanceTimeSettings
) => {
    try {
        const formData = new URLSearchParams();
        formData.append("branch_id", String(branchId));
        formData.append("present_from_time", settings.presentFromTime);
        formData.append("late_after_time", settings.lateAfterTime);

        const response = await api.post(
            `/manage/dashboard/api-card-attendance-time-settings.php`,
            formData.toString(),
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }
        );

        return response.data;
    } catch (error: any) {
        console.error("Failed to save attendance time settings:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export { DEFAULT_CARD_ATTENDANCE_TIME_SETTINGS, normalizeCardAttendanceTimeSettings };

export interface BranchDeviceWifiCredentials {
    branch_id: number;
    wifi_ssid: string;
    wifi_password: string;
    exists?: boolean;
}

export const getBranchDeviceWifiCredentials = async (branchId: number) => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-branch-device-wifi.php?branch_id=${branchId}`
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch branch device WiFi credentials:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export interface DeviceErrorLogEntry {
    id: number;
    device_id: string;
    card_uid: string | null;
    error_source: string;
    log_level: string;
    error_message: string;
    created_at: string;
}

interface GetDeviceErrorLogParams {
    device_id?: string;
    log_level?: string;
    since_id?: number;
    limit?: number;
    offset?: number;
    order?: "asc" | "desc";
}

export const getDeviceErrorLog = async (params: GetDeviceErrorLogParams = {}) => {
    try {
        const queryParams = new URLSearchParams();
        if (params.device_id) {
            queryParams.append("device_id", params.device_id);
        }
        if (params.log_level) {
            queryParams.append("log_level", params.log_level);
        }
        if (params.since_id !== undefined) {
            queryParams.append("since_id", String(params.since_id));
        }
        if (params.limit !== undefined) {
            queryParams.append("limit", String(params.limit));
        }
        if (params.offset !== undefined) {
            queryParams.append("offset", String(params.offset));
        }
        if (params.order) {
            queryParams.append("order", params.order);
        }

        const query = queryParams.toString();
        const response = await api.get(
            `/manage/dashboard/api-device-error-log.php${query ? `?${query}` : ""}`
        );

        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch device serial log:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

interface GetStudentAttendanceParams {
    student_id: number;
    start_date?: string;
    end_date?: string;
}

export const getStudentAttendance = async (params: GetStudentAttendanceParams) => {
    try {
        const queryParams = new URLSearchParams();
        queryParams.append("student_id", String(params.student_id));
        
        if (params.start_date) {
            queryParams.append("start_date", params.start_date);
        }
        if (params.end_date) {
            queryParams.append("end_date", params.end_date);
        }

        const response = await api.get(
            `/manage/dashboard/api-student-attendance.php?${queryParams.toString()}`
        );

        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch student attendance:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

interface GetAttendanceAnalyticsParams {
    branch_id: number;
    class_id: number;
    section_id: number;
    start_date?: string;
    end_date?: string;
}

export const getAttendanceAnalytics = async (params: GetAttendanceAnalyticsParams) => {
    try {
        const queryParams = new URLSearchParams();
        queryParams.append("branch_id", String(params.branch_id));
        queryParams.append("class_id", String(params.class_id));
        queryParams.append("section_id", String(params.section_id));
        
        if (params.start_date) {
            queryParams.append("start_date", params.start_date);
        }
        if (params.end_date) {
            queryParams.append("end_date", params.end_date);
        }

        const response = await api.get(
            `/manage/dashboard/api-attendance-analytics.php?${queryParams.toString()}`
        );

        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch attendance analytics:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const getUserTimetable = async (branchId: number, classId: string, section: string) => {
    try {
        const response = await api.get(`/manage/dashboard/api-timetable.php?branch_id=${branchId}&class_id=${classId}&section=${section}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch user timetable:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

/** XI–XII routinexi screen — separate timetable endpoint */
export const getUserTimetableXi = async (branchId: number, classId: string, section: string) => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-timetablexi.php?branch_id=${branchId}&class_id=${classId}&section=${section}`
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch XI timetable:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Get all timetables for a branch (for teacher conflict checking)
export const getAllBranchTimetables = async (branchId: number) => {
    try {
        // Use custom endpoint to get all timetables for conflict checking
        const response = await fetch(
            `https://ideatrialbrainweb.com/edu/manage/dashboard/api-all-timetables.php?branch_id=${branchId}`
        );
        
        if (!response.ok) {
            console.warn("All timetables endpoint not available");
            return [];
        }
        
        return await response.json();
    } catch (error: any) {
        console.warn("Failed to fetch all branch timetables:", error);
        return [];
    }
};

export const fetchAllNotices = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-notice.php?branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all notices:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

export const getUserRoutineByTeacher = async (branchId: number, routineDay: string, teacherName: string) => {
    try {
        const response = await api.get(`/manage/dashboard/api-timetable2.php?branch_id=${branchId}&day=${routineDay}&teacher=${teacherName}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch user routine by teacher:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const getProvisionalRoutineByTeacher = async (branchId: number, date: string, teacherName: string) => {
    try {
        const response = await api.get(`/manage/dashboard/api-provisional-filter.php?branch_id=${branchId}&day=${date}&teacher=${teacherName}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch provisional routine by teacher:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

const normalizeRoutineList = (data: unknown): any[] => {
    if (Array.isArray(data)) {
        return data;
    }

    if (data && typeof data === "object") {
        const payload = data as { data?: unknown; routines?: unknown; error?: unknown };
        if (Array.isArray(payload.data)) {
            return payload.data;
        }
        if (Array.isArray(payload.routines)) {
            return payload.routines;
        }
        if (payload.error) {
            return [];
        }

        const values = Object.values(payload).filter(
            (value) => value && typeof value === "object" && "period_number" in (value as object)
        );
        if (values.length > 0) {
            return values;
        }
    }

    return [];
};

export const getUserRoutineByStudent = async (branchId: number, routineDay: string, className: string, sectionName: string) => {
    try {
        const response = await api.get(`/manage/dashboard/api-timetable3.php?branch_id=${branchId}&day=${routineDay}&class_id=${className}&section_id=${sectionName}`);
        return normalizeRoutineList(response.data);
    } catch (error: any) {
        console.error("Failed to fetch user routine by student:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}
// pdf page
export const fetchFeesInvoice = async (paymentId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-fees-invoice.php?payment_id=${paymentId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch fees invoice:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};
// list
export const fetchFeesInvoiceList = async (
    branchId: number,
    fromDate: string,
    toDate: string
) => {
    try {
        const response = await api.get('/manage/dashboard/api-fees-received.php', {
            params: {
                branch_id: branchId,
                from_date: fromDate,
                to_date: toDate,
            },
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch fees receipts:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

//events 
export const fetchEvents = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-events.php?branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch events:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};
export const createEvent = async (branchId: number, eventData: Partial<Event>): Promise<Event> => {
    try {
        const response = await api.post(`/manage/dashboard/api-events.php?branch_id=${branchId}`, eventData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update event:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};
export const updateEvent = async (branchId: number, eventData: Partial<Event>): Promise<Event> => {
    try {
        const response = await api.put(`/manage/dashboard/api-events.php?branch_id=${branchId}`, eventData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update event:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

// Delete an event by ID
export const deleteEvent = async (branchId: number, eventId: string): Promise<void> => {
    try {
        await api.delete(`/manage/dashboard/api-events.php?branch_id=${branchId}`, {
            data: { id: eventId }, // Send `id` in the JSON body
        });
    } catch (error: any) {
        console.error("Failed to delete event:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};
//study topic
export const fetchStudy = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api_study_topic.php?admin_branch=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch study topic:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

// Define StudyMaterialInput type if not imported
type StudyMaterialInput = {
    topic: string;
    subject_id: number;
    class_id: number;
    section_id: number;
    upload_date: string;
    uploaded_by: number;
    id?: number; // For updates
    update_date?: string; // For updates
    [key: string]: any; // Adjust fields as per your actual data structure
};

export const createStudy = async (branchId: number, data: StudyMaterialInput): Promise<{ message: string; id: number }> => {
    try {
        console.log('createStudy called with branchId:', branchId);
        console.log('createStudy called with data:', data);
        const response = await api.post(`/manage/dashboard/api_study_topic.php?admin_branch=${branchId}`, data);
        return response.data;
    } catch (error: any) {
        console.error('Failed to create study material:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Update an existing study material
export const updateStudy = async (
    branchId: number,
    id: number,
    data: StudyMaterialInput
): Promise<{ message: string }> => {
    try {
        const response = await api.put(`/manage/dashboard/api_study_topic.php?admin_branch=${branchId}`, { id, ...data });
        return response.data;
    } catch (error: any) {
        console.error('Failed to update study material:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Delete a study material
export const deleteStudy = async (branchId: number, id: number): Promise<{ message: string }> => {
    try {
        const response = await api.delete(`/manage/dashboard/api_study_topic.php?admin_branch=${branchId}`, {
            data: { id },
        });
        return response.data;
    } catch (error: any) {
        console.error('Failed to delete study material:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};
// timetable
export const getProvisionalTimetable = async (branchId: number, classId: string, section: string, date: string) => {
    try {
        const response = await api.get(`/manage/dashboard/api-provisional-timetable.php`, {
            params: {
                branch_id: branchId,
                class_id: classId,
                section: section,
                date: date
            }
        });
        return response.data;
    } catch (error: any) {
        console.error('Error fetching provisional timetable:', error);
        // Return empty array if no data found instead of throwing error
        if (error.response?.status === 404) {
            return [];
        }
        throw error;
    }
};

// In your user.api.ts file
export const updateProvisionalChange = async (id: number, data: any) => {
    try {
        // Send as POST with _method override if PUT is not supported
        const response = await api.post(`/manage/dashboard/api-provisional-timetable.php`,
            { id, ...data, _method: 'PUT' },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error: any) {
        console.error('Error updating provisional change:', error);
        // Show user-friendly error message
        const errorMessage = error.response?.data?.error || error.message || 'Failed to update timetable';
        throw new Error(errorMessage);
    }
};

export const createProvisionalChange = async (data: any) => {
    try {
        const response = await api.post(`/manage/dashboard/api-provisional-timetable.php`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error: any) {
        console.error('Error creating provisional change:', error);
        const errorMessage = error.response?.data?.error || error.message || 'Failed to create provisional change';
        throw new Error(errorMessage);
    }
};

export const deleteProvisionalChange = async (id: number) => {
    try {
        // Send as POST with _method override if DELETE is not supported
        const response = await api.post(`/manage/dashboard/api-provisional-timetable.php`, 
            { id, _method: 'DELETE' },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error: any) {
        console.error('Error deleting provisional change:', error);
        const errorMessage = error.response?.data?.error || error.message || 'Failed to delete provisional change';
        throw new Error(errorMessage);
    }
};

export const fetchAllExpenses = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-expense.php?branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch expenses:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};
export const fetchAllIncomes = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-income.php?branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch incomes:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const fetchIncomeCategories = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-income.php?resource=categories&branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch income categories:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const fetchIncomeSubcategories = async (categoryId: number, branchId: number) => {
    try {
        const response = await api.post(`/manage/dashboard/api-income.php?resource=subcategories`, {
            category_id: categoryId,
            branch_id: branchId
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch income subcategories:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const addIncome = async (incomeData: {
    income_name: string;
    category_id: number;
    subcategory_id: number;
    description: string;
    source: string;
    income_date: string;
    amount: number;
    payment_method: string;
    created_by?: number; // Made optional
    branch_id: string;
    invoice_no?: string;
}) => {
    const response = await api.post('/manage/dashboard/api-income.php?resource=incomes', incomeData);
    return response.data;
};

export const updateIncome = async (id: number, incomeData: {
    income_name: string;
    category_id: number;
    subcategory_id: number;
    description: string;
    source: string;
    income_date: string;
    amount: number;
    payment_method: string;
    branch_id: string;
    invoice_no: string;
}) => {
    const response = await api.put(`/manage/dashboard/api-income.php?resource=incomes&id=${id}`, incomeData);
    return response.data;
};

export const deleteIncome = async (id: number, branchId: string) => {
    const response = await api.delete(`/manage/dashboard/api-income.php?resource=incomes&id=${id}`, {
        data: { branch_id: branchId }
    });
    return response.data;
};

// Regular Payroll APIs (for teacher payroll)
export const fetchAllPayroll = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-Payroll.php?resource=payroll&branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch payroll data:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const createPayroll = async (payrollData: any) => {
    try {
        const response = await api.post(`/manage/dashboard/api-Payroll.php?resource=payroll`, payrollData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to create payroll:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const updatePayroll = async (id: number, payrollData: any) => {
    try {
        const response = await api.put(`/manage/dashboard/api-Payroll.php?resource=payroll&id=${id}`, payrollData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update payroll:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deletePayroll = async (id: number, branchId: number) => {
    try {
        const response = await api.delete(`/manage/dashboard/api-Payroll.php?resource=payroll&id=${id}`, {
            data: { branch_id: branchId }
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete payroll:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Casual Staff Payroll APIs (separate from regular payroll)
export const fetchAllStaffPayroll = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-staff-payroll.php?resource=payroll&branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch staff payroll data:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const createStaffPayroll = async (payrollData: any) => {
    try {
        const response = await api.post(`/manage/dashboard/api-staff-payroll.php?resource=payroll`, payrollData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to create staff payroll:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const updateStaffPayroll = async (id: number, payrollData: any) => {
    try {
        const response = await api.put(`/manage/dashboard/api-staff-payroll.php?resource=payroll&id=${id}`, payrollData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update staff payroll:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteStaffPayroll = async (id: number, branchId: number) => {
    try {
        const response = await api.delete(`/manage/dashboard/api-staff-payroll.php?resource=payroll&id=${id}`, {
            data: { branch_id: branchId }
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete staff payroll:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};
export const fetchAllStudents = async (branchId: number, classId: string, sectionId: string) => {
    try {
        const response = await api.get(`/manage/dashboard/api-filter.php?branch_id=${branchId}&class_id=${classId}&section_id=${sectionId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all students:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}
export const fetchAllStudentssubject = async (
    branchId: number,
    classId: number,
    sectionId: number,
    subject: string,
    examType: number
) => {
    try {
        const response = await api.get(`/manage/dashboard/api_student_subjects.php`, {
            params: {
                branch_id: branchId,
                class_id: classId,
                section_id: sectionId,
                subject: subject,
                exam_type: examType
            }
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch students:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const fetchAllTemplates = async () => {
    try {
        const response = await api.get(`/manage/dashboard/get_whatsapp_templates.php`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch all templates:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const sendSms = async (data: any) => {
    try {
        const response = await api.post(`/manage/dashboard/api_send_whatsapp_messages.php`, data);
        return response.data;
    } catch (error) {
        console.error('Error sending SMS:', error);
        throw error;
    }
}

export const getSmsCount = async (adminId: number, adminBranch: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-sms-count.php?admin_id=${adminId}&admin_branch=${adminBranch}`);
        return response.data;
    } catch (error: any) {
        console.error('Error fetching SMS count:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
}

export const ExpenseCategories = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-Expense_category.php?branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch expenses:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const addExpenseCategory = async (categoryData: {
    category_name: string;
    description: string;
    branch_id: string;
}) => {
    try {
        const response = await api.post(`/manage/dashboard/api-Expense_category.php?resource=expense_categories`, categoryData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to add expense category:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const updateExpenseCategory = async (id: number, categoryData: {
    category_name: string;
    description: string;
    branch_id: string;
}) => {
    try {
        const response = await api.put(`/manage/dashboard/api-Expense_category.php?resource=expense_categories&id=${id}`, categoryData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update expense category:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteExpenseCategory = async (id: number, branch_id: string) => {
    try {
        const response = await api.delete(`/manage/dashboard/api-Expense_category.php?resource=expense_categories&id=${id}`, {
            data: { branch_id }
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete expense category:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const addExpenseSubcategory = async (subcategoryData: {
    category_id: number;
    subcategory_name: string;
    description: string;
    branch_id: string;
}) => {
    try {
        const response = await api.post(`/manage/dashboard/api-Expense_category.php?resource=expense_subcategories`, subcategoryData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to add expense subcategory:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const updateExpenseSubcategory = async (id: number, subcategoryData: {
    category_id: number;
    subcategory_name: string;
    description: string;
    branch_id: string;
}) => {
    try {
        const response = await api.put(`/manage/dashboard/api-Expense_category.php?resource=expense_subcategories&id=${id}`, subcategoryData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update expense subcategory:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteExpenseSubcategory = async (id: number, branch_id: string) => {
    try {
        const response = await api.delete(`/manage/dashboard/api-Expense_category.php?resource=expense_subcategories&id=${id}`, {
            data: { branch_id }
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete expense subcategory:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const getExpenseSubcategories = async (categoryId: number, branchId: number) => {
    try {
        console.log("Attempting to fetch subcategories with categoryId:", categoryId, "branchId:", branchId);
        
        // Try multiple approaches to find the correct API endpoint
        let response;
        
        // Approach 1: Try the same pattern as ExpenseCategories (GET without resource)
        try {
            console.log("Trying approach 1: GET without resource parameter");
            response = await api.get(`/manage/dashboard/api-Expense_category.php?branch_id=${branchId}&category_id=${categoryId}&type=subcategories`);
            console.log("Approach 1 successful:", response.data);
            return response.data;
        } catch (error1: any) {
            console.log("Approach 1 failed:", error1.response?.data || error1.message);
        }
        
        // Approach 2: Try with 'subcategories' resource and GET
        try {
            console.log("Trying approach 2: GET with subcategories resource");
            response = await api.get(`/manage/dashboard/api-Expense_category.php?resource=subcategories&category_id=${categoryId}&branch_id=${branchId}`);
            console.log("Approach 2 successful:", response.data);
            return response.data;
        } catch (error2: any) {
            console.log("Approach 2 failed:", error2.response?.data || error2.message);
        }
        
        // Approach 3: Try POST with 'subcategories' resource
        try {
            console.log("Trying approach 3: POST with subcategories resource");
            response = await api.post(`/manage/dashboard/api-Expense_category.php?resource=subcategories`, {
                category_id: categoryId,
                branch_id: branchId
            });
            console.log("Approach 3 successful:", response.data);
            return response.data;
        } catch (error3: any) {
            console.log("Approach 3 failed:", error3.response?.data || error3.message);
        }
        
        // Approach 4: Try with 'expense_subcategories' resource and GET
        try {
            console.log("Trying approach 4: GET with expense_subcategories resource");
            response = await api.get(`/manage/dashboard/api-Expense_category.php?resource=expense_subcategories&category_id=${categoryId}&branch_id=${branchId}`);
            console.log("Approach 4 successful:", response.data);
            return response.data;
        } catch (error4: any) {
            console.log("Approach 4 failed:", error4.response?.data || error4.message);
        }
        
        // Approach 5: Try the original POST approach but with different parameter names
        try {
            console.log("Trying approach 5: POST with different parameter names");
            response = await api.post(`/manage/dashboard/api-Expense_category.php?resource=expense_subcategories`, {
                categoryId: categoryId,
                branchId: branchId
            });
            console.log("Approach 5 successful:", response.data);
            return response.data;
        } catch (error5: any) {
            console.log("Approach 5 failed:", error5.response?.data || error5.message);
        }
        
        // If all approaches fail, try to provide fallback data for testing
        console.warn("All API approaches failed. Providing fallback data for testing.");
        console.warn("Please check the API endpoint configuration and ensure the API supports fetching subcategories.");
        
        // Return fallback data for testing purposes
        return [
            { id: 1, subcategory_name: "Office Supplies", category_id: categoryId, branch_id: branchId },
            { id: 2, subcategory_name: "Utilities", category_id: categoryId, branch_id: branchId },
            { id: 3, subcategory_name: "Maintenance", category_id: categoryId, branch_id: branchId }
        ];
        
    } catch (error: any) {
        console.error("Failed to fetch expense subcategories:", error.response?.data || error.message);
        
        // Return fallback data even on error for testing
        console.warn("Returning fallback data due to API error");
        return [
            { id: 1, subcategory_name: "Office Supplies", category_id: categoryId, branch_id: branchId },
            { id: 2, subcategory_name: "Utilities", category_id: categoryId, branch_id: branchId },
            { id: 3, subcategory_name: "Maintenance", category_id: categoryId, branch_id: branchId }
        ];
    }
};
export const IncomeCategories = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-income_category.php?branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch expenses:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const testIncomeCategoryAPI = async () => {
    try {
        console.log('Testing income category API endpoint...');
        const response = await api.get(`/manage/dashboard/api-income_category.php?resource=income_categories&test=1`);
        console.log('API test response:', response.data);
        return response.data;
    } catch (error: any) {
        console.error("API test failed:", error);
        console.error("Error response:", error.response);
        console.error("Error status:", error.response?.status);
        throw error;
    }
};

export const addIncomeCategory = async (categoryData: {
    category_name: string;
    description: string;
    branch_id: string;
}) => {
    try {
        console.log('Sending income category data:', categoryData);
        const response = await api.post(`/manage/dashboard/api-income_category.php?resource=income_categories`, categoryData);
        console.log('Income category response:', response.data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to add income category:", error);
        console.error("Error response:", error.response);
        console.error("Error data:", error.response?.data);
        console.error("Error status:", error.response?.status);
        
        // Handle different types of errors
        if (error.response?.status === 500) {
            throw { error: 'Server error: Please check if the income categories table exists and the API is properly configured' };
        } else if (error.response?.status === 404) {
            throw { error: 'API endpoint not found. Please check the API URL configuration' };
        } else if (error.response?.status === 403) {
            throw { error: 'Access denied. Please check your permissions' };
        } else if (error.response?.data?.error) {
            throw error.response.data;
        } else if (error.message) {
            throw { error: error.message };
        } else {
            throw { error: 'Failed to add income category. Please try again.' };
        }
    }
};

export const updateIncomeCategory = async (id: number, categoryData: {
    category_name: string;
    description: string;
    branch_id: string;
}) => {
    try {
        console.log('Updating income category:', id, categoryData);
        const response = await api.put(`/manage/dashboard/api-income_category.php?resource=income_categories&id=${id}`, categoryData);
        console.log('Update response:', response.data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update income category:", error);
        console.error("Error response:", error.response);
        console.error("Error data:", error.response?.data);
        console.error("Error status:", error.response?.status);
        
        // Handle different types of errors
        if (error.response?.status === 500) {
            throw { error: 'Server error: Please check if the income categories table exists and the API is properly configured' };
        } else if (error.response?.status === 404) {
            throw { error: 'API endpoint not found or category not found' };
        } else if (error.response?.status === 403) {
            throw { error: 'Access denied. Please check your permissions' };
        } else if (error.response?.data?.error) {
            throw error.response.data;
        } else if (error.message) {
            throw { error: error.message };
        } else {
            throw { error: 'Failed to update income category. Please try again.' };
        }
    }
};

export const deleteIncomeCategory = async (id: number, branch_id: string) => {
    try {
        console.log('Deleting income category:', id, 'branch:', branch_id);
        const response = await api.delete(`/manage/dashboard/api-income_category.php?resource=income_categories&id=${id}`, {
            data: { branch_id }
        });
        console.log('Delete response:', response.data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete income category:", error);
        console.error("Error response:", error.response);
        console.error("Error data:", error.response?.data);
        console.error("Error status:", error.response?.status);
        
        // Handle different types of errors
        if (error.response?.status === 500) {
            throw { error: 'Server error: Please check if the income categories table exists and the API is properly configured' };
        } else if (error.response?.status === 404) {
            throw { error: 'API endpoint not found or category not found' };
        } else if (error.response?.status === 403) {
            throw { error: 'Access denied. Please check your permissions' };
        } else if (error.response?.data?.error) {
            throw error.response.data;
        } else if (error.message) {
            throw { error: error.message };
        } else {
            throw { error: 'Failed to delete income category. Please try again.' };
        }
    }
};

export const addIncomeSubcategory = async (subcategoryData: {
    category_id: number;
    subcategory_name: string;
    description: string;
    branch_id: string;
}) => {
    try {
        console.log('Adding income subcategory:', subcategoryData);
        const response = await api.post(`/manage/dashboard/api-income_category.php?resource=income_subcategories`, subcategoryData);
        console.log('Subcategory response:', response.data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to add income subcategory:", error);
        console.error("Error response:", error.response);
        console.error("Error data:", error.response?.data);
        console.error("Error status:", error.response?.status);
        
        // Handle different types of errors
        if (error.response?.status === 500) {
            throw { error: 'Server error: Please check if the income subcategories table exists and the API is properly configured' };
        } else if (error.response?.status === 404) {
            throw { error: 'API endpoint not found. Please check the API URL configuration' };
        } else if (error.response?.status === 403) {
            throw { error: 'Access denied. Please check your permissions' };
        } else if (error.response?.data?.error) {
            throw error.response.data;
        } else if (error.message) {
            throw { error: error.message };
        } else {
            throw { error: 'Failed to add income subcategory. Please try again.' };
        }
    }
};

export const updateIncomeSubcategory = async (id: number, subcategoryData: {
    category_id: number;
    subcategory_name: string;
    description: string;
    branch_id: string;
}) => {
    try {
        const response = await api.put(`/manage/dashboard/api-income_category.php?resource=income_subcategories&id=${id}`, subcategoryData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update income subcategory:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteIncomeSubcategory = async (id: number, branch_id: string) => {
    try {
        const response = await api.delete(`/manage/dashboard/api-income_category.php?resource=income_subcategories&id=${id}`, {
            data: { branch_id }
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete income subcategory:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const fetchExaminations = async (adminBranchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-examination.php?admin_branch=${adminBranchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch examinations:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};
export const fetchImageUploadData = async (adminBranchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-imageupload.php?admin_branch=${adminBranchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch image upload data:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const uploadImageUploadData = async (formData: FormData, adminBranchId: number) => {
    try {
        const response = await api.post(`/manage/dashboard/api-imageupload.php?admin_branch=${adminBranchId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to upload image:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
}

export const uploadPrincipalImageData = async (formData: FormData, adminBranchId: number) => {
    try {
        const response = await api.post(`https://brainwebskills.com/edu/api-upload-principal-image.php?admin_branch=${adminBranchId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to upload principal image:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
}

// Alternative API call for principal image upload (direct to the working endpoint)
export const uploadPrincipalImageDirect = async (formData: FormData, adminBranchId: number) => {
    try {
        const response = await api.post(`https://brainwebskills.com/edu/api-upload-principal-image.php?admin_branch=${adminBranchId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to upload principal image (direct):", error.response?.data || error.message);
        throw error.response?.data || error;
    }
}
// Storage limit constant (15GB in bytes)
export const BRANCH_STORAGE_LIMIT = 15 * 1024 * 1024 * 1024; // 15GB

// Get branch storage usage
export const getBranchStorage = async (branchId: number) => {
    try {
        // Support both parameter names for compatibility
        const response = await api.get(`https://brainwebskills.com/edu/manage/dashboard/api-branch-storage.php?branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch branch storage:", error.response?.data || error.message);
        // If API doesn't exist yet, return default values
        if (error.response?.status === 404) {
            return {
                status: "success",
                data: {
                    used_storage: 0,
                    storage_limit: BRANCH_STORAGE_LIMIT,
                    used_percentage: 0
                }
            };
        }
        throw error.response?.data || error;
    }
};

// Update/recalculate branch storage (forces recalculation on backend)
// Only recalculates when recalculate=true, otherwise just returns database value
export const updateBranchStorage = async (branchId: number, recalculate: boolean = true) => {
    try {
        console.log("Updating branch storage for branch:", branchId, "recalculate:", recalculate);
        const response = await api.post(`https://brainwebskills.com/edu/manage/dashboard/api-branch-storage.php`, {
            branch_id: branchId,
            recalculate: recalculate
        }, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        console.log("Storage update response:", response.data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update branch storage:", error.response?.data || error.message);
        // On error, still try to get current storage
        console.log("Falling back to getBranchStorage");
        return await getBranchStorage(branchId);
    }
};

// Check if file upload would exceed storage limit
export const checkStorageLimit = async (branchId: number, fileSize: number) => {
    try {
        const storageData = await getBranchStorage(branchId);
        const currentUsed = storageData.data?.used_storage || 0;
        const newTotal = currentUsed + fileSize;
        
        if (newTotal > BRANCH_STORAGE_LIMIT) {
            const available = BRANCH_STORAGE_LIMIT - currentUsed;
            const availableMB = (available / (1024 * 1024)).toFixed(2);
            const requiredMB = (fileSize / (1024 * 1024)).toFixed(2);
            return {
                allowed: false,
                message: `Storage limit exceeded. Available: ${availableMB} MB, Required: ${requiredMB} MB. Branch storage limit is 15GB.`,
                currentUsed,
                fileSize,
                available
            };
        }
        
        return {
            allowed: true,
            currentUsed,
            fileSize,
            newTotal,
            available: BRANCH_STORAGE_LIMIT - currentUsed
        };
    } catch (error: any) {
        console.error("Failed to check storage limit:", error);
        // On error, allow upload but log warning
        return {
            allowed: true,
            warning: "Could not verify storage limit. Upload may proceed."
        };
    }
};

export const fetchsignUploadData = async (adminBranchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-signupload.php?admin_branch=${adminBranchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch image upload data:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const uploadsignUploadData = async (formData: FormData, adminBranchId: number) => {
    try {
        const response = await api.post(`/manage/dashboard/api-signupload.php?admin_branch=${adminBranchId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to upload image:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
}

export const fetchWebpageData = async (branchId: number) => {
    const response = await fetch(`https://brainwebskills.com/edu/manage/dashboard/api-webpage-cms.php?admin_branch=${branchId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return await response.json();
};

export const updateWebpageData = async (formData: FormData) => {
    const response = await fetch(`https://brainwebskills.com/edu/manage/dashboard/api-webpage-cms.php`, {
        method: 'POST',
        body: formData,
    });
    return await response.json();
};



export const getClassSection = async (branchId: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-class_section.php?branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch class sections:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

// Define AddLiveSessionPayload type if not imported
type AddLiveSessionPayload = {
    // Add the required fields for a live session payload
    title: string;
    date: string;
    startTime: string;
    endTime: string;
    [key: string]: any; // Adjust as per your actual payload structure
};

// Define ApiResponse type if not imported
type ApiResponse<T> = {
    success: boolean;
    data: T;
    message?: string;
};

export const addLiveSession = async (payload: AddLiveSessionPayload): Promise<ApiResponse<{ id: number }>> => {
    try {
        const response = await api.post('/manage/dashboard/api_live_sessions.php', payload);
        return response.data;
    } catch (error: any) {
        console.error("Failed to add live session:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const updateLiveSession = async (payload: AddLiveSessionPayload): Promise<ApiResponse<null>> => {
    try {
        const response = await api.post('/manage/dashboard/api_live_sessions.php', payload);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update live session:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteLiveSession = async (id: number): Promise<ApiResponse<null>> => {
    try {
        const response = await api.delete('/api_live_sessions.php', { data: { id } });
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete live session:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const addNotice = async (noticeData: {
    notice_title: string;
    notice_description: string;
    notice_branch: number;
    notice_uploaded_for: string[];
    notice_uploaded_by: number;
}) => {
    try {
        const response = await api.post(`/manage/dashboard/api-notice.php?branch_id=${noticeData.notice_branch}`, noticeData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to add notice:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};
export const updateNotice = async (notice_branch: number, noticeData: {
    id: number;
    notice_title: string;
    notice_description: string;
    notice_uploaded_for: string[];
}) => {
    try {
        const response = await api.put(`/manage/dashboard/api-notice.php?branch_id=${notice_branch}`, noticeData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update notice:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};
export const deleteNotice = async (id: number) => {
    try {
        const response = await api.delete('/manage/dashboard/api-notice.php', {
            data: { id },
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete notice:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const addMarks = async (branchId: number, classId: number, sectionId: number, subject: string, examType: number, body: any) => {
    try {
        const response = await api.post(`/manage/dashboard/api-marks.php?student_branch=${branchId}&student_class=${classId}&student_section=${sectionId}&subject=${subject}&exam_type=${examType}`, body);
        return response.data;
    } catch (error: any) {
        console.error("Failed to add marks:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

export const teacheraddMarks = async (branchId: number, classId: number, sectionId: number, subject: string, examType: number, body: any, adminTeachingSubject?: string) => {
    try {
        const params = new URLSearchParams({
            admin_branch: branchId.toString(),
            student_class: classId.toString(),
            student_section: sectionId.toString(),
            subject: subject,
            exam_type: examType.toString()
        });
        
        // Add admin_teaching_subject if provided
        if (adminTeachingSubject) {
            params.append('admin_teaching_subject', adminTeachingSubject);
        }
        
        const response = await api.post(`/manage/dashboard/api-teachermarks.php?${params.toString()}`, body);
        return response.data;
    } catch (error: any) {
        console.error("Failed to add marks:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

export const viewMarksheet = async (body: any) => {
    try {
        const response = await api.post(`/manage/dashboard/api-marksheet.php`, body);
        return response.data;

    } catch (error: any) {
        console.error("Failed to view marksheet:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}


export const cumMarksheetstuxi = async (studentId: number, adminBranch: number) => {
    try {
        console.log('Making API call to:', `https://ideatrialbrainweb.com/edu/dashboard/api-cumulative_marks.php?student_id=${studentId}&admin_branch=${adminBranch}`);
        
        // Try using the existing API instance first
        try {
            const response = await api.get(
                `/dashboard/api-cumulative_marks.php?student_id=${studentId}&admin_branch=${adminBranch}`
            );
            console.log('API Response (using api instance):', response);
            return response.data;
        } catch (apiError) {
            console.log('API instance failed, trying direct axios call');
            
            // Fallback to direct axios call
            const response = await axios.get(
                `https://ideatrialbrainweb.com/edu/dashboard/api-cumulative_marks.php?student_id=${studentId}&admin_branch=${adminBranch}`,
                {
                    timeout: 10000,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
            );
            
            console.log('API Response (direct axios):', response);
            console.log('API Response Data:', response.data);
            
            return response.data;
        }
    } catch (error: any) {
        console.error("Failed to fetch cumulative marksheet:", error);
        console.error("Error response:", error.response?.data);
        console.error("Error status:", error.response?.status);
        throw error.response?.data || error;
    }
}

export const cumMarksheetstux = async (studentId: number, adminBranch: number) => {
    try {
        console.log('Making API call to:', `https://ideatrialbrainweb.com/edu/dashboard/api-cumulative_marks2.php?student_id=${studentId}&admin_branch=${adminBranch}`);
        
        // Try using the existing API instance first
        try {
            const response = await api.get(
                `/dashboard/api-cumulative_marks2.php?student_id=${studentId}&admin_branch=${adminBranch}`
            );
            console.log('API Response (using api instance):', response);
            return response.data;
        } catch (apiError) {
            console.log('API instance failed, trying direct axios call');
            
            // Fallback to direct axios call
            const response = await axios.get(
                `https://ideatrialbrainweb.com/edu/dashboard/api-cumulative_marks2.php?student_id=${studentId}&admin_branch=${adminBranch}`,
                {
                    timeout: 10000,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
            );
            
            console.log('API Response (direct axios):', response);
            console.log('API Response Data:', response.data);
            
            return response.data;
        }
    } catch (error: any) {
        console.error("Failed to fetch cumulative marksheet:", error);
        console.error("Error response:", error.response?.data);
        console.error("Error status:", error.response?.status);
        throw error.response?.data || error;
    }
}

export const cumMarksheetstu = async (studentId: number, adminBranch: number) => {
    try {
        console.log('Making API call to:', `https://ideatrialbrainweb.com/edu/dashboard/api-cumulative_marks1.php?student_id=${studentId}&admin_branch=${adminBranch}`);
        
        // Try using the existing API instance first
        try {
            const response = await api.get(
                `/dashboard/api-cumulative_marks1.php?student_id=${studentId}&admin_branch=${adminBranch}`
            );
            console.log('API Response (using api instance):', response);
            return response.data;
        } catch (apiError) {
            console.log('API instance failed, trying direct axios call');
            
            // Fallback to direct axios call
            const response = await axios.get(
                `https://ideatrialbrainweb.com/edu/dashboard/api-cumulative_marks1.php?student_id=${studentId}&admin_branch=${adminBranch}`,
                {
                    timeout: 10000,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
            );
            
            console.log('API Response (direct axios):', response);
            console.log('API Response Data:', response.data);
            
            return response.data;
        }
    } catch (error: any) {
        console.error("Failed to fetch cumulative marksheet:", error);
        console.error("Error response:", error.response?.data);
        console.error("Error status:", error.response?.status);
        throw error.response?.data || error;
    }
}

export const cumMarksheet = async (studentId: number) => {
    try {
        // Use absolute URL instead of relative path
        const response = await api.get(
            `/manage/dashboard/api-cumulative_marks.php?id=${studentId}`
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch cumulative marksheet:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
}
export const cumMarksheetx = async (studentId: number) => {
    try {
        // Use absolute URL instead of relative path
        const response = await api.get(
            `/manage/dashboard/api-cumulative_marks2.php?id=${studentId}`
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch cumulative marksheet:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
}
export const cumMarksheetxi = async (studentId: number) => {
    try {
        // Use absolute URL instead of relative path
        const response = await api.get(
            `/manage/dashboard/api-cumulative_marks3.php?id=${studentId}`
        );
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch cumulative marksheet:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
}
export const viewMarksheetx = async (body: any) => {
    try {
        const response = await api.post(`/manage/dashboard/api-marksheet2.php`, body);
        return response.data;

    } catch (error: any) {
        console.error("Failed to view marksheet:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}
export const viewMarksheetxi = async (body: any) => {
    try {
        const response = await api.post(`/manage/dashboard/api-marksheet3.php`, body);
        return response.data;

    } catch (error: any) {
        console.error("Failed to view marksheet:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}
export const publishResults = async (
    branchId: number,
    classId: number,
    sectionId: number,
    examType: number
) => {
    try {
        const payload = new URLSearchParams({
            branch_id: String(branchId),
            student_class: String(classId),
            student_section: String(sectionId),
            exam_type: String(examType),
        });
        console.log('Sending payload to publishResults:', payload.toString());
        const response = await api.post(
            '/manage/dashboard/api-publish-results.php',
            payload.toString(),
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );
        console.log('API response:', response.data);
        return response.data;
    } catch (error: any) {
        console.error('Failed to publish results:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const getPublishedResults = async (branchId: number) => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-publish-results.php?branch_id=${branchId}&action=list`
        );
        return response.data;
    } catch (error: any) {
        console.error('Failed to fetch published results:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const generateMarksheets = async (
    branchId: number,
    classId: number,
    sectionId: number,
    examType: number
) => {
    try {
        const payload = new URLSearchParams({
            student_branch: String(branchId),
            student_class: String(classId),
            student_section: String(sectionId),
            exam_type: String(examType),
        });
        console.log('Sending payload to generateMarksheets:', payload.toString());
        const response = await api.post(
            '/manage/dashboard/api-generate-marksheet.php',
            payload.toString(),
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );
        console.log('API response:', response.data);
        return response.data;
    } catch (error: any) {
        console.error('Failed to generate marksheets:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const bulkUploadStudents = async (
    branchId: number,
    classId: number,
    sectionId: number,
    file: File
) => {
    const formData = new FormData();
    formData.append("student_branch", branchId.toString());
    formData.append("student_class", classId.toString());
    formData.append("student_section", sectionId.toString());
    formData.append("excel_file_insert", file);

    try {
        const response = await fetch(
            "https://ideatrialbrainweb.com/edu/manage/dashboard/api-bulk-student-upload.php",
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            const text = await response.text();
            throw new Error(`HTTP error! status: ${response.status}, response: ${text}`);
        }

        const contentType = response.headers.get("Content-Type");
        if (!contentType || !contentType.includes("application/json")) {
            const text = await response.text();
            throw new Error(`Expected JSON, received: ${text}`);
        }

        const data = await response.json();

        return {
            success: data.success,
            message: data.message,
            successfulInsertions: data.successful_insertions,
            totalRows: data.total_rows,
            errors: data.errors
                ? data.errors.map((err: any) => ({
                    error: err.errors.join(", "),
                    student_roll_number: err.data.roll_number || "",
                    student_name: err.data.name || "",
                    student_sex: err.data.sex || "",
                    student_dob: err.data.dob || "",
                    student_category: err.data.category || "",
                    student_physically_challenged: err.data.physically_challenged || "",
                    student_religion: err.data.religion || "",
                    student_mobile: err.data.mobile || "",
                    student_email: err.data.email || "",
                    student_admission_date: err.data.admission_date || "",
                    student_blood_group: err.data.blood_group || "",
                    student_medical_history: err.data.medical_history || "",
                    student_kanyasree_id: err.data.kanyasree_id || "",
                    student_aadhar_number: err.data.aadhar_number || "",
                    student_previous_school: err.data.previous_school || "",
                    student_previous_marks: err.data.previous_marks || "",
                    student_father_name: err.data.father_name || "",
                    student_father_contact_number: err.data.student_father_contact_number || "",
                    student_father_occupation: err.data.father_occupation || "",
                    student_father_annual_income: err.data.father_annual_income || "",
                    student_mother_name: err.data.mother_name || "",
                    student_mother_contact_number: err.data.mother_contact_number || "",
                    student_mother_occupation: err.data.mother_occupation || "",
                    student_mother_annual_income: err.data.mother_annual_income || "",
                    student_guardian_name: err.data.guardian_name || "",
                    student_relation_with_guardian: err.data.relation_with_guardian || "",
                    student_guardian_occupation: err.data.guardian_occupation || "",
                    student_guardian_contact_number: err.data.guardian_contact_number || "",
                    student_current_address1: err.data.current_address1 || "",
                    student_current_address2: err.data.current_address2 || "",
                    student_current_city: err.data.current_city || "",
                    student_current_state: err.data.current_state || "",
                    student_current_district: err.data.current_district || "",
                    student_current_pin_code: err.data.current_pin_code || "",
                    student_permanent_address1: err.data.permanent_address1 || "",
                    student_permanent_address2: err.data.permanent_address2 || "",
                    student_permanent_city: err.data.permanent_city || "",
                    student_permanent_state: err.data.permanent_state || "",
                    student_permanent_district: err.data.permanent_district || "",
                    student_permanent_pin_code: err.data.permanent_pin_code || "",
                }))
                : [],
        };
    } catch (error) {
        console.error("Bulk upload error:", error);
        return {
            success: false,
            message: error instanceof Error ? error.message : String(error),
            successfulInsertions: 0,
            totalRows: 0,
            errors: [],
        };
    }
};



// Define TeacherBulkResponse type
type TeacherBulkResponse = {
    success: boolean;
    message: string;
    successfulInsertions?: number;
    totalRows?: number;
    errors?: Array<{
        error: string;
        [key: string]: any;
    }>;
};

// Define ErrorResponse type for error handling
type ErrorResponse = {
    message?: string;
    [key: string]: any;
};

export const bulkUploadTeachers = async (
    branchId: number,
    file: File,
    sendSms: boolean = false
): Promise<TeacherBulkResponse> => {
    const formData = new FormData();
    formData.append('excel_file_insert', file);
    formData.append('admin_branch', branchId.toString());
    formData.append('send_sms', sendSms ? '1' : '0');

    try {
        const response: AxiosResponse<TeacherBulkResponse> = await axios.post(
            'https://ideatrialbrainweb.com/edu/manage/dashboard/api-bulk_teacher_upload.php',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                timeout: 300000, // 5 minutes timeout
            }
        );

        return response.data;
    } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;

        if (axiosError.response) {
            // Server responded with error status (4xx/5xx)
            throw new Error(
                `Bulk upload failed: ${axiosError.response.data.message || 'Unknown error'}`
            );
        } else if (axiosError.request) {
            // Request was made but no response received
            throw new Error('No response received from server. Please check your network connection.');
        } else {
            // Something happened in setting up the request
            throw new Error(`Request setup error: ${axiosError.message}`);
        }
    }
};


export const bulkUploadMarks = async (
    branchId: number,
    classId: number,
    sectionId: number,
    examTypeId: number,
    file: File
) => {
    const formData = new FormData();
    formData.append('excel_file', file);  // Correct field name
    formData.append('student_branch', branchId.toString());  // Required parameter
    formData.append('student_class', classId.toString());
    formData.append('student_section', sectionId.toString());
    formData.append('exam_type', examTypeId.toString());

    try {
        const response = await axios.post(
            `https://ideatrialbrainweb.com/edu/manage/dashboard/api-marks-bulk.php`,
            formData,
            {
                headers: { 'Content-Type': 'multipart/form-data' },
                timeout: 120000,
            }
        );

        return response.data;

    } catch (error) {
        if (axios.isAxiosError(error)) {
            let errorMessage = 'Request failed';

            if (error.response) {
                // Handle structured error response
                if (error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                // Handle raw error strings
                else if (typeof error.response.data === 'string') {
                    errorMessage = error.response.data;
                }
            } else if (error.message) {
                errorMessage = error.message;
            }

            throw new Error(errorMessage);
        }

        throw new Error('Network error occurred');
    }
};
const BASE_URL = "https://brainwebskills.com/edu/manage/dashboard/api-webpage-cms.php";

// Fetch webpage details
export const getWebpageDetails = async (branchId: number): Promise<WebpageData> => {
    try {
        const response = await axios.get(`${BASE_URL}?admin_branch=${branchId}`);
        return response.data.data;
    } catch (error: any) {
        let errorMessage = "Failed to fetch webpage details.";
        if (error.code === "ERR_NETWORK") {
            errorMessage = "Network error: Unable to connect to the server. Please check your internet connection or verify the domain name.";
        } else if (error.response) {
            errorMessage = error.response.data.message || "Server error occurred.";
        }
        console.error("Failed to fetch webpage details:", error);
        throw new Error(errorMessage);
    }
};
export const updateWebpageDetails = async (
    branchId: number,
    formData: FormData
): Promise<void> => {
    try {
        formData.append("admin_branch", branchId.toString());
        const response = await axios.post(BASE_URL, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (error: any) {
        let errorMessage = "Failed to update webpage details.";
        if (error.code === "ERR_NETWORK") {
            errorMessage = "Network error: Unable to connect to the server. Please check your internet connection or verify the server URL.";
        } else if (error.response) {
            errorMessage = error.response.data.message || "Server error occurred.";
        }
        console.error("Failed to update webpage details:", error);
        throw new Error(errorMessage);
    }
};
export const deleteWebpageItem = async (
    branchId: number,
    type: "feature" | "notice",
    index: number,
    currentData?: any
): Promise<void> => {
    try {
        const formData = new FormData();
        formData.append("action", "delete");
        formData.append("admin_branch", branchId.toString());
        formData.append("type", type);
        formData.append("index", index.toString());
        
        // Add required fields if current data is provided
        if (currentData) {
            formData.append("webpage_about", currentData.about || "");
            formData.append("webpage_hm_desk", currentData.principalDesk || "");
            formData.append("webpage_address1", currentData.address1 || "");
            formData.append("webpage_address2", currentData.address2 || "");
            formData.append("webpage_email1", currentData.email1 || "");
            formData.append("webpage_email2", currentData.email2 || "");
            formData.append("webpage_phone1", currentData.phone1 || "");
            formData.append("webpage_phone2", currentData.phone2 || "");
            formData.append("pre_image", currentData.preImage || "");
        }
        
        const response = await axios.post(BASE_URL, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (error: any) {
        let errorMessage = `Failed to delete ${type}.`;
        if (error.code === "ERR_NETWORK") {
            errorMessage = `Network error: Unable to connect to the server. Please check your internet connection or verify the server URL.`;
        } else if (error.response) {
            errorMessage = error.response.data.message || "Server error occurred.";
        }
        console.error(`Failed to delete ${type}:`, error);
        throw new Error(errorMessage);
    }
};

export const getStudentDueFees = async (studentId: number) => {
    try {
        const response = await api.get(`/dashboard/api-due-fees.php?student_id=${studentId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch student due fees:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
}

// Offline Payment API for sch_fees_payment_new table
export const submitOfflinePaymentNew = async (paymentData: {
    admin_branch: number;
    payment_student: string;
    payment_fees_id: string;
    payment_fees_branch: string;
    payment_fees_class: string;
    payment_fees_section: string;
    payment_fees_title: string;
    payment_fees_amount: number;
    payment_fees_description: string;
    payment_fees_actual_amount: number;
    payment_status: string;
    razorpay_order_id?: string;
    razorpay_payment_id?: string;
    razorpay_signature?: string;
    razorpay_route_response?: string;
    payment_fees_account_razorpay?: string;
}) => {
    try {
        // Convert to FormData for PHP API
        const formData = new FormData();
        formData.append('admin_branch', paymentData.admin_branch.toString());
        formData.append('payment_student', paymentData.payment_student);
        formData.append('payment_fees_id', paymentData.payment_fees_id);
        formData.append('payment_fees_branch', paymentData.payment_fees_branch);
        formData.append('payment_fees_class', paymentData.payment_fees_class);
        formData.append('payment_fees_section', paymentData.payment_fees_section);
        formData.append('payment_fees_title', paymentData.payment_fees_title);
        formData.append('payment_fees_amount', paymentData.payment_fees_amount.toString());
        formData.append('payment_fees_description', paymentData.payment_fees_description);
        formData.append('payment_fees_actual_amount', paymentData.payment_fees_actual_amount.toString());
        formData.append('payment_status', paymentData.payment_status);
        formData.append('razorpay_order_id', paymentData.razorpay_order_id || '');
        formData.append('razorpay_payment_id', paymentData.razorpay_payment_id || '');
        formData.append('razorpay_signature', paymentData.razorpay_signature || '');
        formData.append('razorpay_route_response', paymentData.razorpay_route_response || '');
        formData.append('payment_fees_account_razorpay', paymentData.payment_fees_account_razorpay || '');

        console.log("=== API REQUEST DEBUG ===");
        console.log("API URL:", 'https://ideatrialbrainweb.com/edu/manage/dashboard/api-offline-fee-payment.php');
        console.log("FormData contents:");
        // Log FormData contents using Array.from to avoid iterator issues
        Array.from(formData.entries()).forEach(([key, value]) => {
            console.log(`${key}:`, value);
        });
        
        const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-offline-fee-payment.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        
        console.log("=== API RESPONSE DEBUG ===");
        console.log("Response status:", response.status);
        console.log("Response data:", response.data);
        
        return response.data;
    } catch (error: any) {
        console.error("=== API ERROR DEBUG ===");
        console.error("Error object:", error);
        console.error("Error response:", error.response);
        console.error("Error status:", error.response?.status);
        console.error("Error data:", error.response?.data);
        console.error("Error message:", error.message);
        
        // Provide more detailed error information
        if (error.response?.data) {
            throw error.response.data;
        } else if (error.response) {
            throw {
                success: false,
                message: `Server error: ${error.response.status} - ${error.response.statusText}`,
                error: error.response
            };
        } else {
            throw {
                success: false,
                message: `Network error: ${error.message}`,
                error: error
            };
        }
    }
}

// Fetch offline payments from sch_fees_payment_new
export const getOfflinePaymentsNew = async (params: {
    admin_branch: number;
    student_id?: string;
    payment_status?: string;
    limit?: number;
    offset?: number;
}) => {
    try {
        const queryParams = new URLSearchParams({
            admin_branch: params.admin_branch.toString(),
            ...(params.student_id && { student_id: params.student_id }),
            ...(params.payment_status && { payment_status: params.payment_status }),
            ...(params.limit && { limit: params.limit.toString() }),
            ...(params.offset && { offset: params.offset.toString() })
        });
        
        const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-offline-fee-payment.php?${queryParams.toString()}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch offline payments:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
}

// Define UpdateMarksBody type according to your API requirements
type UpdateMarksBody = {
    student_id: number;
    subject: string;
    marks: number;
    exam_type: number;
    [key: string]: any; // Add/adjust fields as needed
};

// Define UpdateMarksResponse type according to your API's response structure
type UpdateMarksResponse = {
    success: boolean;
    message: string;
    [key: string]: any; // Add/adjust fields as needed
};

export const updateMarks = async (body: UpdateMarksBody): Promise<UpdateMarksResponse> => {
    console.log("Sending payload:", JSON.stringify(body, null, 2));

    try {
        const response: AxiosResponse<UpdateMarksResponse> = await api.put('/manage/dashboard/api-edit_result.php', body);
        return response.data;
    } catch (error) {
        console.error("Full error object:", error);

        if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError<UpdateMarksResponse>;
            console.error("Server response:", axiosError.response?.data);
            console.error("Status code:", axiosError.response?.status);
            throw new Error(axiosError.response?.data.message || 'Failed to update marks');
        }

        throw error;
    }
};

// New API functions for edit result
export const getEditResultData = async (studentId: number, adminBranch: number, examType?: number) => {
    try {
        const params = new URLSearchParams({
            student_id: studentId.toString(),
            admin_branch: adminBranch.toString()
        });
        
        if (examType) {
            params.append('student_exam_type', examType.toString());
        }

        const response = await api.get(`/manage/dashboard/api-edit_result.php?${params.toString()}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch edit result data:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const updateEditResultMarks = async (data: {
    student_id: number;
    admin_branch: number;
    exam_type: number;
    marks: { [subject: string]: { [category: string]: number | string } };
    out_of: { [subject: string]: { [category: string]: number } };
}) => {
    try {
        console.log('API: Preparing data with:', data);
        
        // Validate input data
        if (!data.student_id || !data.admin_branch || !data.exam_type) {
            throw new Error('Missing required fields: student_id, admin_branch, or exam_type');
        }
        
        if (!data.marks || Object.keys(data.marks).length === 0) {
            throw new Error('Marks data is empty or missing');
        }
        
        if (!data.out_of || Object.keys(data.out_of).length === 0) {
            throw new Error('Out_of data is empty or missing');
        }
        
        // Create FormData with the exact structure PHP expects
        const formData = new FormData();
        formData.append('student_id', data.student_id.toString());
        formData.append('admin_branch', data.admin_branch.toString());
        formData.append('exam_type', data.exam_type.toString());
        
        // Add marks data in the format PHP expects: marks[subject][category] = value
        let marksCount = 0;
        Object.keys(data.marks).forEach(subject => {
            Object.keys(data.marks[subject]).forEach(category => {
                const value = data.marks[subject][category];
                const stringValue = value === null || value === undefined ? '0' : value.toString();
                formData.append(`marks[${subject}][${category}]`, stringValue);
                console.log(`API: Added marks[${subject}][${category}] = ${stringValue}`);
                marksCount++;
            });
        });
        
        // Add out_of data in the format PHP expects: out_of[subject][category] = value
        let outOfCount = 0;
        Object.keys(data.out_of).forEach(subject => {
            Object.keys(data.out_of[subject]).forEach(category => {
                const value = data.out_of[subject][category];
                const stringValue = value === null || value === undefined ? '0' : value.toString();
                formData.append(`out_of[${subject}][${category}]`, stringValue);
                console.log(`API: Added out_of[${subject}][${category}] = ${stringValue}`);
                outOfCount++;
            });
        });

        console.log('API: FormData entries:');
        formData.forEach((value, key) => {
            console.log(`${key}: ${value}`);
        });

        console.log('API: Total marks entries:', marksCount);
        console.log('API: Total out_of entries:', outOfCount);
        console.log('API: FormData entries count:', Array.from(formData.entries()).length);

        // Log the expected PHP structure
        console.log('API: Expected PHP $_POST structure:');
        const expectedPost = {
            student_id: data.student_id.toString(),
            admin_branch: data.admin_branch.toString(),
            exam_type: data.exam_type.toString(),
            marks: data.marks,
            out_of: data.out_of
        };
        console.log(JSON.stringify(expectedPost, null, 2));

        const response = await api.post('/manage/dashboard/api-edit_result.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        console.log('API: Response received:', response.data);
        return response.data;
    } catch (error: any) {
        console.error("API: Failed to update edit result marks:", error);
        console.error("API: Error response:", error.response?.data);
        throw error.response?.data || error;
    }
};
export const fetchFeesPayment = async (studentClass: number, studentSection: number, studentId: number, branchId: number) => {
    try {
        const response = await api.post("/manage/dashboard/api-fees-payment.php", {
            student_class: studentClass,
            student_section: studentSection,
            student_id: studentId,
            branch_id: branchId
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch fees payment:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};



// Fetch fees for a specific branch

// Feedback API functions
export const getFeedbackForm = async (studentId: number, adminBranch: number) => {
    try {
        const response = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-feedback.php?student_id=${studentId}&admin_branch=${adminBranch}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch feedback form:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const submitFeedback = async (feedbackData: {
    student_id: number;
    admin_branch: number;
    overallSatisfaction_rating: number;
    userFriendly_rating: number;
    contentQueries_rating: number;
    examination_rating: number;
    liveSessions_rating: number;
}) => {
    try {
        const response = await api.post(`https://ideatrialbrainweb.com/edu/dashboard/api-feedback.php`, feedbackData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to submit feedback:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};
// Define Fee type according to your API response structure
type Fee = {
    id: number;
    fees_branch: number;
    fees_class: number;
    fees_title: string;
    fees_amount: number;
    fees_description: string;
    fees_uploaded_for: number[];
    fees_account_razorpay: string;
    // Add other fields as needed
};

export const getFees = async (branchId: number): Promise<{ status: string; data: Fee[] }> => {
    try {
        const response = await api.get(`/manage/dashboard/api-add-fees.php?branch_id=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error('Failed to fetch fees:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Branch details (Razorpay accounts, etc.)
export type BranchDetails = {
    branch_razorpay_id: string;
    branch_razorpay_id2?: string;
    // Add more fields here if backend provides them
};

export const getBranchDetails = async (branchId: number): Promise<BranchDetails> => {
    try {
        // Prefer the unified endpoint used in Add Fees page; adapt to either direct object or wrapped payload
        const response = await api.get(`/api/branch?branch_id=${branchId}`);
        const payload = response.data;
        // Handle both { data: {...} } and direct {...}
        const details: BranchDetails = payload?.data ?? payload;
        return details as BranchDetails;
    } catch (error: any) {
        console.error('Failed to fetch branch details:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Add a new fee
export const addFee = async (
    branchId: number,
    classId: number,
    uploadedFor: number[],
    title: string,
    amount: number,
    description: string,
    razorpayAccount: string
): Promise<{ status: string; message: string; id?: number }> => {
    try {
        const data = {
            fees_branch: branchId,
            fees_class: classId,
            fees_uploaded_for: uploadedFor,
            fees_title: title,
            fees_amount: amount,
            fees_description: description,
            fees_account_razorpay: razorpayAccount,
        };
        const response = await api.post(`/manage/dashboard/api-add-fees.php?branch_id=${branchId}`, data);
        return response.data;
    } catch (error: any) {
        console.error('Failed to add fee:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Update an existing fee
export const updateFee = async (
    feeId: number,
    title: string,
    amount: number,
    description: string,
    uploadedFor: number[],
    razorpayAccount: string
): Promise<{ status: string; message: string }> => {
    try {
        const data = {
            id: feeId,
            fees_title: title,
            fees_amount: amount,
            fees_description: description,
            fees_uploaded_for: uploadedFor,
            fees_account_razorpay: razorpayAccount,
        };
        const response = await api.put(`/manage/dashboard/api-add-fees.php`, data);
        return response.data;
    } catch (error: any) {
        console.error('Failed to update fee:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Delete a fee
export const deleteFee = async (feeId: number): Promise<{ status: string; message: string }> => {
    try {
        const data = {
            id: feeId,
        };
        const response = await api.delete(`/manage/dashboard/api-add-fees.php`, { data });
        return response.data;
    } catch (error: any) {
        console.error('Failed to delete fee:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export interface FeeForEditData {
    student_names?: string[] | string;
    student_ids?: number[] | string;
    fees_uploaded_for?: number[] | string;
    fees_class?: number | string;
    class_id?: number | string;
    class_name?: string;
    section_name?: string | string[];
    section_names?: string[] | string;
    fees_title?: string;
    fees_amount?: number | string;
    fees_description?: string;
    fees_account_razorpay?: string;
    fees_account?: string | number;
    account_razorpay?: string;
    students?: Array<{
      id?: number;
      student_id?: number;
      student_name?: string;
      section_name?: string;
      section?: string;
    }>;
    student_sections?: string[] | string;
}

// Fetch fee details for editing (class, students, amounts, etc.)
export const fetchFeeForEdit = async (
    feesId: number,
    adminBranch: number,
    adminId: number
): Promise<{ success: boolean; message: string; data: FeeForEditData }> => {
    try {
        const response = await api.get(
            `/manage/dashboard/api-edit-fees.php?fees_id=${feesId}&admin_branch=${adminBranch}&admin_id=${adminId}`
        );
        return response.data;
    } catch (error: any) {
        console.error('Failed to fetch fee for edit:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Fetch Student Names for a specific fee
export const fetchFeeStudentNames = fetchFeeForEdit;

// Add Student API
export const addStudent = async (studentData: {
    student_name: string;
    student_mobile: string;
    student_branch: number;
    student_class: number;
    student_section: number;
    student_email: string;
    student_roll_number?: string;
    student_sex?: string;
    student_dob?: string;
    student_category?: string;
    student_physically_challenged?: string;
    student_religion?: string;
    student_admission_date?: string;
    student_blood_group?: string;
    student_medical_history?: string;
    student_kanyasree_id?: string;
    student_aadhar_number?: string;
    student_previous_school?: string;
    student_previous_marks?: string;
    student_father_name?: string;
    student_father_contact_number?: string;
    student_father_occupation?: string;
    student_father_annual_income?: string;
    student_mother_name?: string;
    student_mother_contact_number?: string;
    student_mother_occupation?: string;
    student_mother_annual_income?: string;
    student_guardian_name?: string;
    student_relation_with_guardian?: string;
    student_guardian_occupation?: string;
    student_guardian_contact_number?: string;
    student_current_address1?: string;
    student_current_address2?: string;
    student_current_city?: string;
    student_current_district?: string;
    student_current_state?: string;
    student_current_pin_code?: string;
    student_permanent_address1?: string;
    student_permanent_address2?: string;
    student_permanent_city?: string;
    student_permanent_district?: string;
    student_permanent_state?: string;
    student_permanent_pin_code?: string;
    send_sms?: number;
    student_photo?: File | null;
}): Promise<{
    status: string;
    message: string;
    data?: {
        student_id: number;
        student_username: string;
        student_password: string;
    };
    student_id?: number;
    username?: string;
    password?: string;
}> => {
    try {
        const formData = new FormData();
        
        // Add all student data to FormData in the exact order expected by PHP
        // Required fields first
        formData.append('student_name', studentData.student_name);
        formData.append('student_mobile', studentData.student_mobile);
        formData.append('student_branch', studentData.student_branch.toString());
        formData.append('student_class', studentData.student_class.toString());
        formData.append('student_section', studentData.student_section.toString());
        formData.append('student_email', studentData.student_email);
        
        // Optional fields with proper defaults
        formData.append('student_roll_number', studentData.student_roll_number || '');
        formData.append('student_sex', studentData.student_sex || '');
        formData.append('student_dob', studentData.student_dob || '');
        formData.append('student_category', studentData.student_category || '');
        formData.append('student_physically_challenged', studentData.student_physically_challenged || 'No');
        formData.append('student_religion', studentData.student_religion || '');
        formData.append('student_admission_date', studentData.student_admission_date || '');
        formData.append('student_blood_group', studentData.student_blood_group || '');
        formData.append('student_medical_history', studentData.student_medical_history || '');
        formData.append('student_kanyasree_id', studentData.student_kanyasree_id || '');
        formData.append('student_aadhar_number', studentData.student_aadhar_number || '');
        formData.append('student_previous_school', studentData.student_previous_school || '');
        formData.append('student_previous_marks', studentData.student_previous_marks || '');
        formData.append('student_father_name', studentData.student_father_name || '');
        formData.append('student_father_contact_number', studentData.student_father_contact_number || '');
        formData.append('student_father_occupation', studentData.student_father_occupation || '');
        formData.append('student_father_annual_income', studentData.student_father_annual_income || '');
        formData.append('student_mother_name', studentData.student_mother_name || '');
        formData.append('student_mother_contact_number', studentData.student_mother_contact_number || '');
        formData.append('student_mother_occupation', studentData.student_mother_occupation || '');
        formData.append('student_mother_annual_income', studentData.student_mother_annual_income || '');
        formData.append('student_guardian_name', studentData.student_guardian_name || '');
        formData.append('student_relation_with_guardian', studentData.student_relation_with_guardian || '');
        formData.append('student_guardian_occupation', studentData.student_guardian_occupation || '');
        formData.append('student_guardian_contact_number', studentData.student_guardian_contact_number || '');
        formData.append('student_current_address1', studentData.student_current_address1 || '');
        formData.append('student_current_address2', studentData.student_current_address2 || '');
        formData.append('student_current_city', studentData.student_current_city || '');
        formData.append('student_current_district', studentData.student_current_district || '');
        formData.append('student_current_state', studentData.student_current_state || '');
        formData.append('student_current_pin_code', studentData.student_current_pin_code || '');
        formData.append('student_permanent_address1', studentData.student_permanent_address1 || '');
        formData.append('student_permanent_address2', studentData.student_permanent_address2 || '');
        formData.append('student_permanent_city', studentData.student_permanent_city || '');
        formData.append('student_permanent_district', studentData.student_permanent_district || '');
        formData.append('student_permanent_state', studentData.student_permanent_state || '');
        formData.append('student_permanent_pin_code', studentData.student_permanent_pin_code || '');
        formData.append('send_sms', (studentData.send_sms || 0).toString());

        // Only add photo if it exists
        if (studentData.student_photo) {
            formData.append('student_photo', studentData.student_photo);
        }

        console.log('FormData contents:');
        // Log the data being sent for debugging
        console.log('Student data being sent:', studentData);

        const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-add-student.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        
        return response.data;
    } catch (error: any) {
        console.error('Failed to add student:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Get Student Details for Edit API
export const getStudentDetailsForEdit = async (studentId: number, branchId: number) => {
    try {
        const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-edit-student.php?id=${studentId}&admin_branch=${branchId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch student details for edit:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export type BulkRollUpdateFailure = {
    student_id: number;
    name?: string;
    error: string;
};

export type BulkRollUpdateResponse = {
    success: boolean;
    message: string;
    updated?: number;
    failures?: BulkRollUpdateFailure[];
};

/**
 * Bulk update roll numbers only (single request). Requires api-bulk-roll-update.php on the server.
 * Sends class/section so the backend can verify each student belongs to that group.
 */
export const bulkUpdateStudentRollNumbers = async (params: {
    adminBranch: number;
    studentClass: number;
    studentSection: number;
    updates: { studentId: number; rollNumber: string }[];
}): Promise<BulkRollUpdateResponse> => {
    try {
        const formData = new FormData();
        formData.append("admin_branch", String(params.adminBranch));
        formData.append("student_class", String(params.studentClass));
        formData.append("student_section", String(params.studentSection));
        params.updates.forEach((u) => {
            formData.append("student_id[]", String(u.studentId));
            formData.append("student_roll_number[]", u.rollNumber.trim());
        });
        // Same as api-add-student / api-edit-student: default axios Content-Type is
        // application/json; without multipart headers PHP often gets empty $_POST.
        formData.append("branch_id", String(params.adminBranch));
        formData.append("class_id", String(params.studentClass));
        formData.append("section_id", String(params.studentSection));
        const base = (api.defaults.baseURL || '').replace(/\/$/, '');
        const bulkRollUrl = base
            ? `${base}/manage/dashboard/api-bulk-roll-update.php`
            : 'https://ideatrialbrainweb.com/edu/manage/dashboard/api-bulk-roll-update.php';
        const response = await api.post(bulkRollUrl, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data as BulkRollUpdateResponse;
    } catch (error: any) {
        console.error(
            "Failed bulk roll update:",
            error.response?.data || error.message
        );
        throw error.response?.data || error;
    }
};

// Get districts list by state id (for dynamic State -> District dropdowns)
export const getDistrictsByState = async (stateId: string | number) => {
    try {
        const id = typeof stateId === 'string' ? parseInt(stateId, 10) : stateId;
        if (!id || Number.isNaN(id)) {
            return { success: false, message: 'Invalid state id', data: { districts: [] } };
        }

        // Expected response shapes (depending on PHP implementation):
        // - { success: true, data: { districts: [{ id, district_name }] } }
        // - { success: true, districts: [{ id, district_name }] }
        const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-get-districts.php?state_id=${id}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch districts by state:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Edit Student API
export const editStudent = async (studentData: {
    id: number;
    admin_branch: number;
    student_name: string;
    student_mobile: string;
    student_branch: number;
    student_class: number;
    student_section: number;
    student_email: string;
    student_roll_number?: string;
    student_sex?: string;
    student_dob?: string;
    student_category?: string;
    student_physically_challenged?: string;
    student_religion?: string;
    student_admission_date?: string;
    student_blood_group?: string;
    student_medical_history?: string;
    student_kanyasree_id?: string;
    student_aadhar_number?: string;
    student_previous_school?: string;
    student_previous_marks?: number;
    student_father_name?: string;
    student_father_contact_number?: string;
    student_father_occupation?: string;
    student_father_annual_income?: number;
    student_mother_name?: string;
    student_mother_contact_number?: string;
    student_mother_occupation?: string;
    student_mother_annual_income?: number;
    student_guardian_name?: string;
    student_relation_with_guardian?: string;
    student_guardian_occupation?: string;
    student_guardian_contact_number?: string;
    student_current_address1?: string;
    student_current_address2?: string;
    student_current_city?: string;
    student_current_district?: string;
    student_current_state?: string;
    student_current_pin_code?: string;
    student_permanent_address1?: string;
    student_permanent_address2?: string;
    student_permanent_city?: string;
    student_permanent_district?: string;
    student_permanent_state?: string;
    student_permanent_pin_code?: string;
    student_password?: string;
    student_status?: number;
    pre_image?: string;
    student_photo?: File | null;
}): Promise<{
    success: boolean;
    message: string;
    data?: {
        student_id: number;
    };
}> => {
    try {
        const formData = new FormData();
        
        // Add all student data to FormData in the exact order expected by PHP
        // Required fields first
        formData.append('id', studentData.id.toString());
        formData.append('admin_branch', studentData.admin_branch.toString());
        formData.append('student_name', studentData.student_name);
        formData.append('student_mobile', studentData.student_mobile);
        formData.append('student_branch', studentData.student_branch.toString());
        formData.append('student_class', studentData.student_class.toString());
        formData.append('student_section', studentData.student_section.toString());
        formData.append('student_email', studentData.student_email);
        
        // Optional fields with proper defaults
        formData.append('student_roll_number', studentData.student_roll_number || '');
        formData.append('student_sex', studentData.student_sex || '');
        formData.append('student_dob', studentData.student_dob || '');
        formData.append('student_category', studentData.student_category || '');
        formData.append('student_physically_challenged', studentData.student_physically_challenged || '');
        formData.append('student_religion', studentData.student_religion || '');
        formData.append('student_admission_date', studentData.student_admission_date || '');
        formData.append('student_blood_group', studentData.student_blood_group || '');
        formData.append('student_medical_history', studentData.student_medical_history || '');
        formData.append('student_kanyasree_id', studentData.student_kanyasree_id || '');
        formData.append('student_aadhar_number', studentData.student_aadhar_number || '');
        formData.append('student_previous_school', studentData.student_previous_school || '');
        formData.append('student_previous_marks', (studentData.student_previous_marks || 0).toString());
        
        // Father details
        formData.append('student_father_name', studentData.student_father_name || '');
        formData.append('student_father_contact_number', studentData.student_father_contact_number || '');
        formData.append('student_father_occupation', studentData.student_father_occupation || '');
        formData.append('student_father_annual_income', (studentData.student_father_annual_income || 0).toString());
        
        // Mother details
        formData.append('student_mother_name', studentData.student_mother_name || '');
        formData.append('student_mother_contact_number', studentData.student_mother_contact_number || '');
        formData.append('student_mother_occupation', studentData.student_mother_occupation || '');
        formData.append('student_mother_annual_income', (studentData.student_mother_annual_income || 0).toString());
        
        // Guardian details
        formData.append('student_guardian_name', studentData.student_guardian_name || '');
        formData.append('student_relation_with_guardian', studentData.student_relation_with_guardian || '');
        formData.append('student_guardian_occupation', studentData.student_guardian_occupation || '');
        formData.append('student_guardian_contact_number', studentData.student_guardian_contact_number || '');
        
        // Current address
        formData.append('student_current_address1', studentData.student_current_address1 || '');
        formData.append('student_current_address2', studentData.student_current_address2 || '');
        formData.append('student_current_city', studentData.student_current_city || '');
        formData.append('student_current_district', studentData.student_current_district || '');
        formData.append('student_current_state', studentData.student_current_state || '');
        formData.append('student_current_pin_code', studentData.student_current_pin_code || '');
        
        // Permanent address
        formData.append('student_permanent_address1', studentData.student_permanent_address1 || '');
        formData.append('student_permanent_address2', studentData.student_permanent_address2 || '');
        formData.append('student_permanent_city', studentData.student_permanent_city || '');
        formData.append('student_permanent_district', studentData.student_permanent_district || '');
        formData.append('student_permanent_state', studentData.student_permanent_state || '');
        formData.append('student_permanent_pin_code', studentData.student_permanent_pin_code || '');
        
        // Additional fields
        formData.append('student_password', studentData.student_password || '');
        formData.append('student_status', (studentData.student_status || 1).toString());
        formData.append('pre_image', studentData.pre_image || '');
        
        // Handle file upload
        if (studentData.student_photo) {
            formData.append('student_photo', studentData.student_photo);
        }
        
        const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-edit-student.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        
        return response.data;
    } catch (error: any) {
        console.error('Failed to edit student:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Examination Answer API functions
export const examApi = {
  // Get auto result exams for dropdown
  getAutoResultExams: async (params: {
    admin_branch: string;
    admin_id: string;
    admin_type: string;
  }) => {
    try {
      const response = await api.get('https://ideatrialbrainweb.com/edu/manage/dashboard/api-online-exam.php', {
        params: {
          admin_branch: params.admin_branch,
          admin_id: params.admin_id,
          admin_type: params.admin_type
        }
      });
      return response.data;
    } catch (error: any) {
      console.error("Failed to fetch auto result exams:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  },

  // Get students for a specific examination
  getExamStudents: async (examHash: string, userParams: {
    admin_branch: string;
    admin_id: string;
    admin_type: string;
  }) => {
    try {
      // Use the same API endpoint as getAutoResultExams, but with exam_hash parameter
      const response = await api.get('https://ideatrialbrainweb.com/edu/manage/dashboard/api-examination-answer.php', {
        params: {
          admin_branch: userParams.admin_branch,
          admin_id: userParams.admin_id,
          admin_type: userParams.admin_type,
          exam_hash: examHash
        }
      });
      return response.data;
    } catch (error: any) {
      console.error("Failed to fetch exam students:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  },

  // Get manual answer exams for dropdown
  getManualAnswerExams: async (params: {
    admin_branch: string;
    admin_id: string;
    admin_type: string;
  }) => {
    try {
      const response = await api.get('https://ideatrialbrainweb.com/edu/manage/dashboard/api-examination-answer-manual.php', {
        params: {
          admin_branch: params.admin_branch,
          admin_id: params.admin_id,
          admin_type: params.admin_type
        }
      });
      return response.data;
    } catch (error: any) {
      console.error("Failed to fetch manual answer exams:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  },

  // Get students for a specific manual examination
  getManualExamStudents: async (examHash: string, userParams: {
    admin_branch: string;
    admin_id: string;
    admin_type: string;
  }) => {
    try {
      const response = await api.get('https://ideatrialbrainweb.com/edu/manage/dashboard/api-examination-answer-manual.php', {
        params: {
          admin_branch: userParams.admin_branch,
          admin_id: userParams.admin_id,
          admin_type: userParams.admin_type,
          exam_hash: examHash
        }
      });
      return response.data;
    } catch (error: any) {
      console.error("Failed to fetch manual exam students:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  },

  // Get student exam auto answer details
  getStudentExamAutoAnswer: async (params: {
    admin_branch: string;
    admin_id: string;
    admin_type: string;
    exam_hash: string;
    student_id: string;
  }) => {
    try {
      const response = await api.get('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-exam-auto-answer.php', {
        params: {
          admin_branch: params.admin_branch,
          admin_id: params.admin_id,
          admin_type: params.admin_type,
          exam_hash: params.exam_hash,
          student_id: params.student_id
        }
      });
      return response.data;
    } catch (error: any) {
      console.error("Failed to fetch student exam auto answer:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  },

  // Submit remarks for student exam
  submitStudentExamRemarks: async (params: {
    result_remarks: string;
    result_exam_id?: number;
    result_student: number;
    result_examiner: number;
    exam_hash?: string;
  }) => {
    try {
      const payload: Record<string, string | number> = {
        result_remarks: params.result_remarks,
        result_student: params.result_student,
        result_examiner: params.result_examiner,
      };

      if (params.result_exam_id) {
        payload.result_exam_id = params.result_exam_id;
      }

      if (params.exam_hash) {
        payload.exam_hash = params.exam_hash;
      }

      const response = await api.post(
        'https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-exam-auto-answer.php',
        payload
      );
      return response.data;
    } catch (error: any) {
      console.error("Failed to submit student exam remarks:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  },

  // Get student manual exam answer details
  getStudentExamManualAnswer: async (params: {
    exam_hash: string;
    student_id: string;
    admin_branch: string;
    admin_id: string;
    admin_type: string;
  }) => {
    try {
      const response = await api.get('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-exam-manual-answer.php', {
        params: {
          exam_hash: params.exam_hash,
          student_id: params.student_id,
          admin_branch: params.admin_branch,
          admin_id: params.admin_id,
          admin_type: params.admin_type
        }
      });
      return response.data;
    } catch (error: any) {
      console.error("Failed to fetch student exam manual answer:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  },

  // Submit manual exam marks and remarks
  submitManualExamMarks: async (params: {
    result_exam_id: number;
    result_student: number;
    admin_id: number;
    admin_type: string;
    admin_branch: number;
    exam_answer_mark: number[];
    exam_answer_remark: string[];
    result_remarks: string;
  }) => {
    try {
      console.log('API submitManualExamMarks called with params:', params);
      
      const formData = new FormData();
      formData.append('result_exam_id', params.result_exam_id.toString());
      formData.append('result_student', params.result_student.toString());
      formData.append('admin_id', params.admin_id.toString());
      formData.append('admin_type', params.admin_type);
      formData.append('admin_branch', params.admin_branch.toString());
      formData.append('result_remarks', params.result_remarks);
      
      params.exam_answer_mark.forEach((mark, index) => {
        formData.append('exam_answer_mark[]', mark.toString());
      });
      
      params.exam_answer_remark.forEach((remark, index) => {
        formData.append('exam_answer_remark[]', remark);
      });

      // Log the FormData contents
      console.log('FormData contents:');
      formData.forEach((value, key) => {
        console.log(`${key}: ${value}`);
      });

      // Use direct axios instead of api instance to avoid base URL conflicts
      const response = await axios.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-exam-manual-answer.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 30000, // 30 seconds timeout
      });
      
      console.log('API response:', response);
      return response.data;
    } catch (error: any) {
      console.error("Failed to submit manual exam marks:", error);
      console.error("Error response:", error.response);
      console.error("Error data:", error.response?.data);
      throw error.response?.data || error;
    }
  }
};

// Define Exam interface
export interface Exam {
  exam_hash: string;
  exam_title: string;
}

// Define Student interface
export interface Student {
  student_name: string;
  student_roll_number: string;
  class_name: string;
  section_name: string;
  view_url: string;
}

// Define Manual Exam interfaces
export interface ManualExam {
  exam_id: number;
  exam_hash: string;
  exam_title: string;
}

export interface ManualExamSubmission {
  student_name: string;
  student_id: number;
  branch_name: string;
  class_name: string;
  section_name: string;
}

// Define Student Exam Auto Answer interfaces
export interface StudentExamQuestion {
  question_number: number;
  question_title: string;
  question_file: string | null;
  answer_type: string;
  options: string[];
  right_answer: string;
  marks: number;
  student_answer: string;
}

export interface StudentExamData {
  exam_id?: number;
  exam_title: string;
  student: {
    name: string;
    class_name: string;
    section_name: string;
    roll_number: string;
  };
  marks_obtained: number;
  total_marks: number;
  remarks: string;
  exam_check_flag: number;
  questions: StudentExamQuestion[];
}

// Define Manual Exam Answer interfaces
export interface ManualExamQuestion {
  question_number: number;
  question_title: string;
  question_file: string;
  answer_type: string;
  options: string[];
  marks: number;
  answer: string;
  marks_obtained: number;
  remark: string;
}

export interface ManualExamAnswerData {
  exam_id: number;
  exam_title: string;
  student: {
    name: string;
    class: string;
    section: string;
    roll_number: string;
  };
  total_marks: number;
  is_evaluated: boolean;
  overall_remarks: string;
  questions: ManualExamQuestion[];
}

export interface StudentExamResponse {
  status: string;
  message: string;
  data: StudentExamData;
}

export const fetchLiveClasses = async (branchId: number, classId: number, sectionId: number, studentName: string = '', studentEmail: string = '') => {
    try {
        const params = new URLSearchParams({
            branch: branchId.toString(),
            class: classId.toString(),
            section: sectionId.toString()
        });
        
        if (studentName) params.append('student_name', studentName);
        if (studentEmail) params.append('student_email', studentEmail);
        
        const response = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-live-classes.php?${params.toString()}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch live classes:", error.response?.data || error.message);
        throw error.response?.data || error; // Pass detailed error to frontend
    }
};

// Tutorial Feedback API functions
export interface FeedbackData {
    sender_name: string;
    sender_type: string;
    feedback_details: string;
    feedback_time: string;
    float: string;
    box_color: string;
}

export interface FeedbackResponse {
    status: string;
    message: string;
    data?: {
        feedbacks: FeedbackData[];
    };
}

// Fetch feedback for a tutorial
export const fetchTutorialFeedback = async (params: {
    tutorial_id: number;
    branch: number;
    class: number;
    section: number;
    student_id: number;
}): Promise<FeedbackResponse> => {
    try {
        const queryParams = new URLSearchParams({
            tutorial_id: params.tutorial_id.toString(),
            branch: params.branch.toString(),
            class: params.class.toString(),
            section: params.section.toString(),
            student_id: params.student_id.toString()
        });
        
        const response = await api.get(`/dashboard/ajax/tutorial-feedback.php?${queryParams.toString()}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch tutorial feedback:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Submit feedback for a tutorial
export const submitTutorialFeedback = async (params: {
    tutorial_id: number;
    branch: number;
    class: number;
    section: number;
    student_id: number;
    feedback_details: string;
}): Promise<FeedbackResponse> => {
    try {
        const response = await api.post(`/dashboard/ajax/tutorial-feedback.php`, {
            tutorial_id: params.tutorial_id,
            branch: params.branch,
            class: params.class,
            section: params.section,
            student_id: params.student_id,
            feedback_details: params.feedback_details
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to submit tutorial feedback:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export interface CompletedExamRecord {
    title: string;
    type: string;
    subject: string;
    start_date: string;
    end_date: string;
    status: string;
    view_answer_url: string | null;
    exam_hash?: string | null;
}

const extractExamHashFromUrl = (url?: string | null): string | null => {
    if (!url) return null;
    const idMatch = url.match(/[?&]id=([^&]+)/i);
    if (idMatch) return decodeURIComponent(idMatch[1]);
    const hashMatch = url.match(/exam_hash=([^&]+)/i);
    if (hashMatch) return decodeURIComponent(hashMatch[1]);
    const pathMatch = url.match(/\/online-exam-auto-answer\/([^/?#]+)/i);
    if (pathMatch) return decodeURIComponent(pathMatch[1]);
    return null;
};

export const buildStudentViewAnswerPath = (
    exam: Pick<CompletedExamRecord, 'type' | 'exam_hash' | 'view_answer_url'>,
    studentId?: string | number
): string | null => {
    const examHash = exam.exam_hash || extractExamHashFromUrl(exam.view_answer_url);
    if (!examHash) return null;

    const studentQuery = studentId ? `?studentId=${studentId}` : '';
    const typeLower = (exam.type || '').toLowerCase();

    if (typeLower.includes('manual')) {
        return `/online-exam-manual-answer?id=${examHash}`;
    }

    return `/online-exam-auto-answer/${examHash}${studentQuery}`;
};

export const normalizeCompletedExamRecord = (exam: CompletedExamRecord): CompletedExamRecord => {
    const examHash = exam.exam_hash || extractExamHashFromUrl(exam.view_answer_url);
    const typeLower = (exam.type || '').toLowerCase();
    const statusLower = (exam.status || '').toLowerCase();
    const isAnswerAvailable = ['completed', 'checked', 'done'].includes(statusLower);

    let viewAnswerUrl = exam.view_answer_url;

    if (!viewAnswerUrl && examHash && isAnswerAvailable) {
        viewAnswerUrl = buildStudentViewAnswerPath(
            { ...exam, exam_hash: examHash },
            undefined
        );
    }

    if (viewAnswerUrl) {
        viewAnswerUrl = viewAnswerUrl
            .replace(/\.php(?=\?|$)/, '')
            .replace(/^\/?online-exam-auto-answer\?id=([^&]+)/, '/online-exam-auto-answer/$1')
            .replace(/^\/?online-exam-auto-answer/, '/online-exam-auto-answer')
            .replace(/^\/?online-exam-manual-answer/, '/online-exam-manual-answer');
        if (!viewAnswerUrl.startsWith('/')) {
            viewAnswerUrl = `/${viewAnswerUrl}`;
        }
    }

    return {
        ...exam,
        exam_hash: examHash || null,
        view_answer_url: viewAnswerUrl || null,
    };
};

// Completed Exam API
export const getCompletedExams = async (params: {
    student_id: number;
    specific_day_count?: number;
}): Promise<{
    status: string;
    message: string;
    data: CompletedExamRecord[];
}> => {
    try {
        const queryParams = new URLSearchParams({
            student_id: params.student_id.toString(),
            ...(params.specific_day_count && { specific_day_count: params.specific_day_count.toString() })
        });
        
        const response = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-completed-exam.php?${queryParams.toString()}`);
        const payload = response.data;

        if (payload?.status === 'success' && Array.isArray(payload.data)) {
            return {
                ...payload,
                data: payload.data.map((exam: CompletedExamRecord) => normalizeCompletedExamRecord(exam)),
            };
        }

        return payload;
    } catch (error: any) {
        console.error("Failed to fetch completed exams:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Admin/Teacher Study Material Feedback API functions
export interface AdminFeedbackData {
    sender_name: string;
    sender_type: string;
    feedback_details: string;
    feedback_time: string;
    float: string;
    box_color: string;
}

export interface AdminFeedbackResponse {
    status: string;
    message: string;
    data?: {
        feedbacks: AdminFeedbackData[];
    };
}

// Fetch feedback for a tutorial (Admin/Teacher version)
export const fetchAdminTutorialFeedback = async (params: {
    tutorial_id: number;
    admin_id: number;
    admin_type: string;
    branch: number;
}): Promise<AdminFeedbackResponse> => {
    try {
        const queryParams = new URLSearchParams({
            tutorial_id: params.tutorial_id.toString(),
            admin_id: params.admin_id.toString(),
            admin_type: params.admin_type,
            branch: params.branch.toString()
        });
        
        const response = await api.get(`/manage/dashboard/api-study-material-feedback.php?${queryParams.toString()}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch admin tutorial feedback:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Submit feedback for a tutorial (Admin/Teacher version)
export const submitAdminTutorialFeedback = async (params: {
    tutorial_id: number;
    admin_id: number;
    admin_type: string;
    branch: number;
    feedback_details: string;
}): Promise<AdminFeedbackResponse> => {
    try {
        const response = await api.post(`/manage/dashboard/api-study-material-feedback.php`, {
            tutorial_id: params.tutorial_id,
            admin_id: params.admin_id,
            admin_type: params.admin_type,
            branch: params.branch,
            feedback_details: params.feedback_details
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to submit admin tutorial feedback:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const getStudentMarksheetData = async (studentId: number, examType?: number) => {
    try {
        const params = new URLSearchParams({
            student_id: studentId.toString()
        });
        
        if (examType) {
            params.append('exam_type', examType.toString());
        }
        
        const response = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-view_marks.php?${params.toString()}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch student marksheet data:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Exam Report API function
export interface ExamResult {
    id: number;
    exam_name: string;
    exam_type: string;
    subject: string;
    marks_obtained: number;
    total_marks: number;
    percentage: number;
}

export interface ExamReportResponse {
    status: string;
    message: string;
    data?: ExamResult[];
}

export const getExamReport = async (studentId: number): Promise<ExamReportResponse> => {
    try {
        const response = await api.get(`https://ideatrialbrainweb.com/edu/dashboard/api-exam-report.php?student_id=${studentId}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch exam report:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// View Online Exam Answers API function
export interface OnlineExamAnswer {
    number: number;
    title: string;
    file: string | null;
    options: Array<{
        letter: string;
        text: string;
    }>;
    right_answer: string;
    student_answer: string;
}

export interface OnlineExamAnswerResponse {
    status: string;
    message: string;
    data?: {
        institution_name: string;
        exam_date: string;
        exam_title: string;
        student_name: string;
        examiner_name: string;
        questions: OnlineExamAnswer[];
        marks_obtained: number;
        total_marks: number;
        remarks: string;
    };
}

// Homework Answer interfaces
export interface Homework {
    homework_hash: string;
    homework_title: string;
}

export interface HomeworkSubmission {
    student_name: string;
    student_roll_number: string;
    class_name: string;
    section_name: string;
    student_homework_exam_time: string;
    student_homework_student_id: string;
    answer_url: string;
}

export interface HomeworkSubmissionsResponse {
    status: string;
    message: string;
    data: {
        homework_title: string;
        submissions: HomeworkSubmission[];
    };
}

// Student Homework Answer interfaces
export interface HomeworkQuestion {
    title: string;
    file: string;
}

export interface StudentHomeworkAnswer {
    homework: {
        id: number;
        title: string;
        full_marks: number;
    };
    student: {
        name: string;
        class_name: string;
        section_name: string;
        roll_number: string;
    };
    questions: HomeworkQuestion[];
    answers: string[];
    exam_status: {
        check_flag: number;
        marks_obtained: string;
        remarks: string;
    };
}

export interface StudentHomeworkAnswerResponse {
    status: string;
    message: string;
    data: StudentHomeworkAnswer;
}

export interface SubmitHomeworkResultResponse {
    status: string;
    message: string;
    data: {
        redirect_url: string;
    };
}

export const resolveStudentId = (user?: {
    user_id?: number;
    id?: number;
    student_id?: number;
} | null): number | null => {
    if (user?.user_id) return Number(user.user_id);
    if (user?.id) return Number(user.id);
    if (user?.student_id) return Number(user.student_id);

    if (typeof window !== 'undefined') {
        const storedId = window.localStorage.getItem('user_id');
        if (storedId && Number.isFinite(Number(storedId))) {
            return Number(storedId);
        }
    }

    return null;
};

const fetchOnlineExamAutoAnswers = async (
    examHash: string,
    studentId: number
): Promise<OnlineExamAnswerResponse> => {
    const params = new URLSearchParams({
        id: examHash,
        exam_hash: examHash,
        student_id: studentId.toString(),
    });

    const response = await api.get(
        `https://ideatrialbrainweb.com/edu/dashboard/api-online-exam-auto-answer.php?${params.toString()}`
    );
    return response.data as OnlineExamAnswerResponse;
};

const fetchStudentViewExamAutoAnswers = async (
    examHash: string,
    studentId: number
): Promise<OnlineExamAnswerResponse> => {
    const params = new URLSearchParams({
        exam_hash: examHash,
        id: examHash,
        student_id: studentId.toString(),
    });

    const response = await api.get(
        `https://ideatrialbrainweb.com/edu/dashboard/api-student-view-exam-auto-answer.php?${params.toString()}`
    );
    return response.data as OnlineExamAnswerResponse;
};

const indexToOptionLetter = (index: number) => String.fromCharCode(65 + index);

type StudentExamAutoOption = { index: number; text: string };

const normalizeAnswerIndex = (raw: unknown, options: StudentExamAutoOption[]) => {
    const value = String(raw ?? '').trim();
    if (!value) return '';

    const numeric = Number(value);
    if (Number.isFinite(numeric)) {
        const zeroBased = options.find((opt) => opt.index === numeric);
        if (zeroBased) return indexToOptionLetter(zeroBased.index);
        const oneBased = options.find((opt) => opt.index === numeric - 1);
        if (oneBased) return indexToOptionLetter(oneBased.index);
    }

    const letterMatch = value.match(/^([A-Z])$/i);
    if (letterMatch) {
        return letterMatch[1].toUpperCase();
    }

    const matched = options.find((opt) => opt.text === value);
    return matched ? indexToOptionLetter(matched.index) : value;
};

const fetchExamAnswersFromStudentExamAuto = async (
    examHash: string,
    studentId: number
): Promise<OnlineExamAnswerResponse> => {
    const firstResponse = await getStudentExamAuto(examHash, studentId, 1);
    const firstData = firstResponse?.data;

    if (!firstData) {
        return {
            status: 'error',
            message: firstResponse?.message || 'Unable to load completed exam data.',
        };
    }

    const totalQuestions = Number(firstData.total_questions) || 0;
    if (totalQuestions <= 0) {
        return {
            status: 'error',
            message: 'No questions found for this examination.',
        };
    }

    const questionResponses = await Promise.all(
        Array.from({ length: totalQuestions }, (_, index) =>
            index === 0
                ? Promise.resolve(firstResponse)
                : getStudentExamAuto(examHash, studentId, index + 1)
        )
    );

    const questions: OnlineExamAnswer[] = [];
    let computedTotal = 0;

    questionResponses.forEach((response, index) => {
        const question = response?.data?.question;
        if (!question) return;

        const questionOptions: StudentExamAutoOption[] = question.options || [];
        const options = questionOptions.map((option: StudentExamAutoOption) => ({
            letter: indexToOptionLetter(option.index),
            text: option.text,
        }));

        const studentAnswer = normalizeAnswerIndex(question.current_answer, questionOptions);
        const questionMarks = Number(question.marks) || 0;
        computedTotal += questionMarks;

        questions.push({
            number: question.number || index + 1,
            title: question.title,
            file: question.file,
            options,
            right_answer: '',
            student_answer: studentAnswer || 'No answer given',
        });
    });

    if (questions.length === 0) {
        return {
            status: 'error',
            message: 'No answer data found for this examination.',
        };
    }

    return {
        status: 'success',
        message: 'Exam answer data retrieved from completed exam responses.',
        data: {
            institution_name: firstData.institute || 'Institution',
            exam_date: new Date().toLocaleString('en-GB'),
            exam_title: firstData.exam_title,
            student_name: firstData.student_name,
            examiner_name: 'Auto Generated',
            questions,
            marks_obtained: 0,
            total_marks: computedTotal,
            remarks: '',
        },
    };
};

export const getOnlineExamAnswers = async (examHash: string, studentId: number): Promise<OnlineExamAnswerResponse> => {
    const attempts: Array<() => Promise<OnlineExamAnswerResponse>> = [
        () => fetchStudentViewExamAutoAnswers(examHash, studentId),
        () => fetchOnlineExamAutoAnswers(examHash, studentId),
        () => fetchExamAnswersFromStudentExamAuto(examHash, studentId),
    ];

    let lastError: OnlineExamAnswerResponse | null = null;

    for (const attempt of attempts) {
        try {
            const payload = await attempt();
            if (payload?.status === 'success' && payload.data) {
                return payload;
            }
            lastError = payload;
        } catch (error: any) {
            console.warn('Exam answer fetch attempt failed:', error?.response?.data || error?.message || error);
            if (error?.response?.data) {
                lastError = error.response.data as OnlineExamAnswerResponse;
            }
        }
    }

    if (lastError) {
        return lastError;
    }

    return {
        status: 'error',
        message: 'Failed to fetch online exam answers.',
    };
};

export const verifyPaymentSuccess = async (paymentData: {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
  amount: number;
  fees_id: number;
  student_id: number;
}) => {
  try {
    // Ensure proper data types - convert amount to integer and fees_id to number
    const processedData = {
      razorpay_payment_id: String(paymentData.razorpay_payment_id),
      razorpay_order_id: String(paymentData.razorpay_order_id),
      razorpay_signature: String(paymentData.razorpay_signature),
      amount: Math.round(Number(paymentData.amount)), // Convert to integer
      fees_id: Number(paymentData.fees_id), // Ensure it's a number
      student_id: Number(paymentData.student_id) // Ensure it's a number
    };

    // Log the processed data for debugging
    console.log('Original payment data:', paymentData);
    console.log('Processed data being sent to API:', processedData);

    // Validate that all required fields have values
    if (!processedData.razorpay_payment_id || !processedData.razorpay_order_id || 
        !processedData.razorpay_signature || processedData.amount <= 0 || 
        processedData.fees_id <= 0 || processedData.student_id <= 0) {
      throw new Error(`Invalid data: ${JSON.stringify(processedData)}`);
    }

    // Try multiple approaches to ensure compatibility
    let response: Response | undefined;
    let data: any;
    let success = false;

    // Approach 1: JSON with proper headers
    try {
      console.log('Attempt 1: Sending JSON data with proper headers');
      const jsonData = {
        razorpay_payment_id: processedData.razorpay_payment_id,
        razorpay_order_id: processedData.razorpay_order_id,
        razorpay_signature: processedData.razorpay_signature,
        amount: processedData.amount,
        fees_id: processedData.fees_id,
        student_id: processedData.student_id
      };

      response = await fetch('https://ideatrialbrainweb.com/edu/dashboard/api-payment-success.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(jsonData),
      });

      data = await response.json();
      console.log('JSON API Response:', data);
      
      if (response.ok && data.status !== 'error') {
        success = true;
      }
    } catch (jsonError) {
      console.log('JSON approach failed:', jsonError);
    }

    // Approach 2: Form data if JSON failed
    if (!success) {
      try {
        console.log('Attempt 2: Sending form data');
        const params = new URLSearchParams();
        params.append('razorpay_payment_id', processedData.razorpay_payment_id);
        params.append('razorpay_order_id', processedData.razorpay_order_id);
        params.append('razorpay_signature', processedData.razorpay_signature);
        params.append('amount', processedData.amount.toString());
        params.append('fees_id', processedData.fees_id.toString());
        params.append('student_id', processedData.student_id.toString());

        response = await fetch('https://ideatrialbrainweb.com/edu/dashboard/api-payment-success.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: params.toString(),
        });

        data = await response.json();
        console.log('Form data API Response:', data);
        
        if (response.ok && data.status !== 'error') {
          success = true;
        }
      } catch (formError) {
        console.log('Form data approach failed:', formError);
      }
    }

    // Approach 3: Raw form data as last resort
    if (!success) {
      try {
        console.log('Attempt 3: Sending raw form data');
        const formData = new FormData();
        formData.append('razorpay_payment_id', processedData.razorpay_payment_id);
        formData.append('razorpay_order_id', processedData.razorpay_order_id);
        formData.append('razorpay_signature', processedData.razorpay_signature);
        formData.append('amount', processedData.amount.toString());
        formData.append('fees_id', processedData.fees_id.toString());
        formData.append('student_id', processedData.student_id.toString());

        response = await fetch('https://ideatrialbrainweb.com/edu/dashboard/api-payment-success.php', {
          method: 'POST',
          body: formData,
        });

        data = await response.json();
        console.log('Raw form data API Response:', data);
        
        if (response.ok && data.status !== 'error') {
          success = true;
        }
      } catch (rawFormError) {
        console.log('Raw form data approach failed:', rawFormError);
      }
    }

    if (!success) {
      throw new Error('All API communication methods failed');
    }
    
    // Check if the response indicates an error
    if (!response || !response.ok || data.status === 'error') {
      throw new Error(data?.message || `Payment verification failed with status ${response?.status || 'unknown'}`);
    }

    return data;
  } catch (error) {
    console.error('Payment verification error:', error);
    throw error;
  }
};

// Payment verification API function
export const verifyPaymentSignature = async (paymentData: {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
  amount: number;
  fees_id: number;
  student_id: number;
}) => {
  try {
    // This would call your PHP verification endpoint
    const response = await fetch('https://ideatrialbrainweb.com/edu/dashboard/api-payment-verify.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(paymentData),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Payment verification failed');
    }

    return data;
  } catch (error) {
    console.error('Payment verification error:', error);
    throw error;
  }
};

// Homework API functions for offline examinations
export const fetchHomework = async (adminId: number, adminType: string, adminBranch: number) => {
  try {
    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-homework.php?admin_id=${adminId}&admin_type=${adminType}&admin_branch=${adminBranch}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch homework:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const createHomework = async (data: {
  homework_title: string;
  homework_description: string;
  homework_subject: number;
  homework_class: number;
  homework_section: number[];
  homework_full_marks: number;
  admin_id: number;
  admin_branch: number;
}) => {
  try {
    const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-homework.php`, data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to create homework:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const updateHomework = async (homeworkId: number, data: {
  homework_title: string;
  homework_description: string;
  homework_subject: number;
  homework_class: number;
  homework_section: number[];
  homework_full_marks: number;
  admin_id: number;
  admin_branch: number;
  admin_type?: string;
}) => {
  try {
    // Try using URLSearchParams first (application/x-www-form-urlencoded)
    const params = new URLSearchParams();
    params.append('homework_id', homeworkId.toString());
    params.append('homework_title', data.homework_title);
    params.append('homework_description', data.homework_description || '');
    params.append('homework_subject', data.homework_subject.toString());
    params.append('homework_class', data.homework_class.toString());
    params.append('homework_section', data.homework_section.join(','));
    params.append('homework_full_marks', data.homework_full_marks.toString());
    params.append('admin_branch', data.admin_branch.toString());
    params.append('admin_type', data.admin_type || 'Admin');
    params.append('admin_id', data.admin_id.toString());

    // Debug: Log the data being sent
    console.log('🔍 Data being sent:');
    console.log('  homework_id:', homeworkId.toString());
    console.log('  homework_title:', data.homework_title);
    console.log('  homework_description:', data.homework_description || '');
    console.log('  homework_subject:', data.homework_subject.toString());
    console.log('  homework_class:', data.homework_class.toString());
    console.log('  homework_section:', data.homework_section.join(','));
    console.log('  homework_full_marks:', data.homework_full_marks.toString());
    console.log('  admin_branch:', data.admin_branch.toString());
    console.log('  admin_type:', data.admin_type || 'Admin');
    console.log('  admin_id:', data.admin_id.toString());

    const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-edit-homework.php`, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    
    // Check if response is HTML (error page) instead of JSON
    if (typeof response.data === 'string' && response.data.includes('<br />')) {
      console.error('🔍 Received HTML error page instead of JSON:', response.data);
      throw new Error('API returned HTML error page. Check server configuration.');
    }
    
    return response.data;
  } catch (error: any) {
    console.error("Failed to update homework:", error.response?.data || error.message);
    
    // Handle HTML error responses
    if (error.response?.data && typeof error.response.data === 'string' && error.response.data.includes('<br />')) {
      console.error('🔍 PHP Error Response:', error.response.data);
      throw new Error('Server error: PHP fatal error occurred. Please check the API endpoint.');
    }
    
    throw error.response?.data || error;
  }
};

export const deleteHomework = async (homeworkId: number, adminBranch: number) => {
  try {
    // For delete, we'll use POST with a delete action
    const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-homework.php`, {
      action: 'delete',
      homework_id: homeworkId,
      admin_branch: adminBranch
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to delete homework:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const publishHomework = async (homeworkId: number, startDate: string, endDate: string, adminBranch: number) => {
  try {
    // For publish, we'll use POST with a publish action
    const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-homework.php`, {
      action: 'publish',
      homework_id: homeworkId,
      homework_start_date: startDate,
      homework_end_date: endDate,
      admin_branch: adminBranch
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to publish homework:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Publish homework with new API (includes package, teachers, students)
export const publishHomeworkNew = async (homeworkId: number, publishData: {
  admin_id: number;
  admin_branch: number;
  package_id: number;
  from_date_time: string; // Format: Y-m-d\TH:i (e.g., "2024-01-15T10:30")
  to_date_time: string;   // Format: Y-m-d\TH:i (e.g., "2024-01-22T10:30")
  checking_teachers: number[];
  students: number[];
}) => {
  try {
    // Prepare JSON payload matching PHP API requirements
    const requestData = {
      homework_id: homeworkId,
      admin_id: publishData.admin_id,
      admin_branch: publishData.admin_branch,
      package_id: publishData.package_id,
      from_date_time: publishData.from_date_time,
      to_date_time: publishData.to_date_time,
      checking_teachers: publishData.checking_teachers,
      students: publishData.students
    };
    
    console.log("📤 Publishing homework with JSON payload:", requestData);
    console.log("📋 Request data structure:", {
      homework_id: requestData.homework_id,
      admin_id: requestData.admin_id,
      admin_branch: requestData.admin_branch,
      package_id: requestData.package_id,
      teachers_count: requestData.checking_teachers.length,
      students_count: requestData.students.length
    });
    
    // Send as JSON (not FormData) - PHP API expects JSON
    const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-publish-homework.php`, requestData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    console.log("✅ API Response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("❌ Failed to publish homework:", error.response?.data || error.message);
    console.error("📋 Error details:", {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    throw error.response?.data || error;
  }
};

// Add new function to view homework details
export const viewHomework = async (homeworkId: number, adminBranch: number) => {
  try {
    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-homework.php?action=view&id=${homeworkId}&admin_branch=${adminBranch}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to view homework:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Add new function to fetch homework questions
export const fetchHomeworkQuestions = async (homeworkId: number) => {
  try {
    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-view-homework.php?homework_id=${homeworkId}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch homework questions:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Student Promotion API functions
export const searchStudentsForPromotion = async (studentClass: number, studentSections: string, adminBranch: number) => {
  try {
    const formData = new FormData();
    formData.append('student_class', studentClass.toString());
    formData.append('student_sections', studentSections);
    formData.append('admin_branch', adminBranch.toString());

    const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion.php?endpoint=search`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to search students for promotion:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const promoteStudents = async (studentIds: number[], excludedStudents: string[], promotedClass: number, adminBranch: number) => {
  try {
    const formData = new FormData();
    studentIds.forEach(id => formData.append('student_id[]', id.toString()));
    formData.append('excluded_students', excludedStudents.join(','));
    formData.append('promoted_student_class', promotedClass.toString());
    formData.append('admin_branch', adminBranch.toString());

    const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion.php?endpoint=promote`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to promote students:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Student Promotion XI API functions
export const searchStudentsForPromotionXi = async (studentClass: number, studentSection: number, adminBranch: number) => {
  try {
    const formData = new FormData();
    formData.append('student_class', studentClass.toString());
    formData.append('student_section', studentSection.toString());
    formData.append('admin_branch', adminBranch.toString());

    const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion2.php?endpoint=search`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to search students for promotion XI:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const promoteStudentsXi = async (studentIds: number[], studentRollNumbers: string[], promotedClass: number, promotedSection: number, adminBranch: number) => {
  try {
    const formData = new FormData();
    studentIds.forEach(id => formData.append('student_id[]', id.toString()));
    studentRollNumbers.forEach(rollNumber => formData.append('student_roll_number[]', rollNumber));
    formData.append('promoted_student_class', promotedClass.toString());
    formData.append('promoted_student_section', promotedSection.toString());
    formData.append('admin_branch', adminBranch.toString());

    const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion2.php?endpoint=promote`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to promote students XI:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// API functions for XII student promotion
export const searchStudentsXii = async (adminBranch: number, adminId: number, studentClass: number, studentSection: number) => {
  try {
    const formData = new FormData();
    formData.append('action', 'search');
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', adminId.toString());
    formData.append('student_class', studentClass.toString());
    formData.append('student_section', studentSection.toString());

    const response = await axios.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion2.php`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
      },
      timeout: 30000,
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to search students XII:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const promoteStudentsXii = async (studentIds: number[], studentRollNumbers: string[], promotedClass: number, promotedSection: number, adminBranch: number, adminId: number) => {
  try {
    console.log('Calling promoteStudentsXii with:', { 
      studentIds, 
      studentRollNumbers, 
      promotedClass, 
      promotedSection, 
      adminBranch, 
      adminId 
    });
    
    const formData = new FormData();
    formData.append('action', 'promote');
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', adminId.toString());
    studentIds.forEach(id => formData.append('student_id[]', id.toString()));
    studentRollNumbers.forEach(rollNumber => formData.append('student_roll_number[]', rollNumber));
    formData.append('promoted_class', promotedClass.toString());
    formData.append('promoted_section', promotedSection.toString());

    console.log('FormData contents:');
    console.log('student_id[]:', studentIds);
    console.log('student_roll_number[]:', studentRollNumbers);
    console.log('promoted_class:', promotedClass);
    console.log('promoted_section:', promotedSection);
    console.log('admin_branch:', adminBranch);
    console.log('admin_id:', adminId);

    const response = await axios.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion2.php`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
      },
      timeout: 30000,
    });
    
    console.log('promoteStudentsXii API response:', response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to promote students XII:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getClassesXii = async (adminBranch: number) => {
  try {
    console.log('Calling getClassesXii with:', { adminBranch });
    const url = `https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion2.php?admin_branch=${adminBranch}`;
    console.log('API URL:', url);
    
    // Use axios directly instead of the configured api instance
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      timeout: 30000,
    });
    console.log('getClassesXii API response:', response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch classes XII:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getSectionsXii = async (adminBranch: number, classId: number) => {
  try {
    console.log('Calling getSectionsXii with:', { adminBranch, classId });
    const url = `https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion2.php?admin_branch=${adminBranch}&class_id=${classId}`;
    console.log('API URL:', url);
    
    // Use axios directly instead of the configured api instance
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      timeout: 30000,
    });
    console.log('getSectionsXii API response:', response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch sections XII:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Package API functions for exam publishing
export const getUnusedPackages = async (branchId: number, adminType: string) => {
  try {
    console.log("📦 Fetching UNUSED packages with:", { branchId, adminType });
    
    // The API endpoint should return only packages with package_use_status = 'No'
    const response = await api.get(`/manage/dashboard/ajax/api-get-package.php?endpoint=fetch&admin_branch=${branchId}&admin_type=${adminType}`);
    console.log("📦 Unused packages API response:", response.data);
    
    // Additional client-side filtering to ensure only UNUSED packages
    // Matches PHP API requirements:
    // 1. package_use_status = 'No'
    // 2. package_payment_status = 1
    // 3. package_type = 'Online Examination(Auto)'
    // 4. Package not expired (if validity info available)
    
    if (response.data && response.data.status === "success" && Array.isArray(response.data.data)) {
      const now = new Date();
      
      const unusedPackages = response.data.data.filter((pkg: any) => {
        // Check 1: Must be unused (package_use_status = 'No')
        const isUnused = pkg.package_use_status === 'No' || pkg.package_use_status === 'no' || pkg.package_use_status === 0;
        if (!isUnused) {
          console.log(`⚠️ Filtering out USED package: ${pkg.package_title || pkg.title} (status: ${pkg.package_use_status})`);
          return false;
        }
        
        // Check 2: Must be paid (package_payment_status = 1)
        const isPaid = pkg.package_payment_status === 1 || pkg.package_payment_status === '1';
        if (!isPaid) {
          console.log(`⚠️ Filtering out UNPAID package: ${pkg.package_title || pkg.title} (payment status: ${pkg.package_payment_status})`);
          return false;
        }
        
        // Check 3: Must be Online Examination(Auto) type
        const isCorrectType = pkg.package_type === 'Online Examination(Auto)';
        if (!isCorrectType) {
          console.log(`⚠️ Filtering out WRONG TYPE package: ${pkg.package_title || pkg.title} (type: ${pkg.package_type})`);
          return false;
        }
        
        // Check 4: Must not be expired (if validity info available)
        if (pkg.package_payment_date && pkg.package_use_validity) {
          const paymentDate = new Date(pkg.package_payment_date);
          const validityDays = parseInt(pkg.package_use_validity);
          const expiryDate = new Date(paymentDate.getTime() + validityDays * 24 * 60 * 60 * 1000);
          
          if (now > expiryDate) {
            console.log(`⚠️ Filtering out EXPIRED package: ${pkg.package_title || pkg.title} (expired: ${expiryDate.toISOString()})`);
            return false;
          }
        }
        
        return true;
      });
      
      console.log(`✅ Filtered from ${response.data.data.length} total to ${unusedPackages.length} VALID UNUSED packages`);
      
      if (unusedPackages.length > 0) {
        console.log(`📋 Valid packages:`, unusedPackages.map((pkg: any) => ({
          id: pkg.id,
          title: pkg.package_title || pkg.title,
          status: pkg.package_use_status,
          type: pkg.package_type
        })));
      }
      
      return {
        ...response.data,
        data: unusedPackages
      };
    }
    
    return response.data;
  } catch (error: any) {
    console.error("❌ Failed to fetch unused packages:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Get unused packages for Offline Examination (Homework)
export const getUnusedPackagesForOffline = async (branchId: number, adminType: string) => {
  try {
    console.log("📦 Fetching UNUSED packages for Offline Examination with:", { branchId, adminType });
    
    // The API endpoint should return only packages with package_use_status = 'No'
    const response = await api.get(`/manage/dashboard/ajax/api-get-package.php?endpoint=fetch&admin_branch=${branchId}&admin_type=${adminType}`);
    console.log("📦 Unused packages API response:", response.data);
    
    // Additional client-side filtering to ensure only UNUSED packages for Offline Examination
    // Matches PHP API requirements:
    // 1. package_use_status = 'No'
    // 2. package_payment_status = 1
    // 3. package_type = 'Offline Examination'
    // 4. Package not expired (if validity info available)
    
    if (response.data && response.data.status === "success" && Array.isArray(response.data.data)) {
      const now = new Date();
      
      const unusedPackages = response.data.data.filter((pkg: any) => {
        // Check 1: Must be unused (package_use_status = 'No')
        const isUnused = pkg.package_use_status === 'No' || pkg.package_use_status === 'no' || pkg.package_use_status === 0;
        if (!isUnused) {
          console.log(`⚠️ Filtering out USED package: ${pkg.package_title || pkg.title} (status: ${pkg.package_use_status})`);
          return false;
        }
        
        // Check 2: Must be paid (package_payment_status = 1)
        const isPaid = pkg.package_payment_status === 1 || pkg.package_payment_status === '1';
        if (!isPaid) {
          console.log(`⚠️ Filtering out UNPAID package: ${pkg.package_title || pkg.title} (payment status: ${pkg.package_payment_status})`);
          return false;
        }
        
        // Check 3: Must be Offline Examination type
        const isCorrectType = pkg.package_type === 'Offline Examination';
        if (!isCorrectType) {
          console.log(`⚠️ Filtering out WRONG TYPE package: ${pkg.package_title || pkg.title} (type: ${pkg.package_type})`);
          return false;
        }
        
        // Check 4: Must not be expired (if validity info available)
        if (pkg.package_payment_date && pkg.package_use_validity) {
          const paymentDate = new Date(pkg.package_payment_date);
          const validityDays = parseInt(pkg.package_use_validity);
          const expiryDate = new Date(paymentDate.getTime() + validityDays * 24 * 60 * 60 * 1000);
          
          if (now > expiryDate) {
            console.log(`⚠️ Filtering out EXPIRED package: ${pkg.package_title || pkg.title} (expired: ${expiryDate.toISOString()})`);
            return false;
          }
        }
        
        return true;
      });
      
      console.log(`✅ Filtered from ${response.data.data.length} total to ${unusedPackages.length} VALID UNUSED packages for Offline Examination`);
      
      if (unusedPackages.length > 0) {
        console.log(`📋 Valid packages:`, unusedPackages.map((pkg: any) => ({
          id: pkg.id,
          title: pkg.package_title || pkg.title,
          status: pkg.package_use_status,
          type: pkg.package_type
        })));
      }
      
      return {
        ...response.data,
        data: unusedPackages
      };
    }
    
    return response.data;
  } catch (error: any) {
    console.error("❌ Failed to fetch unused packages for offline examination:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Keep the old function name for backward compatibility
export const getAllPackages = async (branchId: number, adminType: string) => {
  return getUnusedPackages(branchId, adminType);
};

// Keep the old function name for backward compatibility
export const getPackagesForExam = async (examId: number, branchId: number, adminType: string) => {
  return getAllPackages(branchId, adminType);
};

export const getPackageById = async (packageId: number) => {
  try {
    console.log("Fetching package by ID:", packageId);
    
    const response = await api.get(`/manage/dashboard/ajax/api-get-package.php?endpoint=fetch&id=${packageId}`);
    console.log("getPackageById API response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch package by ID:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};



// Students API functions for exam publishing
export const getStudentsForExam = async (branchId: number, examSections: string) => {
  try {
    console.log("🔍 getStudentsForExam called with:", { branchId, examSections });
    
    // Fetch all students from the branch
    const studentsResponse = await getAllStudents(branchId);
    console.log("📋 All students response received");
    
    // Parse exam sections (comma-separated string of section IDs)
    const sectionIds = examSections.split(',').map(id => id.trim());
    console.log("🎯 Target section IDs:", sectionIds);
    
    // Extract students data from response
    let allStudents = [];
    if (studentsResponse && studentsResponse.status === "success" && Array.isArray(studentsResponse.data)) {
      allStudents = studentsResponse.data;
    } else if (studentsResponse && Array.isArray(studentsResponse)) {
      allStudents = studentsResponse;
    } else if (studentsResponse && studentsResponse.data && Array.isArray(studentsResponse.data)) {
      allStudents = studentsResponse.data;
    } else if (studentsResponse && studentsResponse.students && Array.isArray(studentsResponse.students)) {
      allStudents = studentsResponse.students;
    } else {
      console.error("❌ Invalid students response structure:", studentsResponse);
      return {
        status: "success",
        data: []
      };
    }
    
    console.log(`📊 Total students in branch: ${allStudents.length}`);
    
    // Log sample student to understand structure
    if (allStudents.length > 0) {
      console.log("📝 Sample student structure:", {
        id: allStudents[0].id,
        name: allStudents[0].student_name,
        section: allStudents[0].student_section || allStudents[0].section,
        status: allStudents[0].student_status,
        fullObject: allStudents[0]
      });
    }
    
    // Filter students by exam sections
    const filteredStudents = allStudents.filter((student: any) => {
      const studentSection = String(student.student_section || student.section);
      const isInExamSection = sectionIds.includes(studentSection);
      
      // Also check if student is active
      const isActive = student.student_status === 1 || student.student_status === "1";
      
      // Debug logging for filtering
      if (isInExamSection) {
        console.log(`✅ Student ${student.student_name} (section: ${studentSection}) matches exam sections`);
      }
      
      return isInExamSection && isActive;
    });
    
    console.log(`✅ Filtered ${allStudents.length} students to ${filteredStudents.length} for sections: ${sectionIds.join(', ')}`);
    
    if (filteredStudents.length > 0) {
      console.log(`📋 Filtered students:`, filteredStudents.map((s: any) => ({
        id: s.id,
        name: s.student_name,
        section: s.student_section || s.section
      })));
    }
    
    return {
      status: "success",
      data: filteredStudents
    };
  } catch (error: any) {
    console.error("❌ Failed to fetch students for exam:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Direct teachers fetch function for exam publishing
export const getTeachersForExamPublishing = async (branchId: number) => {
  try {
    // Try to fetch teachers from the teachers list API
    const response = await api.get(`/manage/dashboard/api-teacher.php?admin_branch=${branchId}&action=list`);
    console.log("getTeachersForExamPublishing API response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch teachers for exam publishing:", error.response?.data || error.message);
    
    // Fallback to getAllTeachers
    try {
      const fallbackResponse = await getAllTeachers(branchId);
      console.log("Fallback getAllTeachers response:", fallbackResponse);
      return fallbackResponse;
    } catch (fallbackError: any) {
      console.error("Fallback getAllTeachers also failed:", fallbackError.response?.data || fallbackError.message);
      throw fallbackError.response?.data || fallbackError;
    }
  }
};

// Homework Answer API functions
export const homeworkAnswerApi = {
  // Get list of homeworks for the teacher/admin
  getHomeworks: async (params: {
    admin_id: string;
    admin_branch: string;
    admin_type: string;
  }) => {
    try {
      const response = await api.get('https://ideatrialbrainweb.com/edu/manage/dashboard/api-homework-answer.php', {
        params: {
          endpoint: 'list-homeworks',
          admin_id: params.admin_id,
          admin_type: params.admin_type
        }
      });
      return response.data;
    } catch (error: any) {
      console.error("Failed to fetch homeworks:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  },

  // Get list of submissions for a specific homework
  getHomeworkSubmissions: async (homeworkHash: string) => {
    try {
      const response = await api.get('https://ideatrialbrainweb.com/edu/manage/dashboard/api-homework-answer.php', {
        params: {
          endpoint: 'list-submissions',
          homework_hash: homeworkHash
        }
      });
      return response.data;
    } catch (error: any) {
      console.error("Failed to fetch homework submissions:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  }
};

// Homework List API functions
export const homeworkListApi = {
  // Get list of all homeworks for the branch (simplified list)
  getHomeworkList: async (adminBranch: string) => {
    try {
      const response = await api.get('https://ideatrialbrainweb.com/edu/manage/dashboard/api-homework-list.php', {
        params: {
          endpoint: 'list-exams',
          admin_branch: adminBranch
        }
      });
      return response.data;
    } catch (error: any) {
      console.error("Failed to fetch homework list:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  }
};

// Student Homework Answer API functions
export const studentHomeworkAnswerApi = {
  // Fetch student homework answer details
  fetchAnswer: async (params: {
    homework_hash: string;
    student_id: string;
    admin_id: string;
    admin_branch: string;
    admin_type: string;
  }) => {
    try {
      const response = await api.get('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-answer.php', {
        params: {
          endpoint: 'fetch-answer',
          homework_hash: params.homework_hash,
          student_id: params.student_id,
          admin_id: params.admin_id,
          admin_branch: params.admin_branch,
          admin_type: params.admin_type
        }
      });
      return response.data;
    } catch (error: any) {
      console.error("Failed to fetch student homework answer:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  },

  // Submit homework result/remarks
  submitResult: async (data: {
    homework_id: number;
    homework_hash: string;
    homework_title?: string;
    student_id: number;
    result_marks_obtained: string;
    result_remarks: string;
    result_exam_name?: string;
    result_total_marks?: string;
    result_percentage?: string;
    result_status?: string;
    admin_id: number;
    admin_branch: number;
    admin_type: string;
  }) => {
    try {
      const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-answer.php', data, {
        params: {
          endpoint: 'submit-result'
        }
      });
      return response.data;
    } catch (error: any) {
      console.error("Failed to submit homework result:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  }
};

// Check Student Answer API functions
export const checkStudentAnswerApi = {
  // Save annotated answer image
  saveAnnotatedAnswer: async (data: {
    homework_id: number;
    student_id: number;
    index: number;
    data: string; // base64 image data
    admin_id: number;
    admin_branch: number;
    admin_type: string;
  }) => {
    try {
      const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/offline-answer/api-check-student-answer.php', data, {
        params: {
          endpoint: 'save-annotated-answer'
        }
      });
      return response.data;
    } catch (error: any) {
      console.error("Failed to save annotated answer:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  }
};

// Homework Question API functions
export const fetchHomeworkQuestionsList = async (adminId: number, adminType: string, adminBranch: number) => {
  try {
    const response = await api.get(`https://brainwebskills.com/edu/manage/dashboard/api-homework-question.php?endpoint=list&admin_id=${adminId}&admin_type=${adminType}&admin_branch=${adminBranch}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch homework questions:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const fetchHomeworksForQuestions = async (adminId: number, adminType: string, adminBranch: number) => {
  try {
    const response = await api.get(`https://brainwebskills.com/edu/manage/dashboard/api-homework-question.php?endpoint=fetch-homeworks&admin_id=${adminId}&admin_type=${adminType}&admin_branch=${adminBranch}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch homeworks for questions:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const addHomeworkQuestions = async (data: FormData) => {
  try {
    const response = await api.post(`https://brainwebskills.com/edu/manage/dashboard/api-homework-question.php?endpoint=add`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to add homework questions:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const deleteHomeworkQuestion = async (questionId: number) => {
  try {
    const response = await api.delete(`https://brainwebskills.com/edu/manage/dashboard/api-homework-question.php?endpoint=delete&id=${questionId}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to delete homework question:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// New API functions for the updated marksheet system
export const fetchSectionsForClass = async (classId: number, branchId: number) => {
    try {
        const response = await api.get(
            `https://ideatrialbrainweb.com/edu/manage/dashboard/api-bulk-result-download.php?endpoint=fetch-sections&class_id=${classId}&admin_branch=${branchId}`
        );
        return response.data;
    } catch (error: any) {
        console.error('Failed to fetch sections for class:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const generateMarksheetsNew = async (
    branchId: number,
    classId: number,
    sectionId: number,
    examType: number
) => {
    try {
        const payload = {
            student_class: classId,
            student_section: sectionId,
            exam_type: examType,
            admin_branch: branchId,
        };
        
        console.log('Sending payload to generateMarksheetsNew:', payload);
        const response = await api.post(
            'https://ideatrialbrainweb.com/edu/manage/dashboard/api-bulk-result-download.php?endpoint=generate-marksheets',
            payload,
            { 
                headers: { 
                    'Content-Type': 'application/json',
                } 
            }
        );
        console.log('New API response:', response.data);
        return response.data;
    } catch (error: any) {
        console.error('Failed to generate marksheets with new API:', error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// New PHP API functions for examination management
// These functions use the new PHP API at https://ideatrialbrainweb.com/edu/manage/dashboard/api-examination-manual.php

// List exams using the new PHP API
export const listExamsPHP = async (adminId: number, adminType: string, adminBranch: number) => {
  try {
    // Use full URL since the base URL might not be set correctly
    const response = await axios.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-examination-manual.php`, {
      params: {
        endpoint: 'list-exams',
        admin_id: adminId,
        admin_type: adminType,
        admin_branch: adminBranch
      },
      timeout: 30000, // 30 seconds timeout
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch exams from PHP API:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Add exam using the new PHP API
export const addExamPHP = async (examData: {
  exam_title: string;
  exam_description: string;
  exam_fixed_time: number;
  exam_subject: number;
  exam_class: number;
  exam_section: number[];
  admin_id: number;
  admin_branch: number;
}) => {
  try {
    const response = await axios.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-examination-manual.php`, examData, {
      params: {
        endpoint: 'add-exam'
      },
      timeout: 30000, // 30 seconds timeout
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to add exam via PHP API:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Delete exam using the new PHP API
export const deleteExamPHP = async (examId: number, adminId: number, adminType: string, adminBranch: number) => {
  try {
    const response = await axios.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-examination-manual.php`, {
      exam_id: examId,
      admin_id: adminId,
      admin_type: adminType,
      admin_branch: adminBranch
    }, {
      params: {
        endpoint: 'delete-exam'
      },
      timeout: 30000, // 30 seconds timeout
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to delete exam via PHP API:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Show answer sheet using the new PHP API
export const showAnswerSheetPHP = async (examId: number, adminId: number, adminType: string, adminBranch: number) => {
  try {
    const response = await axios.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-examination-manual.php`, {
      exam_id: examId,
      admin_id: adminId,
      admin_type: adminType,
      admin_branch: adminBranch
    }, {
      params: {
        endpoint: 'show-answer-sheet'
      },
      timeout: 30000, // 30 seconds timeout
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to show answer sheet via PHP API:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Fetch sections for a class using the new PHP API
export const fetchSectionsPHP = async (classId: number, adminBranch: number) => {
  try {
    const response = await axios.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-examination-manual.php`, {
      params: {
        endpoint: 'fetch-sections',
        class_id: classId,
        admin_branch: adminBranch
      },
      timeout: 30000, // 30 seconds timeout
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch sections via PHP API:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Update exam using the new PHP API
export const updateExamPHP = async (examId: number, examData: {
  exam_title: string;
  exam_description: string;
  exam_fixed_time: number;
  exam_subject: number;
  exam_class: number;
  exam_section: number[];
  admin_id: number;
  admin_type: string;
  admin_branch: number;
}) => {
  try {
    const response = await axios.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-examination-manual.php`, {
      ...examData,
      id: examId // PHP API expects 'id' not 'exam_id'
    }, {
      params: {
        endpoint: 'update-exam'
      },
      timeout: 30000, // 30 seconds timeout
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to update exam via PHP API:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Edit exam using the dedicated edit API
export const editExamManual = async (examId: number, examData: {
  exam_title: string;
  exam_description: string;
  exam_fixed_time: number;
  exam_subject: number;
  exam_class: number;
  exam_section: number[];
  admin_id: number;
  admin_type: string;
  admin_branch: number;
}) => {
  try {
    const formData = new FormData();
    formData.append('exam_id', examId.toString());
    formData.append('exam_title', examData.exam_title);
    formData.append('exam_description', examData.exam_description);
    formData.append('exam_fixed_time', examData.exam_fixed_time.toString());
    formData.append('exam_subject', examData.exam_subject.toString());
    formData.append('exam_class', examData.exam_class.toString());
    formData.append('exam_section', examData.exam_section.join(','));
    formData.append('admin_id', examData.admin_id.toString());
    formData.append('admin_type', examData.admin_type);
    formData.append('admin_branch', examData.admin_branch.toString());

    const response = await axios.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-edit-exam-manual.php`, formData, {
      timeout: 30000, // 30 seconds timeout
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to edit exam via PHP API:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// View exam details using the new PHP API
export const viewExamManual = async (examId: number, adminId: number, adminType: string, adminBranch: number) => {
  try {
    const response = await axios.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-view-exam-manual.php`, {
      params: {
        id: examId,
        admin_id: adminId,
        admin_type: adminType,
        admin_branch: adminBranch
      },
      timeout: 30000, // 30 seconds timeout
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to view exam via PHP API:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Question Manual API functions
export const fetchManualQuestions = async (adminId: number, adminType: string, adminBranch: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-question-manual.php?admin_id=${adminId}&admin_type=${adminType}&admin_branch=${adminBranch}`);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch manual questions:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const createManualQuestion = async (formData: FormData) => {
    try {
        const response = await api.post(`/manage/dashboard/api-question-manual.php`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to create manual question:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const updateManualQuestion = async (formData: FormData) => {
    try {
        const response = await api.put(`/manage/dashboard/api-question-manual.php`, formData);
        return response.data;
    } catch (error: any) {
        console.error("Failed to update manual question:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteManualQuestion = async (questionId: number, adminId: number, adminType: string, adminBranch: number) => {
    try {
        const response = await api.delete(`/manage/dashboard/api-question-manual.php`, {
            data: { 
                id: questionId, 
                admin_id: adminId, 
                admin_type: adminType,
                admin_branch: adminBranch
            }
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to delete manual question:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Fetch manual examinations for questions
export const fetchManualExaminations = async (adminId: number, adminType: string, adminBranch: number) => {
    try {
        const response = await listExamsPHP(adminId, adminType, adminBranch);
        return response;
    } catch (error: any) {
        console.error("Failed to fetch manual examinations:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Get question number for manual questions
export const getManualQuestionNumber = async (examId: number, adminId: number, adminType: string, adminBranch: number) => {
    try {
        const response = await api.get(`/manage/dashboard/api-question-manual.php`, {
            params: {
                action: 'question_number',
                question_exam_id: examId,
                admin_id: adminId,
                admin_type: adminType,
                admin_branch: adminBranch
            }
        });
        return response.data;
    } catch (error: any) {
        console.error("Failed to get manual question number:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

// Complete Student Promotion IX API functions
export const getStudentPromotionClasses = async (adminBranch: number) => {
  try {
    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php?admin_branch=${adminBranch}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch promotion classes:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getStudentPromotionSections = async (adminBranch: number, classId: number) => {
  try {
    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php?admin_branch=${adminBranch}&class_id=${classId}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch promotion sections:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const searchStudentsForPromotionIX = async (
  studentClass: number,
  studentSections: string,
  adminBranch: number,
  maxSubjectsBelow25Percent: number = 999
) => {
  try {
    const formData = new FormData();
    
    // Add required admin parameters
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1'); // Default admin ID, you might want to get this from user context
    
    // Add action parameter
    formData.append('action', 'search');
    formData.append('student_class', studentClass.toString());
    formData.append('student_sections', studentSections);
    formData.append('max_subjects_below_25_percent', maxSubjectsBelow25Percent.toString());

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to search students for promotion:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Function to check if promoted class has sections
export const checkPromotedClassSections = async (promotedClass: number, adminBranch: number) => {
  try {
    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php?admin_branch=${adminBranch}&class_id=${promotedClass}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to check promoted class sections:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};



// Get promotion preview (simulation without actual promotion)
export const getPromotionPreview = async (
  studentIds: number[],
  promotedClass: number,
  adminBranch: number
) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('action', 'preview');
    
    studentIds.forEach((id) => {
      formData.append('student_id[]', id.toString());
    });
    
    formData.append('promoted_class', promotedClass.toString());

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to get promotion preview:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Get promotion conflicts (students who might have issues)
export const getPromotionConflicts = async (
  studentIds: number[],
  promotedClass: number,
  adminBranch: number
) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('action', 'conflicts');
    
    studentIds.forEach((id) => {
      formData.append('student_id[]', id.toString());
    });
    
    formData.append('promoted_class', promotedClass.toString());

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to get promotion conflicts:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Get promotion recommendations
export const getPromotionRecommendations = async (
  classId: number,
  adminBranch: number,
  criteria?: {
    attendanceWeight?: number;
    marksWeight?: number;
    behaviorWeight?: number;
    feesWeight?: number;
  }
) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('action', 'recommendations');
    formData.append('class_id', classId.toString());
    
    if (criteria) {
      Object.entries(criteria).forEach(([key, value]) => {
        if (value !== undefined) {
          formData.append(key, value.toString());
        }
      });
    }

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to get promotion recommendations:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Send promotion notifications
export const sendPromotionNotifications = async (
  studentIds: number[],
  adminBranch: number,
  notificationType: 'email' | 'sms' | 'both' = 'email',
  customMessage?: string
) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('action', 'notify');
    formData.append('notification_type', notificationType);
    
    studentIds.forEach((id) => {
      formData.append('student_id[]', id.toString());
    });
    
    if (customMessage) {
      formData.append('custom_message', customMessage);
    }

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to send promotion notifications:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Get promotion audit log
export const getPromotionAuditLog = async (
  adminBranch: number,
  startDate?: string,
  endDate?: string,
  action?: string,
  userId?: number
) => {
  try {
    const params = new URLSearchParams();
    params.append('admin_branch', adminBranch.toString());
    params.append('action', 'audit_log');
    
    if (startDate) {
      params.append('start_date', startDate);
    }
    if (endDate) {
      params.append('end_date', endDate);
    }
    if (action) {
      params.append('log_action', action);
    }
    if (userId) {
      params.append('user_id', userId.toString());
    }
    
    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php?${params.toString()}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to get promotion audit log:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Get promotion templates
export const getPromotionTemplates = async (adminBranch: number) => {
  try {
    const params = new URLSearchParams();
    params.append('admin_branch', adminBranch.toString());
    params.append('action', 'templates');
    
    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php?${params.toString()}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to get promotion templates:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Save promotion template
export const savePromotionTemplate = async (
  adminBranch: number,
  templateName: string,
  templateData: {
    criteria: any;
    settings: any;
    description?: string;
  }
) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('action', 'save_template');
    formData.append('template_name', templateName);
    formData.append('template_data', JSON.stringify(templateData));

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to save promotion template:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Apply promotion template
export const applyPromotionTemplate = async (
  templateId: number,
  studentIds: number[],
  promotedClass: number,
  adminBranch: number
) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('action', 'apply_template');
    formData.append('template_id', templateId.toString());
    formData.append('promoted_class', promotedClass.toString());
    
    studentIds.forEach((id) => {
      formData.append('student_id[]', id.toString());
    });

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to apply promotion template:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const promoteStudentsIX = async (
  studentIds: number[],
  excludedStudents: number[],
  promotedClass: number,
  adminBranch: number
) => {
  try {
    const formData = new FormData();
    
    // Add required admin parameters
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1'); // Default admin ID, you might want to get this from user context
    
    // Add action parameter to trigger promotion logic
    formData.append('action', 'promote');
    
    // Add student IDs as array (matching the API format)
    studentIds.forEach((id) => {
      formData.append('student_id[]', id.toString());
    });
    
    // Add excluded students as array (matching the API format)
    excludedStudents.forEach((id) => {
      formData.append('excluded_students[]', id.toString());
    });
    
    // Add promoted class
    formData.append('promoted_class', promotedClass.toString());

    console.log('Sending promotion request with data:', {
      admin_branch: adminBranch,
      admin_id: '1',
      action: 'promote',
      student_ids: studentIds,
      excluded_students: excludedStudents,
      promoted_class: promotedClass
    });

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    console.log('Promotion API response:', response.data);
    
    // Check if response contains PHP error
    if (typeof response.data === 'string' && response.data.includes('Fatal error')) {
      console.error('PHP Error detected:', response.data);
      throw new Error('Server error: Database query failed. Please check the server logs.');
    }
    
    return response.data;
  } catch (error: any) {
    console.error("Failed to promote students:", error.response?.data || error.message);
    console.error("Full error object:", error);
    throw error.response?.data || error;
  }
};

// Additional helper functions for student promotion
export const getStudentPromotionData = async (adminBranch: number, classId: number) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('get_data', '1');
    formData.append('class_id', classId.toString());

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to get promotion data:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const validateStudentPromotion = async (
  studentIds: number[],
  promotedClass: number,
  adminBranch: number
) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('validate', '1');
    formData.append('student_ids', studentIds.join(','));
    formData.append('promoted_class', promotedClass.toString());

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to validate promotion:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getPromotionHistory = async (adminBranch: number, classId?: number) => {
  try {
    const params = new URLSearchParams({
      admin_branch: adminBranch.toString(),
      admin_id: '1',
      get_history: '1'
    });
    
    if (classId) {
      params.append('class_id', classId.toString());
    }

    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php?${params.toString()}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to get promotion history:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const revertStudentPromotion = async (
  studentIds: number[],
  adminBranch: number
) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('revert', '1');
    formData.append('student_ids', studentIds.join(','));

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to revert promotion:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getPromotionStatistics = async (adminBranch: number, classId?: number) => {
  try {
    const params = new URLSearchParams({
      admin_branch: adminBranch.toString(),
      admin_id: '1',
      get_stats: '1'
    });
    
    if (classId) {
      params.append('class_id', classId.toString());
    }

    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php?${params.toString()}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to get promotion statistics:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const exportPromotionReport = async (
  adminBranch: number,
  classId: number,
  format: 'pdf' | 'excel' = 'pdf'
) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('export_report', '1');
    formData.append('class_id', classId.toString());
    formData.append('format', format);

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      responseType: 'blob', // For file downloads
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to export promotion report:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const bulkPromoteStudents = async (
  promotionData: {
    studentIds: number[];
    excludedStudents: number[];
    promotedClass: number;
    rollNumbers?: string[];
    sections?: number[];
  }[],
  adminBranch: number
) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('bulk_promote', '1');
    formData.append('promotion_data', JSON.stringify(promotionData));

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to bulk promote students:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getPromotionEligibility = async (
  studentId: number,
  adminBranch: number
) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('check_eligibility', '1');
    formData.append('student_id', studentId.toString());

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to check promotion eligibility:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const updatePromotionSettings = async (
  settings: {
    maxSubjectsBelow25Percent: number;
    requireFeesPaid: boolean;
    requireAttendance: boolean;
    minimumAttendancePercentage: number;
  },
  adminBranch: number
) => {
  try {
    const formData = new FormData();
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', '1');
    formData.append('update_settings', '1');
    formData.append('settings', JSON.stringify(settings));

    const response = await api.post('https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to update promotion settings:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getPromotionSettings = async (adminBranch: number) => {
  try {
    const params = new URLSearchParams({
      admin_branch: adminBranch.toString(),
      admin_id: '1',
      get_settings: '1'
    });

    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion1.php?${params.toString()}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to get promotion settings:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// New API functions for the updated student promotion API
export const getPromotionClasses = async (adminBranch: number) => {
  try {
    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion2.php?admin_branch=${adminBranch}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch promotion classes:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getPromotionSections = async (adminBranch: number, classId: number) => {
  try {
    const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion2.php?admin_branch=${adminBranch}&class_id=${classId}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch promotion sections:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const searchPromotionStudents = async (adminBranch: number, adminId: number, studentClass: number, studentSection: number) => {
  try {
    const formData = new FormData();
    formData.append('action', 'search');
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', adminId.toString());
    formData.append('student_class', studentClass.toString());
    formData.append('student_section', studentSection.toString());

    const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion2.php`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to search promotion students:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const promoteStudentsNew = async (adminBranch: number, adminId: number, studentIds: number[], studentRollNumbers: string[], promotedClass: number, promotedSection: number) => {
  try {
    const formData = new FormData();
    formData.append('action', 'promote');
    formData.append('admin_branch', adminBranch.toString());
    formData.append('admin_id', adminId.toString());
    studentIds.forEach(id => formData.append('student_id[]', id.toString()));
    studentRollNumbers.forEach(rollNumber => formData.append('student_roll_number[]', rollNumber));
    formData.append('promoted_class', promotedClass.toString());
    formData.append('promoted_section', promotedSection.toString());

    const response = await api.post(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-student-promotion2.php`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to promote students:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getBulkCumulativeDownload = async (adminBranch: number, studentClass: number, studentSection: number) => {
  try {
    console.log('Making API call to bulk cumulative download with params:', {
      admin_branch: adminBranch,
      student_class: studentClass,
      student_section: studentSection
    });

    const params = new URLSearchParams({
      admin_branch: adminBranch.toString(),
      student_class: studentClass.toString(),
      student_section: studentSection.toString()
    });

    // Try using the existing API instance first
    try {
      const response = await api.get(`https://ideatrialbrainweb.com/edu/manage/dashboard/api-bulk-cumulative-download.php?${params.toString()}`);
      console.log('API Response (using api instance):', response);
      return response.data;
    } catch (apiError) {
      console.log('API instance failed, trying direct axios call');
      
      // Fallback to direct axios call with better error handling
      const response = await axios.get(
        `https://ideatrialbrainweb.com/edu/manage/dashboard/api-bulk-cumulative-download.php?${params.toString()}`,
        {
          timeout: 30000, // 30 seconds timeout
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      );
      
      console.log('API Response (direct axios):', response);
      console.log('API Response Data:', response.data);
      
      return response.data;
    }
  } catch (error: any) {
    console.error("Failed to fetch bulk cumulative download data:", error);
    console.error("Error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    console.error("Error message:", error.message);
    
    // Return a more detailed error message
    const errorMessage = error.response?.data?.message || error.message || 'Unknown error occurred';
    throw {
      success: false,
      message: `Failed to fetch bulk cumulative download data: ${errorMessage}`,
      error: error.response?.data || error
    };
  }
};

// Alternative approach using the existing bulk-result-download API
// Test function to check if the API endpoint exists
export const testBulkCumulativeDownloadAPI = async () => {
  try {
    console.log('Testing if bulk cumulative download API endpoint exists...');
    
    const response = await axios.get(
      'https://ideatrialbrainweb.com/edu/manage/dashboard/api-bulk-cumulative-download.php',
      {
        timeout: 10000,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    );
    
    console.log('API endpoint test response:', response);
    return { exists: true, response: response.data };
  } catch (error: any) {
    console.log('API endpoint test failed:', error.response?.status, error.message);
    return { 
      exists: false, 
      status: error.response?.status, 
      message: error.message,
      data: error.response?.data 
    };
  }
};

export const getBulkCumulativeDownloadAlternative = async (adminBranch: number, studentClass: number, studentSection: number) => {
  try {
    console.log('Making alternative API call to bulk result download with params:', {
      admin_branch: adminBranch,
      student_class: studentClass,
      student_section: studentSection
    });

    // Use GET request instead of POST to avoid CORS issues
    const params = new URLSearchParams({
      endpoint: 'cumulative-download',
      admin_branch: adminBranch.toString(),
      student_class: studentClass.toString(),
      student_section: studentSection.toString()
    });
    
    console.log('Sending GET request to alternative API with params:', params.toString());
    const response = await api.get(
      `https://ideatrialbrainweb.com/edu/manage/dashboard/api-bulk-result-download.php?${params.toString()}`
    );
    console.log('Alternative API response:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('Failed to fetch bulk cumulative download with alternative API:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// New API endpoint for classes IX-X bulk cumulative download
export const getBulkCumulativeDownloadIX_X = async (adminBranch: number, studentClass: number, studentSection: number) => {
  try {
    console.log('Making API call to bulk cumulative download IX-X with params:', {
      admin_branch: adminBranch,
      student_class: studentClass,
      student_section: studentSection
    });

    const params = new URLSearchParams({
      admin_branch: adminBranch.toString(),
      student_class: studentClass.toString(),
      student_section: studentSection.toString()
    });

    const response = await axios.get(
      `https://ideatrialbrainweb.com/edu/manage/dashboard/api-bulk-cumulative-download1.php?${params.toString()}`,
      {
        timeout: 30000, // 30 seconds timeout
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    );
    
    console.log('API Response (IX-X):', response);
    console.log('API Response Data:', response.data);
    
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch bulk cumulative download IX-X data:", error);
    console.error("Error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    console.error("Error message:", error.message);
    
    const errorMessage = error.response?.data?.message || error.message || 'Unknown error occurred';
    throw {
      success: false,
      message: `Failed to fetch bulk cumulative download IX-X data: ${errorMessage}`,
      error: error.response?.data || error
    };
  }
};
export const getBulkCumulativeDownloadXI_XII = async (adminBranch: number, studentClass: number, studentSection: number) => {
  try {
    console.log('Making API call to bulk cumulative download XI-XII with params:', {
      admin_branch: adminBranch,
      student_class: studentClass,
      student_section: studentSection
    });

    const params = new URLSearchParams({
      admin_branch: adminBranch.toString(),
      student_class: studentClass.toString(),
      student_section: studentSection.toString()
    });

    const response = await axios.get(
      `https://ideatrialbrainweb.com/edu/manage/dashboard/api-bulk-cumulative-download1.php?${params.toString()}`,
      {
        timeout: 30000, // 30 seconds timeout
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    );
    
    console.log('API Response (IX-X):', response);
    console.log('API Response Data:', response.data);
    
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch bulk cumulative download IX-X data:", error);
    console.error("Error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    console.error("Error message:", error.message);
    
    const errorMessage = error.response?.data?.message || error.message || 'Unknown error occurred';
    throw {
      success: false,
      message: `Failed to fetch bulk cumulative download IX-X data: ${errorMessage}`,
      error: error.response?.data || error
    };
  }
};
// Third alternative: Use existing cumulative marks APIs and aggregate results
export const getBulkCumulativeDownloadFallback = async (adminBranch: number, studentClass: number, studentSection: number) => {
  try {
    console.log('Making fallback API call using existing cumulative marks APIs...');
    
    // First, get all students for the class and section
    const studentsResponse = await api.get(
      `/manage/dashboard/api-filter.php?branch_id=${adminBranch}&class_id=${studentClass}&section_id=${studentSection}`
    );
    
    if (!studentsResponse.data.success || !studentsResponse.data.data) {
      throw new Error('Failed to fetch students list');
    }
    
    const students = studentsResponse.data.data;
    console.log('Found students:', students.length);
    
    // Get cumulative marks for each student using existing API
    const marksheets = [];
    const examTypes = [];
    const formativeIndicators = [];
    
    for (const student of students) {
      try {
        console.log(`Fetching marks for student ${student.id} (${student.name})`);
        
        // Use the correct cumulative marks API based on class
        // For classes V-VIII, use the basic cumulative marks API
        const marksheetResponse = await api.get(
          `/manage/dashboard/api-cumulative_marks.php?id=${student.id}`
        );
        
        console.log(`Student ${student.id} API response:`, marksheetResponse.data);
        
        if (marksheetResponse.data.success && marksheetResponse.data.data) {
          const studentData = marksheetResponse.data.data;
          
          // Transform the data to match our expected format
          const transformedMarksheet = {
            student_id: student.id,
            student_name: student.name || student.student_name || 'Unknown',
            student_roll_number: student.roll_number || student.student_roll_number || 'N/A',
            student_guardian_name: student.guardian_name || student.student_guardian_name || 'N/A',
            class_name: student.class_name || 'V',
            section_name: student.section_name || 'A',
            branch_name: studentData.branch_name || 'Main Branch',
            branch_location: studentData.branch_location || 'City Center',
            branch_institution_head: studentData.branch_institution_head || 'Dr. Smith',
            branch_pin_code: studentData.branch_pin_code || '12345',
            branch_institution_head_contact: studentData.branch_institution_head_contact || '9876543210',
            branch_institution_code: studentData.branch_institution_code || 'SCH001',
            logo_url: studentData.logo_url || '',
            signature_url: studentData.signature_url || '',
            marks: studentData.marks || studentData.subject_marks || [],
            total_obtained_marks: studentData.total_obtained_marks || studentData.total_marks_obtained || 0,
            total_max_marks: studentData.total_max_marks || studentData.total_marks || 0,
            overall_percentage: studentData.overall_percentage || studentData.percentage || 0,
            overall_grade: studentData.overall_grade || studentData.grade || 'D'
          };
          
          console.log(`Transformed marksheet for student ${student.id}:`, transformedMarksheet);
          marksheets.push(transformedMarksheet);
          
          // Collect exam types and formative indicators from the first student
          if (marksheets.length === 1) {
            examTypes.push(...(studentData.exam_types || studentData.exam_type || []));
            formativeIndicators.push(...(studentData.formative_indicators || studentData.formative || []));
          }
        } else {
          console.log(`Student ${student.id} API returned no data:`, marksheetResponse.data);
        }
      } catch (studentError) {
        console.error(`Failed to fetch marks for student ${student.id}:`, studentError);
        // Continue with other students
      }
    }
    
    if (marksheets.length === 0) {
      throw new Error('No marksheet data found for any students');
    }
    
    // Grading scale
    const grading_scale = [
      { range: '90-100', grade: 'A+' },
      { range: '80-89', grade: 'A' },
      { range: '70-79', grade: 'B+' },
      { range: '60-69', grade: 'B' },
      { range: '45-59', grade: 'C+' },
      { range: '25-44', grade: 'C' },
      { range: 'Below 25', grade: 'D' }
    ];
    
    const response_data = {
      marksheets: marksheets,
      exam_types: examTypes,
      formative_indicators: formativeIndicators,
      grading_scale: grading_scale
    };
    
    console.log('Fallback API response:', response_data);
    return {
      success: true,
      message: 'Marksheet data retrieved successfully using fallback method',
      data: response_data
    };
    
  } catch (error: any) {
    console.error('Failed to fetch bulk cumulative download with fallback API:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// Teacher QR Attendance APIs
export interface TeacherQrSession {
  token: string;
  branch_id: number;
  expires_at: string;
  expires_in_seconds: number;
}

export interface TeacherQrAttendanceRecord {
  id?: number;
  teacher_id: number;
  teacher_name: string;
  teacher_code?: string;
  status: string;
  check_in_time: string;
  date?: string;
  location_verified?: boolean;
  distance_meters?: number;
}

export interface TeacherQrAttendanceLocationSettings {
  branchId: number;
  label: string;
  latitude: number;
  longitude: number;
  radiusMeters: number;
  enabled: boolean;
}

export interface TeacherQrReportSummary {
  total: number;
  present: number;
  late: number;
  unique_teachers: number;
  active_days: number;
  on_time_rate: number;
}

export interface TeacherQrReportBreakdownItem {
  label: string;
  total: number;
  present: number;
  late: number;
  date?: string;
  month?: string;
}

export interface TeacherQrAttendanceReport {
  view: "day" | "month" | "year";
  period_label: string;
  period_start: string;
  period_end: string;
  summary: TeacherQrReportSummary;
  breakdown: TeacherQrReportBreakdownItem[];
  records: TeacherQrAttendanceRecord[];
}

export const getTeacherQrSession = async (branchId: number, adminId: number) => {
  try {
    const response = await api.get(
      `/manage/dashboard/api-teacher-qr-session.php?branch_id=${branchId}&admin_id=${adminId}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch teacher QR session:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const markTeacherQrAttendance = async (params: {
  token: string;
  branch_id: number;
  teacher_id: number;
  latitude?: number;
  longitude?: number;
}) => {
  try {
    const formData = new URLSearchParams();
    formData.append("token", params.token);
    formData.append("branch_id", String(params.branch_id));
    formData.append("teacher_id", String(params.teacher_id));
    if (params.latitude != null) {
      formData.append("latitude", String(params.latitude));
    }
    if (params.longitude != null) {
      formData.append("longitude", String(params.longitude));
    }

    const response = await api.post(
      `/manage/dashboard/api-teacher-qr-attendance.php`,
      formData.toString(),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Failed to mark teacher QR attendance:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getTeacherQrAttendanceList = async (branchId: number, date?: string) => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append("branch_id", String(branchId));
    if (date) {
      queryParams.append("date", date);
    }

    const response = await api.get(
      `/manage/dashboard/api-teacher-qr-attendance-list.php?${queryParams.toString()}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch teacher QR attendance list:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getTeacherQrAttendanceStatus = async (branchId: number, teacherId: number, date?: string) => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append("branch_id", String(branchId));
    queryParams.append("teacher_id", String(teacherId));
    if (date) {
      queryParams.append("date", date);
    }

    const response = await api.get(
      `/manage/dashboard/api-teacher-qr-attendance-status.php?${queryParams.toString()}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch teacher QR attendance status:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export interface TeacherQrAttendanceTimeSettings {
  presentFromTime: string;
  lateAfterTime: string;
}

const DEFAULT_TEACHER_QR_ATTENDANCE_TIME_SETTINGS: TeacherQrAttendanceTimeSettings = {
  presentFromTime: "08:00",
  lateAfterTime: "09:15",
};

const normalizeTeacherQrAttendanceTimeSettings = (
  data: Partial<TeacherQrAttendanceTimeSettings> | null | undefined
): TeacherQrAttendanceTimeSettings => ({
  presentFromTime:
    data?.presentFromTime || DEFAULT_TEACHER_QR_ATTENDANCE_TIME_SETTINGS.presentFromTime,
  lateAfterTime:
    data?.lateAfterTime || DEFAULT_TEACHER_QR_ATTENDANCE_TIME_SETTINGS.lateAfterTime,
});

export const getTeacherQrAttendanceTimeSettings = async (branchId: number) => {
  try {
    const response = await api.get(
      `/manage/dashboard/api-teacher-qr-attendance-time-settings.php?branch_id=${branchId}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch teacher QR attendance time settings:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const saveTeacherQrAttendanceTimeSettings = async (
  branchId: number,
  settings: TeacherQrAttendanceTimeSettings
) => {
  try {
    const formData = new URLSearchParams();
    formData.append("branch_id", String(branchId));
    formData.append("present_from_time", settings.presentFromTime);
    formData.append("late_after_time", settings.lateAfterTime);

    const response = await api.post(
      `/manage/dashboard/api-teacher-qr-attendance-time-settings.php`,
      formData.toString(),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Failed to save teacher QR attendance time settings:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

const DEFAULT_TEACHER_QR_ATTENDANCE_LOCATION_SETTINGS: TeacherQrAttendanceLocationSettings = {
  branchId: 0,
  label: "School Entrance",
  latitude: 0,
  longitude: 0,
  radiusMeters: 100,
  enabled: false,
};

const normalizeTeacherQrAttendanceLocationSettings = (
  branchId: number,
  data: Partial<TeacherQrAttendanceLocationSettings> | Record<string, unknown> | null | undefined
): TeacherQrAttendanceLocationSettings => {
  const raw = (data ?? {}) as Record<string, unknown>;

  return {
    branchId,
    label: String(raw.label ?? DEFAULT_TEACHER_QR_ATTENDANCE_LOCATION_SETTINGS.label),
    latitude: Number(raw.latitude ?? 0),
    longitude: Number(raw.longitude ?? 0),
    radiusMeters: Number(
      raw.radiusMeters ?? raw.radius_meters ?? DEFAULT_TEACHER_QR_ATTENDANCE_LOCATION_SETTINGS.radiusMeters
    ),
    enabled: Boolean(raw.enabled ?? (Number(raw.latitude) && Number(raw.longitude))),
  };
};

export const getTeacherQrAttendanceLocationSettings = async (branchId: number) => {
  try {
    const response = await api.get(
      `/manage/dashboard/api-teacher-qr-attendance-location-settings.php?branch_id=${branchId}`
    );
    return response.data;
  } catch (error: any) {
    console.error(
      "Failed to fetch teacher QR attendance location settings:",
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

export const saveTeacherQrAttendanceLocationSettings = async (
  branchId: number,
  settings: Omit<TeacherQrAttendanceLocationSettings, "branchId">
) => {
  try {
    const formData = new URLSearchParams();
    formData.append("branch_id", String(branchId));
    formData.append("label", settings.label);
    formData.append("latitude", String(settings.latitude));
    formData.append("longitude", String(settings.longitude));
    formData.append("radius_meters", String(settings.radiusMeters));
    formData.append("enabled", settings.enabled ? "1" : "0");

    const response = await api.post(
      `/manage/dashboard/api-teacher-qr-attendance-location-settings.php`,
      formData.toString(),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error(
      "Failed to save teacher QR attendance location settings:",
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

export {
  DEFAULT_TEACHER_QR_ATTENDANCE_LOCATION_SETTINGS,
  DEFAULT_TEACHER_QR_ATTENDANCE_TIME_SETTINGS,
  normalizeTeacherQrAttendanceLocationSettings,
  normalizeTeacherQrAttendanceTimeSettings,
};

export const getTeacherQrAttendanceReport = async (params: {
  branchId: number;
  view: "day" | "month" | "year";
  date?: string;
  month?: string;
  year?: number;
  teacherId?: number;
}) => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append("branch_id", String(params.branchId));
    queryParams.append("view", params.view);

    if (params.teacherId) {
      queryParams.append("teacher_id", String(params.teacherId));
    }

    if (params.view === "day" && params.date) {
      queryParams.append("date", params.date);
    } else if (params.view === "month" && params.month) {
      queryParams.append("month", params.month);
    } else if (params.view === "year" && params.year) {
      queryParams.append("year", String(params.year));
    }

    const response = await api.get(
      `/manage/dashboard/api-teacher-qr-attendance-report.php?${queryParams.toString()}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch teacher QR attendance report:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};